webpackJsonp([88],{

/***/ "+J9x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"page-container"},[_vm._v("404 page not found")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1RNm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2+ao":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types_js__ = __webpack_require__("Qgp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__story___ = __webpack_require__("Zsfk");





/* harmony default export */ __webpack_exports__["a"] = ({

  /*  async getCartlist({
      commit,
      state
    }) {
      let res = await getData.shoppingCartNum();
      commit(types.SAVE_CARTLIST, res.shoppingCartNum)
    }*/
  saveListPagePars: function saveListPagePars(_ref, _ref2) {
    var commit = _ref.commit;
    var path = _ref2.path,
        pars = _ref2.pars;

    commit('SAVE_LIST_PAGE_PARS', { path: path, pars: pars });
  }

});

/***/ }),

/***/ "2ZEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("al2G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b28a024_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("ny8D");
function injectStyle (ssrContext) {
  __webpack_require__("Lul/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b28a024"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b28a024_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2mXc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "4bLx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7yzj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_craft_vue__ = __webpack_require__("tH33");

//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      craftLine: [{
        procedureType: 'flow',
        procedureName: '主流程',
        hash: 1539651058192,
        fixed: true,
        children: [{
          procedureType: 'semi',
          procedureName: '半成品',
          hash: 1539651058193,
          fixed: true,
          children: [{
            procedureType: 'process',
            procedureName: '自带工序',
            hash: 1539651058194,
            fixed: true
          }, {
            procedureType: 'process',
            procedureName: '自带工序2',
            hash: 1539651058195,
            fixed: true
          }]
        }]
      }],
      halfList: []
    };
  },

  computed: {},
  mounted: function mounted() {},

  components: {
    craft: __WEBPACK_IMPORTED_MODULE_1__components_craft_vue__["a" /* default */]
  },
  methods: {
    addBefore: function addBefore(item, next) {
      //console.log(item)
      // do something
      //item.dddd=111
      next(item);
    },
    add: function add() {
      this.$refs.craft.addresult({
        procedureType: 'process',
        procedureName: '自带工序',
        hash: 1539651058195
      });
    },
    getList: function getList(arr) {
      var _this = this;

      this.halfList = [];
      var arrs = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(arr));
      arrs.reverse();
      var start = null;
      var end = arrs.length;
      var halfList = [];
      for (var i = 0; i < arrs.length; i++) {
        if (arrs[i].hash == this.$store.state.selectHash) {
          start = i;
          console.log(start);
        } else if (arrs[i].procedureType == 'process' && start != null) {
          end = i;
          console.log(end);
          break;
        }
      }
      if (end - start > 1) {
        halfList = arrs.slice(start + 1, end);
        halfList.forEach(function (item) {
          if (item.procedureType == 'semi') {
            _this.halfList.push(item);
          } else {
            _this.getHalf(item.children);
          }
        });
      }
      console.log(this.halfList);
    },
    getHalf: function getHalf(arr) {
      var _this2 = this;

      arr.forEach(function (item) {
        if (item.procedureType == 'semi') {
          _this2.halfList.push(item);
        } else if (item.children && item.children.length > 0) {
          _this2.getHalf(item.children);
        }
      });
    }
  },
  watch: {}
});

/***/ }),

/***/ "CSg2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp-box flex-direction-box"},[_c('v-header'),_vm._v(" "),_c('div',{staticClass:"line-box"},[_c('div',{staticClass:"line-info"},[_c('div',{staticClass:"title shadow"},[_vm._v("班组员工生产安排列表")]),_vm._v(" "),_c('div',{staticClass:"info shadow"},[_c('div',{staticClass:"line-search"},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"tit"},[_vm._v("人员列表")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入内容"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}},[_c('template',{slot:"append"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search"}},[_vm._v("搜索")])],1)],2)],1),_vm._v(" "),_c('ul',{staticClass:"peoples",on:{"dragover":function($event){$event.stopPropagation();return _vm.handleDragOver.apply(null, arguments)}}},_vm._l((_vm.peoples),function(item,index){return _c('li',{key:index,staticClass:"people diy-prop-item",attrs:{"data-index":index}},[_c('div',{staticClass:"label",class:{odd:(index+1)%2}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"con"},_vm._l((item.nodes),function(node,index2){return _c('div',{staticClass:"node",class:node.type == 'drag'?'g-dashed':'',style:({width:((_vm.width(node.duration)) + "%"),left:((_vm.left(node.startTime)) + "%")}),attrs:{"draggable":"true","data-index":(index + "," + index2)},on:{"dragstart":function($event){$event.stopPropagation();return _vm.changeDragStart.apply(null, arguments)},"dragend":function($event){$event.stopPropagation();return _vm.changeDragEnd.apply(null, arguments)}}})}),0)])}),0)]),_vm._v(" "),_c('div',{staticClass:"line-tabel"},[_c('div',{staticClass:"tit"},[_vm._v("班组员工生产安排列表")]),_vm._v(" "),_c('div',{staticClass:"dates"},_vm._l((_vm.time),function(item){return _c('div',{staticClass:"date"},[_vm._v(_vm._s(item))])}),0),_vm._v(" "),_c('div',{staticClass:"times"},_vm._l((_vm.time),function(item){return _c('div',{staticClass:"date"},[_c('div',{staticClass:"time"},[_vm._v("08:00-12:00")]),_vm._v(" "),_c('div',{staticClass:"time"},[_vm._v("12:30-16:30")])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"line-bar"},[_c('div',{staticClass:"title shadow"},[_vm._v("订单任务列表")]),_vm._v(" "),_c('div',{staticClass:"info shadow"},[_c('div',{staticClass:"collapse"},[_c('el-collapse',{staticClass:"o-collapse",attrs:{"accordion":""}},_vm._l((_vm.orders),function(order,index){return _c('el-collapse-item',{key:index},[_c('template',{slot:"title"},[_vm._v("\n                "+_vm._s(order.name)+"\n              ")]),_vm._v(" "),_c('el-collapse',{staticClass:"p-collapse",attrs:{"accordion":""}},_vm._l((order.products),function(product,index2){return _c('el-collapse-item',{key:index2},[_c('template',{slot:"title"},[_vm._v("\n                    "+_vm._s(product.name)+"\n                  ")]),_vm._v(" "),_c('ul',{staticClass:"orders"},_vm._l((product.process),function(process,index3){return _c('li',{key:index3,attrs:{"draggable":"true"}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(process.label))]),_vm._v(" "),_c('div',{staticClass:"con"},[_vm._v(_vm._s(process.info))])])}),0)],2)}),1)],2)}),1)],1)])])]),_vm._v(" "),_c('el-dialog',{staticClass:"g-dialogs",attrs:{"title":"请确认","visible":_vm.dialogVisible,"width":"430px","center":"","show-close":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',[_c('el-form',{ref:"form",staticClass:"g-assigndialog",attrs:{"model":_vm.form,"label-width":"200px","size":"mini"}},[_c('el-form-item',{attrs:{"label":"变更员工："}},[_c('p',[_vm._v("员工A")])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"变更工序："}},[_c('p',[_vm._v("员工A")])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"变更数量："}},[_c('p',[_vm._v("员工A")])]),_vm._v(" "),_c('el-form-item',{staticClass:"g-form-item-input",attrs:{"label":"分配数量："}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"当前已完成任务量："}},[_c('p',[_vm._v("员工A")])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"变更后剩余完成任务量："}},[_c('p',[_vm._v("员工A")])]),_vm._v(" "),_c('el-form-item',{staticClass:"g-form-item-input",attrs:{"label":"任务开始时间："}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期时间"},model:{value:(_vm.form.startTime),callback:function ($$v) {_vm.$set(_vm.form, "startTime", $$v)},expression:"form.startTime"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"g-form-item-input",attrs:{"label":"任务截止时间："}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期时间"},model:{value:(_vm.form.endTime),callback:function ($$v) {_vm.$set(_vm.form, "endTime", $$v)},expression:"form.endTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"预计工时："}},[_c('p',[_vm._v("员工A")])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上步工序开始时间："}},[_c('p',[_vm._v("员工A")])])],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.submit}},[_vm._v("确 定")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cz8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("wqBJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afece0be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("j0zN");
function injectStyle (ssrContext) {
  __webpack_require__("XgGO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-afece0be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afece0be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Do2q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GMIA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__ = __webpack_require__("Qgp7");


var _types$SAVE_ORDERFLOW;



/* harmony default export */ __webpack_exports__["a"] = (_types$SAVE_ORDERFLOW = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_ORDERFLOW, __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__["c" /* SAVE_ORDERFLOWADD */], function (state, orderFlowInfo) {
  state.orderFlowInfo = orderFlowInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_ORDERFLOW, __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__["b" /* SAVE_ORDERFLOWACTIVE */], function (state, orderFlowInfoActive) {
  state.orderFlowInfoActive = orderFlowInfoActive;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_ORDERFLOW, __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__["d" /* SHOW_HOUSE_INFO */], function (state, company) {
  state.houseDialog = !state.houseDialog;
  if (company) {
    state.finalState = company.colorType;
    state.houseResId = company.houseResId;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_ORDERFLOW, __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__["a" /* SAVE_LIST_PAGE_PARS */], function (state, _ref) {
  var path = _ref.path,
      pars = _ref.pars;

  state.listPagePars.set(path, pars);
}), _types$SAVE_ORDERFLOW);

/***/ }),

/***/ "L8Y5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("dYVh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db5ab74e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("w/eq");
function injectStyle (ssrContext) {
  __webpack_require__("f3nc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db5ab74e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lul/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M7eE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.J_options = {
  //使用状态
  useState: [{ label: '使用中', value: 1 }, { label: '已冻结', value: 2 }],
  //部门
  departments: [{ label: '研发部', value: 1 }, { label: '生产部', value: 2 }, { label: '质量部', value: 3 }, { label: '仓库部', value: 4 }],
  //维修原因
  repairReason: [{ label: '操作失误', value: 1 }, { label: '例行保养', value: 2 }, { label: '检点不到位', value: 3 }, { label: '正常配件更换', value: 4 }, { label: '其他', value: 4 }],
  //维修原因
  repairReason2: [{ label: '操作问题', value: 1 }, { label: '点检不到位', value: 3 }, { label: '其他', value: 5 }, { label: '机械故障', value: 6 }, { label: '电路故障', value: 7 }],
  //设备启用状态
  equipmentState: [{ label: '已启用', value: 1 }, { label: '委外维修中', value: 2 }, { label: '维修中', value: 3 }],
  //模具工装类型
  mouldType: [
  // { label: '拉伸-凸模', value: 1},
  // { label: '拉伸-凹模', value: 2},
  // { label: '拉伸-切边模', value: 3},
  // { label: '拉伸-翻边模', value: 4},
  // { label: '冲压-落料', value: 5},
  // { label: '冲压-冲孔', value: 6},
  // { label: '冲压-成型', value: 7},
  // { label: '冲压-整形', value: 8},
  { label: '拉伸模一', value: 1 }, { label: '拉伸模二', value: 2 }, { label: '拉伸模三', value: 3 }, { label: '拉伸模四', value: 4 }, { label: '拉伸模五', value: 5 }, { label: '冲压模 落料', value: 6 }, { label: '冲压模 冲孔', value: 7 }, { label: '冲压模 成型', value: 8 }, { label: '冲压模 整型', value: 9 }, { label: '翻边模', value: 10 }, { label: '车边工装', value: 11 }, { label: '抛边工装', value: 12 }, { label: '焊接工装', value: 13 }, { label: '钻孔工装', value: 14 }],
  //通知记录类型
  messageType: [{ label: '质检通知', value: 1 }, { label: '财务通过(仓库)', value: 2 }, { label: '生产延期通知', value: 3 }, { label: '主管审核', value: 4 }, { label: '采购需求', value: 5 }, { label: '财务审核', value: 6 }, { label: '财务到期', value: 7 }, { label: '财务通过', value: 8 }, { label: '产品提交入库', value: 9 }, { label: '产品报修', value: 10 }, { label: '物料预警', value: 11 }],
  //产品类型
  productType: [{ label: '成品', value: 1 }, { label: '半成品', value: 2 }],
  //产品状态
  productState: [{ label: '发布', value: 1 }, { label: '未发布', value: 2 }],
  //关注点标准类型
  pointsType: [{ label: '>', value: 1 }, { label: '<', value: 2 }, { label: '范围', value: 3 }, { label: '+-', value: 4 }, { label: '人工判断', value: 5 }],
  //订单类型
  orderType: [{ label: '国内订单', value: 1 }, { label: '国外订单', value: 2 }],
  //订单类型
  clientType: [{ label: '国内客户', value: 1 }, { label: '国外客户', value: 2 }],
  //结算方式
  payType: [{ label: '付清发货', value: 1 }, { label: '货到付款', value: 2 }],
  //包装方式
  packagingType: [{ label: '无', value: 1 }, { label: '纸箱', value: 2 }, { label: '托盘', value: 3 }, { label: '纸箱+托盘', value: 4 }, { label: '其它', value: 5 }],
  // 订单是否为特殊订单
  ordersIsSpecial: [{ label: '特殊订单', value: 1 }, { label: '普通订单', value: 0 }],
  //事件类型
  planType: [{ label: '指定日期', value: 2 }, { label: '月结', value: 3 }, { label: '开票后', value: 4 }]

  //订单类型
};__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('orderType', function (val) {
  switch (val) {
    case 1:
      return '国内订单';
    case 2:
      return '国外订单';
    case 3:
      return '子订单';
    default:
      return val;
  }
});

//客户类型
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('clientType', function (val) {
  switch (val) {
    case 1:
      return '国内客户';
    case 2:
      return '国外客户';
    default:
      return val;
  }
});

//订单类型
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('ordersIsSpecial', function (val) {
  switch (val) {
    case 1:
      return '特殊订单';
    case 0:
      return '普通订单';
    default:
      return val;
  }
});

//结算方式
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('payType', function (val) {
  switch (val) {
    case 1:
      return '付清发货';
    case 2:
      return '货到付款';
    default:
      return val;
  }
});

//包装方式
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('packagingType', function (val) {
  switch (val) {
    case 1:
      return '无';
    case 2:
      return '纸箱';
    case 3:
      return '托盘';
    case 4:
      return '纸箱+托盘';
    case 5:
      return '其它';
    default:
      return val;
  }
});
//订单审核状态类型
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('orderAuditType', function (val) {
  switch (val) {
    case '1':
      return '待审核';
    case '2':
      return '已审核';
    case '3':
      return '已取消';
    default:
      return val;
  }
});

//质检类别
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('qualityTest', function (val) {
  switch (val) {
    case 1:
      return '首检';
    case 2:
      return '巡检';
    case 3:
      return '末检';
    case 4:
      return '中检/成品检验';
    case 5:
      return '采购物料检验';
    case 6:
      return '委外产品检验';
    default:
      return val;
  }
});

//使用状态（1使用中 2已冻结 0删除）
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('useState', function (val) {
  switch (val) {
    case 1:
      return '使用中';
    case 2:
      return '已冻结';
    case 0:
      return '已删除';
    default:
      return val;
  }
});

//部门（1研发部 2生产部 3质量部 4 仓库部）
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('departments', function (val) {
  switch (val) {
    case 1:
      return '研发部';
    case 2:
      return '生产部';
    case 3:
      return '质量部';
    case 4:
      return '仓库部';
    default:
      return val;
  }
});

//设备启用状态(1/已启用 2/委外维修中 3/维修中)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('equipmentState', function (val) {
  switch (val) {
    case 1:
      return '已启用';
    case 2:
      return '委外维修中';
    case 3:
      return '维修中';
    default:
      return '已报废';
  }
});

//故障原因（1 操作失误 2例行保养 3检点不到位 4正常配件更换 5其他）
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('repairReason', function (val) {
  switch (val) {
    case 1:
      return '操作失误';
    case 2:
      return '例行保养';
    case 3:
      return '检点不到位';
    case 4:
      return '正常配件更换';
    case 5:
      return '其他';
    default:
      return val;
  }
});

//维修结果（1/成功 2/报废）
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('repairResult', function (val) {
  switch (val) {
    case 1:
      return '成功';
    case 2:
      return '报废';
    default:
      return val;
  }
});

//模具工装类型(1拉伸-凸模，2拉伸-凹模，3拉伸-切边模，4拉伸-翻边模，5冲压-落料，6冲压-冲孔，7冲压-成型，8冲压-整形)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('mouldType', function (val) {
  switch (val) {
    // case 1:
    //   return '拉伸-凸模';
    // case 2:
    //   return '拉伸-凹模';
    // case 3:
    //   return '拉伸-切边模';
    // case 4:
    //   return '拉伸-翻边模';
    // case 5:
    //   return '冲压-落料';
    // case 6:
    //   return '冲压-冲孔';
    // case 7:
    //   return '冲压-成型';
    // case 8:
    //   return '冲压-整形';
    case 1:
      return '拉伸模一';
    case 2:
      return '拉伸模二';
    case 3:
      return '拉伸模三';
    case 4:
      return '拉伸模四';
    case 5:
      return '拉伸模五';
    case 6:
      return '冲压模 落料';
    case 7:
      return '冲压模 冲孔';
    case 8:
      return '冲压模 成型';
    case 9:
      return '冲压模 整型';
    case 10:
      return '翻边模';
    case 11:
      return '车边工装';
    case 12:
      return '抛边工装';
    case 13:
      return '焊接工装';
    case 14:
      return '钻孔工装';
    default:
      return val;
  }
});

//通知类型
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('messageType', function (val) {
  switch (val) {
    case 1:
      return '质检通知';
    case 2:
      return '财务通过(仓库)';
    case 3:
      return '生产延期通知';
    case 4:
      return '主管审核';
    case 5:
      return '采购需求';
    case 6:
      return '财务审核';
    case 7:
      return '财务到期';
    case 8:
      return '财务通过';
    case 9:
      return '产品提交入库';
    case 10:
      return '产品报修';
    case 11:
      return '物料预警';
    default:
      return val;
  }
});

//产品类型（1/成品 2/半成品）
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('productType', function (val) {
  switch (val) {
    case 1:
      return '成品';
    case 2:
      return '半成品';
    default:
      return val;
  }
});

//产品状态（1/发布 2/未发布)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('productState', function (val) {
  switch (val) {
    case 1:
      return '已发布';
    case 2:
      return '未发布';
    default:
      return val;
  }
});

//订单类型1/国内 2/国外 3/子订单)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('ordersType', function (val) {
  switch (val) {
    case 1:
      return '国内订单';
    case 2:
      return '国外订单';
    case 3:
      return '子订单';
    default:
      return val;
  }
});

//状态1/已逾期 2/未逾期)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('outStatus', function (val) {
  switch (val) {
    case 1:
      return '已逾期';
    case 0:
      return '未逾期';
    default:
      return val;
  }
});

//收款类型1预付款 2尾款)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('ordersPaymentPlanName', function (val) {
  switch (val) {
    case 1:
      return '预付款';
    case 2:
      return '尾款';
    case 3:
      return '尾款';
    default:
      return val;
  }
});

//采购状态(1采购中2已完成3已入库)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('procurementPlanState', function (val) {
  switch (val) {
    case 1:
      return '采购中';
    case 2:
      return '已完成';
    case 3:
      return '已入库';
    default:
      return val;
  }
});

//货架类型(1/大 2/中 3/小)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('storageRackType', function (val) {
  switch (val) {
    case 1:
      return '大';
    case 2:
      return '中';
    case 3:
      return '小';
    default:
      return val;
  }
});

//货架存入类型（1采购入库  2生产入库  3特殊入库）
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('storageDepositRecordType', function (val) {
  switch (val) {
    case 1:
      return '采购入库';
    case 2:
      return '生产入库';
    case 3:
      return '特殊入库';
    default:
      return val;
  }
});

//货架取用类型(1/生产领料  2/订单发货  3特殊出库)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('storageTakeRecordType', function (val) {
  switch (val) {
    case 1:
      return '生产领料';
    case 2:
      return '订单发货';
    case 3:
      return '特殊出库';
    default:
      return val;
  }
});

// 1 已审核 0未审核
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('stocktakesState', function (val) {
  switch (val) {
    case 0:
      return '未审核';
    case 1:
      return '已审核';
    case 3:
      return '已通过';
    case 4:
      return '已驳回';
    default:
      return val;
  }
});

// 	区域类型（”货架管理”, 0), (“工位管理”, 1）
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('areaType', function (val) {
  switch (val) {
    case 0:
      return '货架管理';
    case 1:
      return '工位管理';
    default:
      return val;
  }
});

//任务状态（1盘库中 2审核中 3已完成 4已驳回 0/删除标志）
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('stocktakesState', function (val) {
  switch (val) {
    case 1:
      return '盘库中';
    case 2:
      return '审核中';
    case 3:
      return '已完成';
    case 4:
      return '已驳回';
    default:
      return val;
  }
});

//类型 1/成品 2/半成品生产）
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('productType', function (val) {
  switch (val) {
    case 1:
      return '成品';
    case 2:
      return '半成品';
    default:
      return val;
  }
});
//类型 1/成品 2/半成品生产）
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('productionType', function (val) {
  switch (val) {
    case 1:
      return '成品';
    case 2:
      return '半成品';
    default:
      return val;
  }
});

//生产任务状态(1生产中2已完成3已入库)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('productionPlanState', function (val) {
  switch (val) {
    case 1:
      return '生产中';
    case 2:
      return '已完成';
    case 3:
      return '已入库';
    default:
      return val;
  }
});

////备货状态 (1 待备货 2 备货中 3备货完成)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('productionOutState', function (val) {
  switch (val) {
    case 1:
      return '待备货';
    case 2:
      return '正在备货';
    case 3:
      return '已备货';
    default:
      return val;
  }
});

////// 物料类型1 原料 2半成品
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('goodsType', function (val) {
  switch (val) {
    case 1:
      return '原材料';
    case 2:
      return '半成品';
    default:
      return val;
  }
});

////// 出入库记录物料类型
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('recordGoodsType', function (val) {
  switch (val) {
    case 1:
      return '产品';
    case 2:
      return '半成品';
    case 3:
      return '原料';
    case 4:
      return '模具工装';
    default:
      return val;
  }
});

//产品:（1/成品  2/半成品
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('thingType1', function (val) {
  switch (val) {
    case 1:
      return '成品';
    case 2:
      return '半成品';
    default:
      return val;
  }
});

//是否入库:（1/是  2/否
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('yesNo', function (val) {
  switch (val) {
    case 1:
      return '是';
    case 0:
      return '否';
    default:
      return val;
  }
});

//模具工装:(1拉伸-凸模，2拉伸-凹模，3拉伸-切边模，4拉伸-翻边模，5冲压-落料，6冲压-冲孔，7冲压-成型，8冲压-整形)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('thingType2', function (val) {
  switch (val) {
    case 1:
      return '拉伸-凸模';
    case 2:
      return '拉伸-凹模';
    case 3:
      return '拉伸-切边模';
    case 4:
      return '拉伸-翻边模';
    case 5:
      return '冲压-落料';
    case 6:
      return '冲压-冲孔';
    case 7:
      return '冲压-成型';
    case 8:
      return '冲压-整形';
    default:
      return val;
  }
});

//状态(1未开始2等待首检3首检完成,待开始4,进行中5待末检6已完成7暂停)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('productionAdminState', function (val) {
  switch (val) {
    case 1:
      return '未开始';
    case 2:
      return '等待首检';
    case 3:
      return '待开始';
    case 4:
      return '进行中';
    case 5:
      return '待末检';
    case 6:
      return '已完成';
    case 7:
      return '暂停';
    default:
      return val;
  }
});

//订单状态(1未开始2等待首检3首检完成,待开始4,进行中5待末检6已完成7暂停)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('orderState', function (val) {
  switch (val) {
    case '1':
      return '未审核';
    case '2':
      return '审核中';
    case '3':
      return '跟进中';
    case '4':
      return '已完成';
    case '5':
      return '坏账';
    default:
      return val;
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51b2c5c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("UhAd");
function injectStyle (ssrContext) {
  __webpack_require__("QMUp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51b2c5c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__story___ = __webpack_require__("Zsfk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components___ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__service_getData_js__ = __webpack_require__("i84Q");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a);




__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__components___["a" /* default */]).forEach(function (key) {
  var name = key.replace(/(\w)/, function (v) {
    return v.toUpperCase();
  }); // 首字母大写
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('v' + name, __WEBPACK_IMPORTED_MODULE_6__components___["a" /* default */][key]);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$checkPermissions = function (val) {
  if (!sessionStorage['permissions']) return false;
  return JSON.parse(sessionStorage['permissions']).indexOf(val) > -1;
};

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  var user = sessionStorage.getItem('user');
  var path = to.path;
  // console.log(!user && path != '/login')
  if (path != '/login') {
    __WEBPACK_IMPORTED_MODULE_7__service_getData_js__["checkLogin"]().then(function (res) {
      if (res.data.code != '1') {
        next({ path: '/login' });
        sessionStorage.removeItem('user');
        return;
      }
      sessionStorage.setItem('user', 'success');
      next();
    });
    return;
  }
  next();
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_4__story___["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]);
  },
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NWCo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flow_vue__ = __webpack_require__("irzW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c27e2318_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_flow_vue__ = __webpack_require__("Wvau");
function injectStyle (ssrContext) {
  __webpack_require__("pYs9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c27e2318_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_flow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QMUp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qgp7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAVE_ORDERFLOWADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SAVE_ORDERFLOWACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHOW_HOUSE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SAVE_LIST_PAGE_PARS; });
var SAVE_ORDERFLOWADD = 'SAVE_ORDERFLOWADD';
var SAVE_ORDERFLOWACTIVE = 'SAVE_ORDERFLOWACTIVE';
var SHOW_HOUSE_INFO = 'SHOW_HOUSE_INFO';
var SAVE_LIST_PAGE_PARS = 'SAVE_LIST_PAGE_PARS';

/***/ }),

/***/ "RSuO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_mUtils__ = __webpack_require__("yclV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      url: '',
      query: '',
      netaddress: '',
      isCollapse: false,
      sideList: [{
        path: '/index',
        name: '系统操作面板',
        hidden: false,
        leaf: true,
        icon: 'icon-52', //图标样式class
        children: [{ path: "/mediaSystem/systemIndex", name: '系统操作面板' }],
        permission: "index_module"
      }]
    };
  },

  // props: ['number', 'type', 'size', 'list'],
  created: function created() {},
  mounted: function mounted() {},

  computed: {},
  methods: {
    shows: function shows() {}
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "THLI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp-box flex-direction-box"},[_c('v-header'),_vm._v(" "),_c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.add}},[_vm._v("add")])],1),_vm._v(" "),_c('craft',{ref:"craft",attrs:{"craft-line":_vm.craftLine,"add-before":_vm.addBefore},on:{"get-list":_vm.getList}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UhAd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VuGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"craft-box"},[(!_vm.notEdit)?_c('div',{staticClass:"addbtns"},[_c('el-button',{staticClass:"flex-box",attrs:{"type":"warning","plain":""},on:{"click":function($event){return _vm.adds(_vm.items[0])}}},[_vm._v("添加主流程"),_c('i',{staticClass:"el-icon--right el-icon-circle-plus-outline"})]),_vm._v(" "),_c('el-button',{staticClass:"flex-box",attrs:{"type":"success","plain":""},on:{"click":function($event){return _vm.adds(_vm.items[1])}}},[_vm._v("添加半成品"),_c('i',{staticClass:"el-icon--right el-icon-circle-plus-outline"})]),_vm._v(" "),_c('el-button',{staticClass:"flex-box",attrs:{"type":"primary","plain":""},on:{"click":function($event){return _vm.adds(_vm.items[2])}}},[_vm._v("添加工序"),_c('i',{staticClass:"el-icon--right el-icon-circle-plus-outline"})])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex-box flex-center"},[(_vm.craftLineCopy.length)?_c('ul',{staticClass:"craft-info flex-box",on:{"dragover":function($event){$event.stopPropagation();return _vm.handleDragOver.apply(null, arguments)},"drop":function($event){$event.stopPropagation();return _vm.handleDrag.apply(null, arguments)}}},_vm._l((_vm.craftLineCopy),function(model,index){return _c('items',{key:index,attrs:{"model":model,"item-height":_vm.itemHeight,"edit-procedure":_vm.editProcedure}})}),1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wvau":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"item"},[(_vm.model.procedureType === 'process')?_c('div',{staticClass:"item-info",class:[_vm.model.procedureType,{border:_vm.$store.state.selectHash==_vm.model.hash},_vm.$store.state.activeHash==_vm.model.hash?_vm.$store.state.activeDirection:'',{disabled:_vm.$store.state.startHash==_vm.model.hash},{fixed:_vm.model.fixed}],style:({height: _vm.itemHeight+'px'}),attrs:{"draggable":!_vm.model.fixed,"data-hash":_vm.model.hash},on:{"dragstart":function($event){$event.stopPropagation();return _vm.changeDragStart.apply(null, arguments)},"dragend":function($event){$event.stopPropagation();return _vm.changeDragEnd.apply(null, arguments)},"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.select(_vm.model)}}},[(!_vm.model.fixed)?_c('div',{staticClass:"j-delete"},[_c('i',{staticClass:"el-icon-remove-outline",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.del(_vm.model.hash)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v("\n      "+_vm._s(_vm.model.procedureName)+"\n    ")]),_vm._v(" "),(_vm.editProcedure && _vm.directlyProcess)?_c('div',{staticClass:"item-edit-icon el-icon-edit",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.select2(_vm.model)}}}):_vm._e()]):(_vm.model.procedureType === 'semi')?_c('div',{staticClass:"item-info",class:[_vm.model.procedureType,{border:_vm.$store.state.selectHash==_vm.model.hash},_vm.$store.state.activeHash==_vm.model.hash?_vm.$store.state.activeDirection:'',{disabled:_vm.$store.state.startHash==_vm.model.hash},{fixed:_vm.model.fixed}],attrs:{"draggable":!_vm.model.fixed,"data-hash":_vm.model.hash},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.select(_vm.model)},"dragstart":function($event){$event.stopPropagation();return _vm.changeDragStart.apply(null, arguments)},"dragend":function($event){$event.stopPropagation();return _vm.changeDragEnd.apply(null, arguments)}}},[_c('div',{staticClass:"info"},[_vm._v("\n      "+_vm._s(_vm.model.procedureName || '工序')),(_vm.model.procedureQuantity&&_vm.model.procedureQuantity>1)?_c('span',[_vm._v("*"+_vm._s(_vm.model.procedureQuantity))]):_vm._e(),_vm._v(" "),(_vm.totalNum>0)?_c('div',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.isShow = !_vm.isShow;}}},[_c('i',{class:_vm.isShow?'el-icon-caret-bottom':'el-icon-caret-top'}),_vm._v(_vm._s(_vm.totalNum)+"道工序\n      ")]):_vm._e(),_vm._v(" "),(!_vm.model.fixed)?_c('div',{staticClass:"j-delete"},[_c('i',{staticClass:"el-icon-remove-outline",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.del(_vm.model.hash)}}})]):_vm._e()])]):_c('div',{staticClass:"item-info",class:[_vm.model.procedureType,{border:_vm.$store.state.selectHash==_vm.model.hash},_vm.$store.state.activeHash==_vm.model.hash?_vm.$store.state.activeDirection:'',{disabled:_vm.$store.state.startHash==_vm.model.hash},{fixed:_vm.model.fixed}],attrs:{"draggable":!_vm.model.fixed,"data-hash":_vm.model.hash},on:{"dragstart":function($event){$event.stopPropagation();return _vm.changeDragStart.apply(null, arguments)},"dragend":function($event){$event.stopPropagation();return _vm.changeDragEnd.apply(null, arguments)},"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.select(_vm.model)}}},[_c('div',{staticClass:"info"},[_vm._v("\n      "+_vm._s(_vm.model.procedureName)+"\n      "),(_vm.totalNum>0)?_c('div',[_vm._v(_vm._s(_vm.totalNum)+"道工序")]):_vm._e(),_vm._v(" "),(!_vm.model.fixed)?_c('div',{staticClass:"j-delete"},[_c('i',{staticClass:"el-icon-remove-outline",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.del(_vm.model.hash)}}})]):_vm._e()])]),_vm._v(" "),(_vm.model.children&&_vm.model.children.length>0)?_c('ul',{class:{isShow:!_vm.isShow}},_vm._l((_vm.model.children),function(cel,index){return _c('items',{key:index,attrs:{"model":cel,"item-height":_vm.itemHeight,"editProcedure":_vm.editProcedure,"directlyProcess":_vm.model.procedureType == 'flow' && cel.procedureType == 'process'}})}),1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XgGO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_options__ = __webpack_require__("M7eE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_index__ = __webpack_require__("L8Y5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_404__ = __webpack_require__("jEQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_login__ = __webpack_require__("2ZEU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_timeLine_vue__ = __webpack_require__("a4ob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_craftLine_vue__ = __webpack_require__("qRls");










var homePage = function homePage(r) {
  return __webpack_require__.e/* require.ensure */(9).then((function () {
    return r(__webpack_require__("14TJ"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

//基础数据管理
var customerManagement = function customerManagement(r) {
  return __webpack_require__.e/* require.ensure */(62).then((function () {
    return r(__webpack_require__("2HOv"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var customerAdd = function customerAdd(r) {
  return __webpack_require__.e/* require.ensure */(59).then((function () {
    return r(__webpack_require__("cleI"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var customerEdit = function customerEdit(r) {
  return __webpack_require__.e/* require.ensure */(50).then((function () {
    return r(__webpack_require__("iNfm"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var groupManagement = function groupManagement(r) {
  return __webpack_require__.e/* require.ensure */(52).then((function () {
    return r(__webpack_require__("uYJf"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var groupAdd = function groupAdd(r) {
  return __webpack_require__.e/* require.ensure */(55).then((function () {
    return r(__webpack_require__("QWnT"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var groupEdit = function groupEdit(r) {
  return __webpack_require__.e/* require.ensure */(47).then((function () {
    return r(__webpack_require__("Uu2z"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var materialManagement = function materialManagement(r) {
  return __webpack_require__.e/* require.ensure */(54).then((function () {
    return r(__webpack_require__("Z0c6"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var materialAdd = function materialAdd(r) {
  return __webpack_require__.e/* require.ensure */(57).then((function () {
    return r(__webpack_require__("FDN+"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var materialEdit = function materialEdit(r) {
  return __webpack_require__.e/* require.ensure */(48).then((function () {
    return r(__webpack_require__("GPl0"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var supplierManagement = function supplierManagement(r) {
  return __webpack_require__.e/* require.ensure */(63).then((function () {
    return r(__webpack_require__("V/vX"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var supplierAdd = function supplierAdd(r) {
  return __webpack_require__.e/* require.ensure */(60).then((function () {
    return r(__webpack_require__("Medc"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var supplierEdit = function supplierEdit(r) {
  return __webpack_require__.e/* require.ensure */(51).then((function () {
    return r(__webpack_require__("nvOq"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var deviceManagement = function deviceManagement(r) {
  return __webpack_require__.e/* require.ensure */(45).then((function () {
    return r(__webpack_require__("CFmW"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var deviceAdd = function deviceAdd(r) {
  return __webpack_require__.e/* require.ensure */(56).then((function () {
    return r(__webpack_require__("AJ3O"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var deviceEdit = function deviceEdit(r) {
  return __webpack_require__.e/* require.ensure */(46).then((function () {
    return r(__webpack_require__("I6y5"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var mouldManagement = function mouldManagement(r) {
  return __webpack_require__.e/* require.ensure */(8).then((function () {
    return r(__webpack_require__("gYbB"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var mouldAdd = function mouldAdd(r) {
  return __webpack_require__.e/* require.ensure */(5).then((function () {
    return r(__webpack_require__("UcB+"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var mouldType = function mouldType(r) {
  return __webpack_require__.e/* require.ensure */(53).then((function () {
    return r(__webpack_require__("v9EN"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var mouldEdit = function mouldEdit(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__("8nIS"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var positionManagement = function positionManagement(r) {
  return __webpack_require__.e/* require.ensure */(61).then((function () {
    return r(__webpack_require__("/X/2"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var positionAdd = function positionAdd(r) {
  return __webpack_require__.e/* require.ensure */(58).then((function () {
    return r(__webpack_require__("1uxj"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var positionEdit = function positionEdit(r) {
  return __webpack_require__.e/* require.ensure */(49).then((function () {
    return r(__webpack_require__("QUNl"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var notificationManagement = function notificationManagement(r) {
  return __webpack_require__.e/* require.ensure */(44).then((function () {
    return r(__webpack_require__("R3iH"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var noticeRecord = function noticeRecord(r) {
  return __webpack_require__.e/* require.ensure */(43).then((function () {
    return r(__webpack_require__("aivL"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// const creationList = r => require.ensure([], () => r(require('@/view/基础数据管理/生产物管理.vue')), 'creationList');

//订单管理
var orderList = function orderList(r) {
  return __webpack_require__.e/* require.ensure */(27).then((function () {
    return r(__webpack_require__("PrO5"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var orderAdd = function orderAdd(r) {
  return __webpack_require__.e/* require.ensure */(12).then((function () {
    return r(__webpack_require__("bqt8"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var orderEdit = function orderEdit(r) {
  return __webpack_require__.e/* require.ensure */(10).then((function () {
    return r(__webpack_require__("DFHi"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var orderSplit = function orderSplit(r) {
  return __webpack_require__.e/* require.ensure */(11).then((function () {
    return r(__webpack_require__("vcgT"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var orderAudit = function orderAudit(r) {
  return __webpack_require__.e/* require.ensure */(26).then((function () {
    return r(__webpack_require__("zYeD"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var orderRecord = function orderRecord(r) {
  return __webpack_require__.e/* require.ensure */(28).then((function () {
    return r(__webpack_require__("dyUY"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

//采购管理
var purchaseList = function purchaseList(r) {
  return __webpack_require__.e/* require.ensure */(14).then((function () {
    return r(__webpack_require__("A/uX"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var changePrice = function changePrice(r) {
  return __webpack_require__.e/* require.ensure */(15).then((function () {
    return r(__webpack_require__("ZzEm"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

//产品及工艺管理
var productList = function productList(r) {
  return __webpack_require__.e/* require.ensure */(85).then((function () {
    return r(__webpack_require__("6eGY"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var productAdd = function productAdd(r) {
  return __webpack_require__.e/* require.ensure */(83).then((function () {
    return r(__webpack_require__("2bmI"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var productEdit = function productEdit(r) {
  return __webpack_require__.e/* require.ensure */(77).then((function () {
    return r(__webpack_require__("nE6/"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var productMaintenance = function productMaintenance(r) {
  return __webpack_require__.e/* require.ensure */(84).then((function () {
    return r(__webpack_require__("jogC"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var routeDetail = function routeDetail(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__("/Kku"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var routeAdd = function routeAdd(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__("J8zm"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var routeEdit = function routeEdit(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__("WzjW"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var categoryManagement = function categoryManagement(r) {
  return __webpack_require__.e/* require.ensure */(81).then((function () {
    return r(__webpack_require__("qt4I"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var categoryAdd = function categoryAdd(r) {
  return __webpack_require__.e/* require.ensure */(80).then((function () {
    return r(__webpack_require__("/CYi"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var categoryEdit = function categoryEdit(r) {
  return __webpack_require__.e/* require.ensure */(78).then((function () {
    return r(__webpack_require__("Obfv"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var badRecordList = function badRecordList(r) {
  return __webpack_require__.e/* require.ensure */(86).then((function () {
    return r(__webpack_require__("uLfV"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var badRecordDetail = function badRecordDetail(r) {
  return __webpack_require__.e/* require.ensure */(79).then((function () {
    return r(__webpack_require__("vfPA"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var processTime = function processTime(r) {
  return __webpack_require__.e/* require.ensure */(82).then((function () {
    return r(__webpack_require__("jSrC"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var processTimeEdit = function processTimeEdit(r) {
  return __webpack_require__.e/* require.ensure */(6).then((function () {
    return r(__webpack_require__("d2On"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

//生产任务管理
var productionDemandList = function productionDemandList(r) {
  return __webpack_require__.e/* require.ensure */(36).then((function () {
    return r(__webpack_require__("2GbZ"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var orderSchedulingManagement = function orderSchedulingManagement(r) {
  return __webpack_require__.e/* require.ensure */(7).then((function () {
    return r(__webpack_require__("aNNs"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var productionTaskRelease = function productionTaskRelease(r) {
  return __webpack_require__.e/* require.ensure */(13).then((function () {
    return r(__webpack_require__("KwEH"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var productionTaskReleaseCopy = function productionTaskReleaseCopy(r) {
  return __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
    return r(__webpack_require__("Hln4"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var productionDemandAdd = function productionDemandAdd(r) {
  return __webpack_require__.e/* require.ensure */(40).then((function () {
    return r(__webpack_require__("L2p3"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var mouldtoolsTaskRelease = function mouldtoolsTaskRelease(r) {
  return __webpack_require__.e/* require.ensure */(35).then((function () {
    return r(__webpack_require__("cfv/"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var mouldtoolsTaskAdd = function mouldtoolsTaskAdd(r) {
  return __webpack_require__.e/* require.ensure */(42).then((function () {
    return r(__webpack_require__("Y9Lj"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var productionTaskStatistics = function productionTaskStatistics(r) {
  return __webpack_require__.e/* require.ensure */(39).then((function () {
    return r(__webpack_require__("1jU1"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var productiontest = function productiontest(r) {
  return __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
    return r(__webpack_require__("Hln4"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var productionDemandLogList = function productionDemandLogList(r) {
  return __webpack_require__.e/* require.ensure */(37).then((function () {
    return r(__webpack_require__("p2yl"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var creationAdminList = function creationAdminList(r) {
  return __webpack_require__.e/* require.ensure */(38).then((function () {
    return r(__webpack_require__("YlQU"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var wageStatistics = function wageStatistics(r) {
  return __webpack_require__.e/* require.ensure */(41).then((function () {
    return r(__webpack_require__("Rjbs"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

//质检管理
var inspectorList = function inspectorList(r) {
  return __webpack_require__.e/* require.ensure */(19).then((function () {
    return r(__webpack_require__("Swf0"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var inspectionManagement = function inspectionManagement(r) {
  return __webpack_require__.e/* require.ensure */(16).then((function () {
    return r(__webpack_require__("N8NM"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var inspectionPlanList = function inspectionPlanList(r) {
  return __webpack_require__.e/* require.ensure */(17).then((function () {
    return r(__webpack_require__("knmH"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var configurationAuthority = function configurationAuthority(r) {
  return __webpack_require__.e/* require.ensure */(18).then((function () {
    return r(__webpack_require__("GxHb"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var inspectionPlanAdd = function inspectionPlanAdd(r) {
  return __webpack_require__.e/* require.ensure */(21).then((function () {
    return r(__webpack_require__("7APy"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var inspectionPlanEdit = function inspectionPlanEdit(r) {
  return __webpack_require__.e/* require.ensure */(20).then((function () {
    return r(__webpack_require__("Xol8"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

//仓库管理
var purchaseAndStorage = function purchaseAndStorage(r) {
  return __webpack_require__.e/* require.ensure */(64).then((function () {
    return r(__webpack_require__("Xr/x"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var productionWarehousing = function productionWarehousing(r) {
  return __webpack_require__.e/* require.ensure */(70).then((function () {
    return r(__webpack_require__("y06G"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var deliveryAndOutgoing = function deliveryAndOutgoing(r) {
  return __webpack_require__.e/* require.ensure */(75).then((function () {
    return r(__webpack_require__("Q2QQ"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var productionMaterial = function productionMaterial(r) {
  return __webpack_require__.e/* require.ensure */(69).then((function () {
    return r(__webpack_require__("gMAZ"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var materialInventory = function materialInventory(r) {
  return __webpack_require__.e/* require.ensure */(71).then((function () {
    return r(__webpack_require__("Aazp"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var shelfManagement = function shelfManagement(r) {
  return __webpack_require__.e/* require.ensure */(65).then((function () {
    return r(__webpack_require__("SMfb"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var regionalManagement = function regionalManagement(r) {
  return __webpack_require__.e/* require.ensure */(76).then((function () {
    return r(__webpack_require__("+2kK"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var inventoryManagement = function inventoryManagement(r) {
  return __webpack_require__.e/* require.ensure */(68).then((function () {
    return r(__webpack_require__("yCvQ"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var shelvesAdd = function shelvesAdd(r) {
  return __webpack_require__.e/* require.ensure */(72).then((function () {
    return r(__webpack_require__("tf8H"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var areaAdd = function areaAdd(r) {
  return __webpack_require__.e/* require.ensure */(74).then((function () {
    return r(__webpack_require__("AJn4"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var libraryAdd = function libraryAdd(r) {
  return __webpack_require__.e/* require.ensure */(73).then((function () {
    return r(__webpack_require__("qB21"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var shelvesEdit = function shelvesEdit(r) {
  return __webpack_require__.e/* require.ensure */(66).then((function () {
    return r(__webpack_require__("5ALr"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var areaEdit = function areaEdit(r) {
  return __webpack_require__.e/* require.ensure */(67).then((function () {
    return r(__webpack_require__("Dyqx"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

//财务管理
var paymentMoneyAudit = function paymentMoneyAudit(r) {
  return __webpack_require__.e/* require.ensure */(24).then((function () {
    return r(__webpack_require__("q4TS"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var paymentAudit = function paymentAudit(r) {
  return __webpack_require__.e/* require.ensure */(25).then((function () {
    return r(__webpack_require__("j2S9"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var inventoryAuditManagement = function inventoryAuditManagement(r) {
  return __webpack_require__.e/* require.ensure */(22).then((function () {
    return r(__webpack_require__("Jowz"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var rawMaterialPriceAudit = function rawMaterialPriceAudit(r) {
  return __webpack_require__.e/* require.ensure */(23).then((function () {
    return r(__webpack_require__("Gor2"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

//系统管理
var employeeManagement = function employeeManagement(r) {
  return __webpack_require__.e/* require.ensure */(34).then((function () {
    return r(__webpack_require__("gnnb"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var roleManagement = function roleManagement(r) {
  return __webpack_require__.e/* require.ensure */(29).then((function () {
    return r(__webpack_require__("yfJp"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var employeeAdd = function employeeAdd(r) {
  return __webpack_require__.e/* require.ensure */(33).then((function () {
    return r(__webpack_require__("MMit"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var roleAdd = function roleAdd(r) {
  return __webpack_require__.e/* require.ensure */(32).then((function () {
    return r(__webpack_require__("KUw4"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var employeeEdit = function employeeEdit(r) {
  return __webpack_require__.e/* require.ensure */(31).then((function () {
    return r(__webpack_require__("BEaU"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var roleEdit = function roleEdit(r) {
  return __webpack_require__.e/* require.ensure */(30).then((function () {
    return r(__webpack_require__("S1Gx"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: [{
    path: '',
    redirect: '/login',
    hidden: true
  }, {
    path: '/404',
    component: __WEBPACK_IMPORTED_MODULE_4__view_404__["a" /* default */],
    name: '',
    hidden: true
  }, {
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_5__view_login__["a" /* default */],
    name: '登录',
    hidden: true
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__view_index__["a" /* default */],
    name: '首页',
    hidden: false,
    leaf: true,
    permission: 'base_data_manager',
    icon: '', //图标样式class
    children: [{
      path: '/homePage', component: homePage, name: '我的信息'
    }]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__view_index__["a" /* default */],
    name: '基础数据管理',
    hidden: false,
    leaf: false,
    permission: 'base_data_manager',
    icon: 'iconfont icon-shuju', //图标样式class
    children: [{
      path: '/timeLine', component: __WEBPACK_IMPORTED_MODULE_6__view_timeLine_vue__["a" /* default */], name: '时间'
    }, {
      path: '/craftLine', component: __WEBPACK_IMPORTED_MODULE_7__view_craftLine_vue__["a" /* default */], name: '工艺路线'
    }, {
      path: '/customerManagement', component: customerManagement, name: '客户管理', permission: 'client_manager'
    }, {
      path: '/customerAdd', component: customerAdd, name: '录入客户', hidden: true, permission: 'client_add', _path: '/customerManagement'
    }, {
      path: '/customerEdit', component: customerEdit, name: '编辑客户', hidden: true, permission: 'client_edit', _path: '/customerManagement'
    }, {
      path: '/groupManagement', component: groupManagement, name: '班组管理', permission: 'teams_manager'
    }, {
      path: '/groupAdd', component: groupAdd, name: '新增班组', hidden: true, permission: 'teams_add', _path: '/groupManagement'
    }, {
      path: '/groupEdit', component: groupEdit, name: '编辑班组', hidden: true, permission: 'teams_edit', _path: '/groupManagement'
    }, {
      path: '/materialManagement', component: materialManagement, name: '材料管理', permission: 'materials_manager'
    }, {
      path: '/materialAdd', component: materialAdd, name: '录入材料', hidden: true, permission: 'materials_add', _path: '/materialManagement'
    }, {
      path: '/materialEdit', component: materialEdit, name: '编辑材料', hidden: true, permission: 'materials_edit', _path: '/materialManagement'
    }, {
      path: '/supplierManagement', component: supplierManagement, name: '供应商管理', permission: 'suppliers_manager'
    }, {
      path: '/supplierAdd', component: supplierAdd, name: '录入供应商', hidden: true, permission: 'suppliers_add', _path: '/supplierManagement'
    }, {
      path: '/supplierEdit', component: supplierEdit, name: '编辑供应商', hidden: true, permission: 'suppliers_edit', _path: '/supplierManagement'
    }, {
      path: '/deviceManagement', component: deviceManagement, name: '设备管理', permission: 'equipment_manager'
    }, {
      path: '/deviceAdd', component: deviceAdd, name: '录入设备', hidden: true, permission: 'equipment_add', _path: '/deviceManagement'
    }, {
      path: '/deviceEdit', component: deviceEdit, name: '编辑设备', hidden: true, permission: 'equipment_edit', _path: '/deviceManagement'
    }, {
      path: '/mouldManagement', component: mouldManagement, name: '模具工装管理', permission: 'tool_manager'
    }, {
      path: '/mouldAdd', component: mouldAdd, name: '录入模具工装', hidden: true, permission: 'tools_add', _path: '/mouldManagement'
    }, {
      path: '/mouldType', component: mouldType, name: '模具工装类型管理', hidden: true, permission: 'tools_add', _path: '/mouldManagement'
    }, {
      path: '/mouldEdit', component: mouldEdit, name: '编辑模具工装', hidden: true, permission: 'tools_edit', _path: '/mouldManagement'
    }, {
      path: '/positionManagement', component: positionManagement, name: '工位管理', permission: 'station_manager'
    }, {
      path: '/positionAdd', component: positionAdd, name: '录入工位信息', hidden: true, permission: 'station_add', _path: '/positionManagement'
    }, {
      path: '/positionEdit', component: positionEdit, name: '编辑工位信息', hidden: true, permission: 'station_edit', _path: '/positionManagement'
    }, {
      path: '/notificationManagement', component: notificationManagement, name: '通知管理', permission: 'notify_manager'
    }, {
      path: '/noticeRecord', component: noticeRecord, name: '通知记录', hidden: true, permission: 'notify_record_list'
    }]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__view_index__["a" /* default */],
    name: '产品及工艺管理',
    hidden: false,
    leaf: false,
    permission: 'product_manager',
    icon: 'iconfont icon-chanpin', //图标样式class
    children: [{
      path: '/productList', component: productList, name: '产品列表', permission: 'product_list'
    }, {
      path: '/productAdd', component: productAdd, name: '新增产品信息', hidden: true, permission: 'product_add', _path: '/productList'
    }, {
      path: '/productEdit', component: productEdit, name: '编辑产品信息', hidden: true, permission: 'product_edit', _path: '/productList'
    }, {
      path: '/productMaintenance', component: productMaintenance, name: '产品及工序维护', permission: 'process_list'
    }, {
      path: '/routeDetail', component: routeDetail, name: '工艺路线详情', hidden: true, permission: 'procument_detail'
    }, {
      path: '/routeAdd', component: routeAdd, name: '新增工艺路线', hidden: true, permission: 'procument_add'
    }, {
      path: '/routeEdit', component: routeEdit, name: '编辑工艺路线', hidden: true, permission: 'procument_edit'
    }, {
      path: '/categoryManagement', component: categoryManagement, name: '工序类别管理', permission: 'category_list'
    }, {
      path: '/categoryAdd', component: categoryAdd, name: '新增类别', hidden: true, permission: 'category_add', _path: '/categoryManagement'
    }, {
      path: '/categoryEdit', component: categoryEdit, name: '类别编辑', hidden: true, permission: 'category_edit', _path: '/categoryManagement'
    }, {
      path: '/badRecord', component: badRecordList, name: '不良记录', permission: 'bad_record_edit'
    }, {
      path: '/badRecordDetail', component: badRecordDetail, name: '查看不良记录', hidden: true, permission: 'bad_record_edit', _path: '/badRecord'
    }, {
      path: '/processTime', component: processTime, name: '工序用时统计', permission: 'procedure_stats_edit' // procedure_stats_edit
    }, {
      path: '/processTimeEdit', component: processTimeEdit, name: '编辑工序用时统计', hidden: true, permission: 'procedure_stats_edit' // procedure_stats_edit
    }]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__view_index__["a" /* default */],
    name: '订单管理',
    hidden: false,
    leaf: false,
    permission: 'orders_manager',
    icon: 'iconfont icon-dingdanguanli', //图标样式class
    children: [{
      path: '/orderList', component: orderList, name: '订单列表', permission: 'orders_list'
    }, {
      path: '/orderAdd', component: orderAdd, name: '录入订单', hidden: true, permission: 'orders_add'
    }, {
      path: '/orderEdit', component: orderEdit, name: '编辑订单', hidden: true, permission: 'orders_edit'
    }, {
      path: '/orderSplit', component: orderSplit, name: '拆分订单', hidden: true, permission: 'orders_split'
    }, {
      path: '/orderAudit', component: orderAudit, name: '订单审核', permission: 'orders_check_list'
    }, {
      path: '/orderRecord', component: orderRecord, name: '订单修改记录', permission: 'orders_check_list'
    }]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__view_index__["a" /* default */],
    name: '质检管理',
    hidden: false,
    leaf: false,
    permission: 'quality_manager',
    icon: 'iconfont icon-zhijianluyin', //图标样式class
    children: [{
      path: '/inspectorList', component: inspectorList, name: '质检员列表', permission: 'quality_people_list'
    }, {
      path: '/inspectionManagement', component: inspectionManagement, name: '质检任务列表', permission: 'quality_task_list'
    }, {
      path: '/inspectionPlanList', component: inspectionPlanList, name: '质检方案列表', permission: 'quality_programme_list'
    }, {
      path: '/configurationAuthority', component: configurationAuthority, name: '质检员权限配置', hidden: true, permission: 'quality_people_edit'
    }, {
      path: '/inspectionPlanAdd', component: inspectionPlanAdd, name: '新建质检方案', hidden: true, permission: 'quality_programme_add'
    }, {
      path: '/inspectionPlanEdit', component: inspectionPlanEdit, name: '编辑质检方案', hidden: true, permission: 'quality_programme_edit'
    }]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__view_index__["a" /* default */],
    name: '生产任务管理',
    hidden: false,
    leaf: false,
    permission: 'production_task_manager',
    icon: 'iconfont icon-renwuliebiao', //图标样式class
    children: [{
      path: '/productionDemandList', component: productionDemandList, name: '生产需求单列表', permission: 'production_demand_list'
    }, {
      path: '/orderSchedulingManagement', component: orderSchedulingManagement, name: '订单排期管理', permission: 'orders_time_list'
    },
    // {
    //         //   path: '/productionTaskRelease', component: productionTaskRelease, name: '分配生产任务', permission:'task_submit_manager',
    //         // },
    {
      path: '/productionTaskReleaseCopy', component: productionTaskReleaseCopy, name: '分配生产任务', permission: 'task_submit_manager'
    }, {
      path: '/mouldtoolsTaskRelease', component: mouldtoolsTaskRelease, name: '装拆模任务分配', permission: 'task_submit_manager'
    }, {
      path: '/mouldtoolsTaskAdd', component: mouldtoolsTaskAdd, name: '分配装拆模任务', hidden: true, permission: 'task_submit_manager'
    }, {
      path: '/productionDemandAdd', component: productionDemandAdd, name: '新增生产需求单', hidden: true, permission: 'production_demand_add'
    }, {
      path: '/productionTaskStatistics', component: productionTaskStatistics, name: '生产任务统计', permission: 'production_demand_detail'
    }, {
      path: '/productiontest', component: productiontest, name: '测试'
    }, {
      path: '/productionDemandLogList', component: productionDemandLogList, hidden: true, name: '生产需求单修改记录', permission: 'product_task_log_list'
    }, {
      path: '/creationAdminList', component: creationAdminList, name: '生产移交记录', permission: 'creation_admin_List'
    }, {
      path: '/wageStatistics', component: wageStatistics, name: '员工工资统计', permission: 'production_salary'
    }]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__view_index__["a" /* default */],
    name: '采购管理',
    hidden: false,
    leaf: false,
    permission: 'procurement_manager',
    icon: 'iconfont icon-caigoudanguanli', //图标样式class
    children: [{
      path: '/purchaseList', component: purchaseList, name: '采购需求单列表', permission: 'procurement_orders_list'
    }, {
      path: '/changePrice', component: changePrice, name: '申请更改原料价格', hidden: true, permission: 'procurement_price_change'
    }]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__view_index__["a" /* default */],
    name: '仓库管理',
    hidden: false,
    leaf: false,
    permission: 'house_manager',
    icon: 'iconfont icon-beipin_cangkuguanli', //图标样式class
    children: [{
      path: '/purchaseAndStorage', component: purchaseAndStorage, name: '采购入库管理', permission: 'buy_enter_manager'
    }, {
      path: '/productionWarehousing', component: productionWarehousing, name: '生产入库管理', permission: 'production_enter_manager'
    }, {
      path: '/deliveryAndOutgoing', component: deliveryAndOutgoing, name: '发货出库管理', permission: 'send_out_manager'
    }, {
      path: '/productionMaterial', component: productionMaterial, name: '生产领料管理', permission: 'product_task_manager'
    }, {
      path: '/materialInventory', component: materialInventory, name: '材料库存管理', permission: 'materials_cargo_manager'
    }, {
      path: '/shelfManagement', component: shelfManagement, name: '货架管理', permission: 'storage_rack_manager'
    }, {
      path: '/regionalManagement', component: regionalManagement, name: '区域管理', permission: 'area_manager'
    }, {
      path: '/inventoryManagement', component: inventoryManagement, name: '盘库任务管理', permission: 'stocktake_task_manager'
    }, {
      path: '/shelvesAdd', component: shelvesAdd, name: '新增货架', hidden: true, permission: 'storage_rack_add'
    }, {
      path: '/areaAdd', component: areaAdd, name: '新增区域', hidden: true, permission: 'area_add'
    }, {
      path: '/libraryAdd', component: libraryAdd, name: '新增盘库', hidden: true, permission: 'stocktake_add'
    }, {
      path: '/shelvesEdit', component: shelvesEdit, name: '编辑货架', hidden: true, permission: 'storage_rack_edit'
    }, {
      path: '/areaEdit', component: areaEdit, name: '编辑区域', hidden: true, permission: 'area_edit'
    }]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__view_index__["a" /* default */],
    name: '财务管理',
    hidden: false,
    leaf: false,
    permission: 'finance_manager',
    icon: 'iconfont icon-caiwuguanli', //图标样式class
    children: [{
      path: '/paymentMoneyAudit', component: paymentMoneyAudit, name: '到款审核管理', permission: 'orders_plan_manage'
    }, {
      path: '/paymentAudit', component: paymentAudit, name: '付款审核管理', permission: 'orders_payment_manager'
    }, {
      path: '/inventoryAuditManagement', component: inventoryAuditManagement, name: '盘库审核管理', permission: 'stocktake_check_manager'
    }, {
      path: '/rawMaterialPriceAudit', component: rawMaterialPriceAudit, name: '原材料价格审核', permission: 'materials_check_manager'
    }]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__view_index__["a" /* default */],
    name: '系统管理',
    hidden: false,
    leaf: false,
    permission: 'system_manager',
    icon: 'iconfont icon-xitongguanli', //图标样式class
    children: [{
      path: '/employeeManagement', component: employeeManagement, name: '员工管理', permission: 'admin_manager'
    }, {
      path: '/roleManagement', component: roleManagement, name: '角色管理', permission: 'role_manager'
    }, {
      path: '/employeeAdd', component: employeeAdd, name: '新增员工', hidden: true, permission: 'admin_add'
    }, {
      path: '/roleAdd', component: roleAdd, name: '新增角色', hidden: true, permission: 'role_add'
    }, {
      path: '/employeeEdit', component: employeeEdit, name: '编辑员工', hidden: true, permission: 'admin_edit'
    }, {
      path: '/roleEdit', component: roleEdit, name: '编辑角色', hidden: true, permission: 'role_edit'
    }]
  }]
}));

/***/ }),

/***/ "Zsfk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__("GMIA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action__ = __webpack_require__("2+ao");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getters__ = __webpack_require__("2mXc");








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
window.Promise = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a;

var state = {
  history: [],
  startHash: -1,
  moveItem: {},
  selectHash: -1,
  deleteHash: -1,
  activeHash: -1,
  activePreHash: -1,
  activeNextHash: -1,
  activeDirection: 'top',
  listPagePars: new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a(),
  addNew: false,
  newProcedure: {
    procedureId: 0,
    procedureName: '',
    procedureNumber: '',
    procedureType: '',
    procedureQuantity: '',
    checkState: false,
    procedureHalfProductId: '',
    procedureHash: '默认下步工序',
    technicsCard: {
      technicsCardId: 0,
      technicsCardTeamsId: '',
      procedureCategoryId: '',
      technicsCardEquipmentIds: [],
      technicsCardIfInStorage: 0,
      technicsCardIfOutsource: 0,
      technicsCardPrice: '',
      technicsCardReferenceTime: '',
      technicsCardSuppliersId: ''
    },
    tcProduceDepictList: [],
    materialsType: 1,
    tcRequiredMaterialsList: [],
    tcBadnessRecordList: [],
    tcQualityPlanList: [{
      label: '首检',
      isValid: true,
      tcQualityCheckTypeId: 1,
      tcQualityPlanIfRequire: 1,
      tcQualityPlanDescription: '',
      tcQualityPlanInfo: {
        tcQualityPlanInfoWay: 1,
        tcQualityPlanInfoProportion: '',
        tcQualityPlanInfoIfchecknum: '',
        tcQualityPlanInfoInterval: '',
        qualityCheckPlanIds: [],
        qualityCheckPlanPointsName: '',
        qualityCheckPlanPointsId: '',
        tcQualityPlanPointsList: []
      }
    }, {
      label: '巡检',
      isValid: true,
      tcQualityCheckTypeId: 2,
      tcQualityPlanIfRequire: 0,
      tcQualityPlanDescription: '',
      tcQualityPlanInfo: {
        tcQualityPlanInfoWay: '',
        tcQualityPlanInfoProportion: '',
        tcQualityPlanInfoIfchecknum: '',
        tcQualityPlanInfoInterval: '',
        qualityCheckPlanIds: [],
        qualityCheckPlanPointsName: '',
        qualityCheckPlanPointsId: '',
        tcQualityPlanPointsList: []
      }
    }, {
      label: '末检',
      isValid: true,
      tcQualityCheckTypeId: 3,
      tcQualityPlanIfRequire: 0,
      tcQualityPlanDescription: '',
      tcQualityPlanInfo: {
        tcQualityPlanInfoWay: '',
        tcQualityPlanInfoProportion: '',
        tcQualityPlanInfoIfchecknum: '',
        tcQualityPlanInfoInterval: '',
        qualityCheckPlanIds: [],
        qualityCheckPlanPointsName: '',
        qualityCheckPlanPointsId: '',
        tcQualityPlanPointsList: []
      }
    }, {
      label: '  中检  成品检验',
      isValid: true,
      tcQualityCheckTypeId: 4,
      tcQualityPlanIfRequire: 0,
      tcQualityPlanDescription: '',
      tcQualityPlanInfo: {
        tcQualityPlanInfoWay: '',
        tcQualityPlanInfoProportion: '',
        tcQualityPlanInfoIfchecknum: '',
        tcQualityPlanInfoInterval: '',
        qualityCheckPlanIds: [],
        qualityCheckPlanPointsName: '',
        qualityCheckPlanPointsId: '',
        tcQualityPlanPointsList: []
      }
    }]

  }
};
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_6__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_5__action__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
}));

/***/ }),

/***/ "a4ob":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_timeLine_vue__ = __webpack_require__("cAqH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e51f0c38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timeLine_vue__ = __webpack_require__("CSg2");
function injectStyle (ssrContext) {
  __webpack_require__("dDrr")
  __webpack_require__("1RNm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e51f0c38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_timeLine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e51f0c38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timeLine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "al2G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData_js__ = __webpack_require__("i84Q");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import NProgress from 'nprogress'
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      logining: false,
      form: {
        adminAccount: '',
        password: ''
      },
      rules: {
        adminAccount: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: true
    };
  },
  mounted: function mounted() {},

  methods: {
    handleReset2: function handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    login: function login(ev) {
      var _this2 = this;

      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.logining = true;
          __WEBPACK_IMPORTED_MODULE_1__service_getData_js__["login"](_this2.form.adminAccount, _this2.form.password).then(function (res) {
            // console.log(res);
            if (res.data.code == 1) {
              sessionStorage.clear();
              sessionStorage['adminName'] = res.data.data.admin.adminName;
              sessionStorage['adminId'] = res.data.data.admin.adminId;
              sessionStorage['permissions'] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.data.list);
              sessionStorage['user'] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.data.admin);
              _this2.$router.push({ path: '/homePage' });
            } else {
              _this2.$message({
                message: res.data.message,
                type: 'error'
              });
              _this2.logining = false;
            }
          });
        } else {
          _this2.logining = false;
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),

/***/ "bGai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__left_navbar_vue__ = __webpack_require__("wG2C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_vue__ = __webpack_require__("Cz8s");
/**
 * Created by Administrator on 2017/12/7.
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  leftNavBar: __WEBPACK_IMPORTED_MODULE_0__left_navbar_vue__["a" /* default */], header: __WEBPACK_IMPORTED_MODULE_1__header_vue__["a" /* default */]
});

/***/ }),

/***/ "cAqH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_mUtils__ = __webpack_require__("yclV");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialogVisible: false,
      form: {
        name: '',
        startTime: '',
        endTime: ''
      },
      search: '',
      time: ['2018.09.13', '2018.09.14', '2018.09.15', '2018.09.14', '2018.09.15', '2018.09.14', '2018.09.15'],
      peoples: [{
        name: '人员1',
        nodes: [{
          startTime: '2018.09.13 08:00',
          endTime: '2018.09.13 12:00',
          duration: 240
        }, {
          startTime: '2018.09.14 08:00',
          endTime: '2018.09.14 11:00',
          duration: 180
        }]
      }, {
        name: '人员2',
        nodes: [{
          startTime: '2018.09.14 09:00',
          endTime: '2018.09.14 10:00',
          duration: 60
        }]
      }, {
        name: '人员2',
        nodes: [{
          startTime: '2018.09.13 10:00',
          endTime: '2018.09.13 12:00',
          duration: 120
        }]
      }],
      orders: [{
        name: '1号订单:43216487(1/3)',
        products: [{
          name: '1号产品:搅拌桶1',
          process: [{
            label: '工序1',
            info: '0/500'
          }]
        }, {
          name: '1号产品:搅拌桶1',
          process: [{
            label: '工序1',
            info: '0/500'
          }]
        }]
      }, {
        name: '1号订单:43216487(1/3)',
        products: [{
          name: '1号产品:搅拌桶1',
          process: [{
            label: '工序1',
            info: '0/500'
          }]
        }]
      }],
      startIndex: -1,
      parentnode: false,
      dragInfo: { type: 'drag', cont: '拖放字段到这里' }
    };
  },

  computed: {
    totalTime: function totalTime() {
      return this.time.length * 8 * 60 * 60;
    }
  },
  mounted: function mounted() {},

  methods: {
    width: function width(duration) {
      return duration * 60 / this.totalTime * 100;
    },
    left: function left(time) {
      return this.getValidTime(this.time[0] + ' 08:00', time) / this.totalTime * 100;
    },
    getValidTime: function getValidTime(stTime, edTime) {
      var startTime = new Date(stTime);
      var endTime = new Date(edTime);
      var oneDayTime = 8 * 60 * 60 * 1000;
      var dayEnd = 16 * 3600000 + 30 * 60000;
      var reduceTime = 0; //应减去的时间
      if (startTime.getHours() > 8) {
        //开始时间大于8点
        if (startTime.getHours() < 12) {
          reduceTime += (startTime.getHours() - 8) * 3600000 + startTime.getMinutes() * 60000;
        } else if (startTime.getHours() === 12 && startTime.getMinutes() < 30) {
          //开始时间在12:00 - 12:30
          reduceTime += 4 * 3600000;
        } else {
          reduceTime += 4 * 3600000 + startTime.getHours() * 3600000 + startTime.getMinutes() * 60000 - 12 * 3600000 - 30 * 60000;
        }
      }
      if (endTime.getHours() * 3600000 + endTime.getMinutes() * 60000 - dayEnd < 0) {
        reduceTime += dayEnd - endTime.getHours() * 3600000 - endTime.getMinutes() * 60000;
        if (endTime.getHours() === 12 && endTime.getMinutes() < 30) {
          //结束时间在12:00 - 12:30
          reduceTime -= 12 * 3600000 + 30 * 60000 - endTime.getHours() * 3600000 - endTime.getMinutes() * 60000;
        } else if (endTime.getHours() < 12) {
          reduceTime -= 30 * 60000;
        }
      }
      if (startTime.format('yyyy-MM-dd') === endTime.format('yyyy-MM-dd')) {
        //同一天之内
        if (startTime.getHours() < 8 && endTime.getHours() > 16 && endTime.getMinutes() > 30) {
          return oneDayTime / 1000;
        } else {
          return (oneDayTime - reduceTime) / 1000;
        }
      } else {
        //非一天之内
        var allDay = (new Date(endTime.getFullYear() + '-' + endTime.getMonth() + '-' + endTime.getDate() + ' 24:00:00') - new Date(startTime.getFullYear() + '-' + startTime.getMonth() + '-' + startTime.getDate() + ' 00:00:00')) / (24 * 3600000); //相差总天数
        return (oneDayTime * allDay - reduceTime) / 1000;
      }
    },
    getEndTime: function getEndTime(sTime, vTime) {},
    findParent: function findParent(node) {
      if (node.className.indexOf('diy-prop-item') > -1) {
        this.parentnode = node;
      } else {
        this.parentnode = false;
        if (node.parentNode.nodeName.toLowerCase() != 'body') {
          this.findParent(node.parentNode);
        }
      }
    },
    changeDragEnd: function changeDragEnd(el) {
      var activeIndex = this.parentnode ? this.parentnode.getAttribute('data-index') : null;
      if (this.startIndex === -1) {} else {
        var _peoples$y$nodes;

        var x = this.startIndex.split(','),
            y = activeIndex;
        this.deleteDrag();
        if (x[0] == y) {
          return;
        }
        var startTime = void 0,
            endTime = void 0;
        if (this.peoples[y].nodes.length - 1 == -1) {
          startTime = this.time[0] + ' 08:00:00';
          endTime = __WEBPACK_IMPORTED_MODULE_2__config_mUtils__["a" /* getEndtime */](startTime, this.peoples[x[0]].nodes[x[1]].duration * 60);
        } else {
          startTime = this.peoples[y].nodes[this.peoples[y].nodes.length - 1].endTime;
          endTime = __WEBPACK_IMPORTED_MODULE_2__config_mUtils__["a" /* getEndtime */](startTime, this.peoples[x[0]].nodes[x[1]].duration * 60);
        }
        (_peoples$y$nodes = this.peoples[y].nodes).push.apply(_peoples$y$nodes, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.peoples[x[0]].nodes.splice(x[1], 1)));
        this.peoples[y].nodes[this.peoples[y].nodes.length - 1].startTime = startTime;
        this.peoples[y].nodes[this.peoples[y].nodes.length - 1].endTime = endTime;
        x[0] = y;
        this.startIndex = x.join(',');
      }
      this.startIndex = -1;
    },
    changeDragStart: function changeDragStart(el) {
      this.startIndex = el.target.getAttribute('data-index');
    },
    handleDragOver: function handleDragOver(el) {
      el.preventDefault(); //重要
      el.dataTransfer.dropEffect = 'move';
      this.findParent(el.target);
      var activeIndex = this.parentnode ? this.parentnode.getAttribute('data-index') : null;
      if (activeIndex != null) {
        //console.log(x, y)    //["2", "0"] "0"   被拖拽元素索引 拖拽位置索引
        if (this.startIndex === -1) {
          this.righToLeft(activeIndex);
        } else {

          var x = this.startIndex.split(','),
              y = activeIndex;
          console.log(x, y);
          this.getfictitious(x, y);
        }
        /*let x = this.startIndex.split(','), y = activeIndex;
        this.getfictitious(x, y);*/

        /*this.peoples[y].nodes.push(...this.peoples[x[0]].nodes.splice(x[1], 1))
         x[0] = y
         this.startIndex = x.join(',')*/
      }
    },
    righToLeft: function righToLeft(y) {
      this.deleteDrag();
      var nodesItem = {
        startTime: '',
        endTime: '',
        duration: 120,
        type: ''
      };
      if (this.peoples[y].nodes.length - 1 == -1) {
        nodesItem.startTime = this.time[0] + ' 08:00';
        nodesItem.endTime = __WEBPACK_IMPORTED_MODULE_2__config_mUtils__["a" /* getEndtime */](nodesItem.startTime, nodesItem.duration * 60);
      } else {
        nodesItem.startTime = this.peoples[y].nodes[this.peoples[y].nodes.length - 1].endTime;
        nodesItem.endTime = __WEBPACK_IMPORTED_MODULE_2__config_mUtils__["a" /* getEndtime */](nodesItem.startTime, nodesItem.duration * 60);
      }
      nodesItem.type = this.dragInfo.type;
      this.peoples[y].nodes.push(nodesItem);
    },
    getfictitious: function getfictitious(x, y) {
      this.deleteDrag();
      if (x[0] == y) {
        return;
      }
      var nodesItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.peoples[x[0]].nodes[x[1]]));
      if (this.peoples[y].nodes.length - 1 == -1) {
        nodesItem.startTime = this.time[0] + ' 08:00';
        nodesItem.endTime = __WEBPACK_IMPORTED_MODULE_2__config_mUtils__["a" /* getEndtime */](nodesItem.startTime, nodesItem.duration * 60);
      } else {
        nodesItem.startTime = this.peoples[y].nodes[this.peoples[y].nodes.length - 1].endTime;
        nodesItem.endTime = __WEBPACK_IMPORTED_MODULE_2__config_mUtils__["a" /* getEndtime */](nodesItem.startTime, nodesItem.duration * 60);
      }
      nodesItem.type = this.dragInfo.type;
      this.peoples[y].nodes.push(nodesItem);
    },
    deleteDrag: function deleteDrag() {
      for (var i = 0; i < this.peoples.length; i++) {
        if (this.peoples[i].nodes.length > 0) {
          if (this.peoples[i].nodes[this.peoples[i].nodes.length - 1].type) {
            this.peoples[i].nodes.splice(this.peoples[i].nodes.length - 1, 1);
          }
        }
      }
    },
    submit: function submit() {}
  }
});

/***/ }),

/***/ "dDrr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dLd/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "dYVh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_env__ = __webpack_require__("uaSg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isCollapse: false,
      toggleSystem: false,
      isSwitch: true,
      applicationActive: 0,
      active: '',
      name: '',
      seacrhcont: '',
      path: '',
      adminName: '',
      adminPortraitUrl: '',
      headerNavList: [],
      asideList: [],
      nowSystem: 0,
      url: this.$route.path,
      query: this.$route.query.single,
      netaddress: '',
      myPermission: {},
      logoUrl: '',
      isActive: '',
      selectList: [],
      isSelectAll: false,
      isDataCenter: false,
      otherSystemUrl: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.adminName = sessionStorage['adminName'];
  },

  methods: {
    judgeBuildingDetail: function judgeBuildingDetail(val, id) {
      var _this = this;

      if (val == '/index') {
        // this.$router.replace({path: '/applicationList'});
        this.applicationActive = 0;
      } else {
        this.asideList.forEach(function (item, index) {
          if (val.indexOf(item.path) != -1) {
            _this.applicationActive = index;
          }
        });
      }
    },
    logOut: function logOut() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["logout"]().then(function (res) {
        if (res.data.code == 1) {
          sessionStorage.clear();
          _this2.$router.replace('/login');
        }
      });
    }
  },
  watch: {
    '$route': function $route(val) {
      this.judgeBuildingDetail(val.path);
    }
  }
});

/***/ }),

/***/ "f3nc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i84Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "commonGet", function() { return commonGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productList", function() { return productList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productLists", function() { return productLists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteProduct", function() { return deleteProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelProduct", function() { return cancelProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "releaseProduct", function() { return releaseProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProduct", function() { return getProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateProduct", function() { return updateProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addProduct", function() { return addProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productRoutingList", function() { return productRoutingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelRouting", function() { return cancelRouting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "releaseRouting", function() { return releaseRouting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRouting", function() { return getRouting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProcedure", function() { return getProcedure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "semiFinishedProductList", function() { return semiFinishedProductList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductProcedure", function() { return getProductProcedure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeRoutings", function() { return writeRoutings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "procedureList", function() { return procedureList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProduceDraw", function() { return getProduceDraw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductDraw", function() { return getProductDraw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkProduct", function() { return checkProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteProcedures", function() { return deleteProcedures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editProcedure", function() { return editProcedure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getResListByType", function() { return getResListByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purchaseImportList", function() { return purchaseImportList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purchaseImportDetail", function() { return purchaseImportDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notifyCheck", function() { return notifyCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "planDetail", function() { return planDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allAreaList", function() { return allAreaList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getByAreaId", function() { return getByAreaId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "warehousingEnter", function() { return warehousingEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "goodsShelvesList", function() { return goodsShelvesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storageRackDelete", function() { return storageRackDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storageRackDetail", function() { return storageRackDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storageRackAdd", function() { return storageRackAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storageRackUpdate", function() { return storageRackUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMaxAreaNum", function() { return getMaxAreaNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "areaList", function() { return areaList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteArea", function() { return deleteArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addArea", function() { return addArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editArea", function() { return editArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "areaInfo", function() { return areaInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stocktakesList", function() { return stocktakesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addStocktakes", function() { return addStocktakes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stocktakesInfo", function() { return stocktakesInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitApproval", function() { return submitApproval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "procurementPlanBuyOver", function() { return procurementPlanBuyOver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productionInventoryList", function() { return productionInventoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productionInventoryDetail", function() { return productionInventoryDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productionInventoryPlanDetail", function() { return productionInventoryPlanDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productionInventoryPlanEnter", function() { return productionInventoryPlanEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productionInventoryPlanGetEnter", function() { return productionInventoryPlanGetEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deliveryOutList", function() { return deliveryOutList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deliveryOutListDetail", function() { return deliveryOutListDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deliveryOutListOut", function() { return deliveryOutListOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deliveryoutPlanDetail", function() { return deliveryoutPlanDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deliveryoutSendProduct", function() { return deliveryoutSendProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productionRequisitionList", function() { return productionRequisitionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productionRequisitionDetail", function() { return productionRequisitionDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productionRequisitionOutWarehouse", function() { return productionRequisitionOutWarehouse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "materialstoolsList", function() { return materialstoolsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWarning", function() { return setWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "materialsListDetail", function() { return materialsListDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStocktakeAdminByPermission", function() { return getStocktakeAdminByPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQualityAdminByPermission", function() { return getQualityAdminByPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "printingQRode", function() { return printingQRode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStocktakesNum", function() { return getStocktakesNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStorageRackQrCode", function() { return getStorageRackQrCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteStocktake", function() { return deleteStocktake; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notifyCheckProduct", function() { return notifyCheckProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findClientListNoPage", function() { return findClientListNoPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findClientList", function() { return findClientList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clientDetail", function() { return clientDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "freezeClient", function() { return freezeClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "thawClient", function() { return thawClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addClient", function() { return addClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateClient", function() { return updateClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findTeamsListNoPage", function() { return findTeamsListNoPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findTeamsList", function() { return findTeamsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addTeams", function() { return addTeams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teamsDetail", function() { return teamsDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTeams", function() { return updateTeams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTeams", function() { return deleteTeams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "materialsAll", function() { return materialsAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "materialsList", function() { return materialsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "materialsOperationRecordList", function() { return materialsOperationRecordList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteMaterials", function() { return deleteMaterials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addMaterials", function() { return addMaterials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editMaterials", function() { return editMaterials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allqualityCheckPlanList", function() { return allqualityCheckPlanList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findSuppliersList", function() { return findSuppliersList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "suppliersDetail", function() { return suppliersDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "freezeSuppliers", function() { return freezeSuppliers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "thawSuppliers", function() { return thawSuppliers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addSuppliers", function() { return addSuppliers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateSuppliers", function() { return updateSuppliers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findEquipmentListNoPage", function() { return findEquipmentListNoPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findEquipmentList", function() { return findEquipmentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findEquipmentByid", function() { return findEquipmentByid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maintenanceEquipment", function() { return maintenanceEquipment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadMaintenanceEquipment", function() { return uploadMaintenanceEquipment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMaintenanceEquipmentImageOrVideo", function() { return getMaintenanceEquipmentImageOrVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "processedEquipment", function() { return processedEquipment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEquipment", function() { return addEquipment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateEquipment", function() { return updateEquipment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findMouldToolsListNoPage", function() { return findMouldToolsListNoPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mouldtoolsList", function() { return mouldtoolsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addMouldTools", function() { return addMouldTools; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mouldToolsDetail", function() { return mouldToolsDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateMouldTools", function() { return updateMouldTools; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteMouldTools", function() { return deleteMouldTools; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mouldTypeList", function() { return mouldTypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addMouldType", function() { return addMouldType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findStation", function() { return findStation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findStationNoPage", function() { return findStationNoPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addStation", function() { return addStation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateStation", function() { return updateStation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteStation", function() { return deleteStation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findStationById", function() { return findStationById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findMessageTemplates", function() { return findMessageTemplates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setRole", function() { return setRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findMessageTemplatesById", function() { return findMessageTemplatesById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "freezeMessageTemplate", function() { return freezeMessageTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "thaweMessageTemplate", function() { return thaweMessageTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findMessage", function() { return findMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "materialsCheckInfo", function() { return materialsCheckInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStationQrCode", function() { return getStationQrCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStorageRackByStock", function() { return getStorageRackByStock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteSuppliers", function() { return deleteSuppliers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteClient", function() { return deleteClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "creationList", function() { return creationList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadDrawing", function() { return uploadDrawing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "drawingHistoryList", function() { return drawingHistoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mouldtoolsUseList", function() { return mouldtoolsUseList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMouldtoolsUse", function() { return createMouldtoolsUse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateMouldtoolsUse", function() { return updateMouldtoolsUse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delelteMouldtoolsUse", function() { return delelteMouldtoolsUse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mouldtoolsUseDetail", function() { return mouldtoolsUseDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findMouldToolsByProcedureId", function() { return findMouldToolsByProcedureId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mouldToolsNofityUnload", function() { return mouldToolsNofityUnload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrdersList", function() { return getOrdersList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productionOrderInfo", function() { return productionOrderInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "requirementsInfo", function() { return requirementsInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "firstGenerate", function() { return firstGenerate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "halfProductList", function() { return halfProductList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "secondGenerate", function() { return secondGenerate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rejectGenerate", function() { return rejectGenerate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "publishGenerate", function() { return publishGenerate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productionTaskList", function() { return productionTaskList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeTimes", function() { return changeTimes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productionTaskListRelease", function() { return productionTaskListRelease; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productionTaskAdminList", function() { return productionTaskAdminList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findAdminProcessInfo", function() { return findAdminProcessInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateAdminProcessTime", function() { return updateAdminProcessTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeAdminProcess", function() { return changeAdminProcess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLastWorkstageStartTime", function() { return getLastWorkstageStartTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allocationProcessToAdmin", function() { return allocationProcessToAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "processMissionTranslation", function() { return processMissionTranslation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "recallAdminProcess", function() { return recallAdminProcess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "processMissionList", function() { return processMissionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "processTaskInfo", function() { return processTaskInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "countReferenceTime", function() { return countReferenceTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "countMissionsData", function() { return countMissionsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrdersByprogress", function() { return getOrdersByprogress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logList", function() { return logList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logInfo", function() { return logInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "creationAdminList", function() { return creationAdminList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSalaryList", function() { return getSalaryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findByCondition", function() { return findByCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteOrders", function() { return deleteOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "followOrders", function() { return followOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeSureProduct", function() { return makeSureProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "badDebt", function() { return badDebt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ordersConfirmReceipt", function() { return ordersConfirmReceipt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ordersDetail", function() { return ordersDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ordersCheckList", function() { return ordersCheckList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCheckOrders", function() { return deleteCheckOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "passCheck", function() { return passCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ordersCheckDetail", function() { return ordersCheckDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addOrders", function() { return addOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editOrders", function() { return editOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "splitOrders", function() { return splitOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSalesmanByPermission", function() { return getSalesmanByPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "canBuyProductList", function() { return canBuyProductList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "historyProduct", function() { return historyProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRate", function() { return getRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteOrdersContracts", function() { return deleteOrdersContracts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "putOrdersContact", function() { return putOrdersContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ordersLogList", function() { return ordersLogList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ordersLogDetail", function() { return ordersLogDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paymentList", function() { return paymentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ordersPayDetail", function() { return ordersPayDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startTicket", function() { return startTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMoney", function() { return getMoney; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paymentCheckList", function() { return paymentCheckList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSuppliersList", function() { return getSuppliersList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeSurePay", function() { return makeSurePay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "libraryCheckList", function() { return libraryCheckList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "librarycheckDetail", function() { return librarycheckDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "librarycheckUpdate", function() { return librarycheckUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listMaterialsPriceApply", function() { return listMaterialsPriceApply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listMaterialsPriceDetail", function() { return listMaterialsPriceDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listMaterialsPriceAccept", function() { return listMaterialsPriceAccept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listMaterialsPriceReject", function() { return listMaterialsPriceReject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "procurementPlanList", function() { return procurementPlanList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePrice", function() { return changePrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "procurementPlanDetail", function() { return procurementPlanDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "requirementsInfoByTaskId", function() { return requirementsInfoByTaskId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "materialsInfo", function() { return materialsInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allGongWeiAreaList", function() { return allGongWeiAreaList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allHuojiaAreaList", function() { return allHuojiaAreaList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkLogin", function() { return checkLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logout", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "adminList", function() { return adminList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRoleList", function() { return getRoleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allTeamList", function() { return allTeamList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteAdmin", function() { return deleteAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "freezeAdmin", function() { return freezeAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalAdmin", function() { return normalAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addAdmin", function() { return addAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateAdmin", function() { return updateAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "detailAdmin", function() { return detailAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listRole", function() { return listRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteRole", function() { return deleteRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addRole", function() { return addRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeRole", function() { return changeRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRole", function() { return getRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPermissions", function() { return getPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateRole", function() { return updateRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchQualityCheckPlanList", function() { return searchQualityCheckPlanList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qualityAdminList", function() { return qualityAdminList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteAdminQuality", function() { return deleteAdminQuality; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qualityCheckTypeList", function() { return qualityCheckTypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAdminQuality", function() { return getAdminQuality; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateAdminQuality", function() { return updateAdminQuality; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "procedureCategoryList", function() { return procedureCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qualityTaskList", function() { return qualityTaskList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qualityTaskListFinished", function() { return qualityTaskListFinished; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQualityTask", function() { return getQualityTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQualityTaskRecord", function() { return getQualityTaskRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qualityCheckPlanList", function() { return qualityCheckPlanList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addToTcBadnessRecord", function() { return addToTcBadnessRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlineQualityCheckPlan", function() { return onlineQualityCheckPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "offlineQualityCheckPlan", function() { return offlineQualityCheckPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addQualityCheckPlan", function() { return addQualityCheckPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQualityCheckPlan", function() { return getQualityCheckPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateQualityCheckPlan", function() { return updateQualityCheckPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkUpdateQualityCheckPlan", function() { return checkUpdateQualityCheckPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listProcedureCategory", function() { return listProcedureCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteProcedureCategory", function() { return deleteProcedureCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editProcedureCategory", function() { return editProcedureCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleProcedureCategory", function() { return toggleProcedureCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addProcedureCategory", function() { return addProcedureCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProcedureCategory", function() { return getProcedureCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiveFile", function() { return receiveFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downloadResource", function() { return downloadResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productHalfList", function() { return productHalfList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findSuppliersListNoPage", function() { return findSuppliersListNoPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHomeMessage", function() { return getHomeMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIndexCount", function() { return getIndexCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTcBadRecord", function() { return getTcBadRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadBadRecord", function() { return uploadBadRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addTcBadRecord", function() { return addTcBadRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTcBadRecord", function() { return deleteTcBadRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showTcBadRecord", function() { return showTcBadRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProceduresStatsList", function() { return getProceduresStatsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addProceduresStatsList", function() { return addProceduresStatsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateProceduresStatsList", function() { return updateProceduresStatsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadProceduresStatsVideo", function() { return uploadProceduresStatsVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProceduresStatsDeatil", function() { return getProceduresStatsDeatil; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_env__ = __webpack_require__("uaSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_mUtils__ = __webpack_require__("yclV");








__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
  config.params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({ timess: new Date().getTime() }, config.params);
  // 在发送请求之前做些什么
  // let channelId = sessionStorage.getItem('channelId');
  // let adminAccount = sessionStorage.getItem('adminAccount');
  // let allSessionId = sessionStorage.getItem('allSessionId');
  // let permissionId = sessionStorage.getItem('permissionId');
  // if (!channelId || !adminAccount || !allSessionId || !permissionId) {
  //   location.href = localStorage.getItem('channelChannelUrl') ? localStorage.getItem('channelChannelUrl') : localStorage.getItem('channelUrl');
  // }
  // config.headers['channelId'] = channelId;
  // config.headers['adminAccount'] = adminAccount;
  // config.headers['allSessionId'] = allSessionId;
  // config.headers['permissionId'] = permissionId;
  return config;
}, function (error) {
  // 对请求错误做些什么
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
  // token 已过期，重定向到登录页面
  if (response.data.code == 2 || response.data.code == 'noLogin') {

    // alert('登录超时，请重新登录！');
    localStorage.clear();
    __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].replace({ path: '/login' });
    return null;
  }
  return response;
}, function (error) {
  // Do something with response error
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

var searchParams = function searchParams(prop) {
  var param = new URLSearchParams();
  for (var key in prop) {
    param.append(key, prop[key]);
  }
  return param;
};
//手机端
var transformRequest = function transformRequest(data) {
  var ret = '';
  for (var it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
  }
  return ret;
};

//产品及工艺管理

// 通用
var commonGet = function commonGet(url, data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: data });
};

/**
 * 产品列表
 * 参数名	必选	类型	说明
 * pageIndex	是	Integer	页码
 * pageSize	是	Integer	页面大小
 * productState	是	Integer	状态 1/发布 2/未发布
 * productNumber	否	string	编号
 * productName	否	string	名称
 * productArticleNumber	否	string	品号
 * productModel	否	string	型号
 * productType	否	Inteegr	产品类型 1/成品 2/半成品
 * productClientId	否	Long	客户ID
 */

var productList = function productList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/product/productList', { params: data });
};
var productLists = function productLists(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/product/findProducts', { params: data });
};

/**
 * 删除产品接口
 * 参数名	必选	类型	说明
 * productId	是	Long	产品ID
 */

var deleteProduct = function deleteProduct(productId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/product/deleteProduct', 'productId=' + productId);
};

/**
 * 取消发布产品
 * 参数名	必选	类型	说明
 * productId	是	Long	产品ID
 */

var cancelProduct = function cancelProduct(productId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/product/cancelProduct', 'productId=' + productId);
};
/**
 * 删除工序
 * @param productId 产品ID
 * @returns {AxiosPromise}
 */
var deleteProcedures = function deleteProcedures(productId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/product/deleteProcedures', 'productId=' + productId);
};
var editProcedure = function editProcedure(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/product/editProcedure', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};
/**
 * 发布产品
 * 参数名	必选	类型	说明
 * productId	是	Long	产品ID
 */

var releaseProduct = function releaseProduct(productId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/product/releaseProduct', 'productId=' + productId);
};

/**
 * 产品详情
 * 参数名	必选	类型	说明
 * productId	是	Long	产品ID
 */

var getProduct = function getProduct(productId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/product/getProduct', { params: { productId: productId } });
};

/**
 * 更新产品
 * 参数名	必选	类型	说明
 * productId	是	Long	产品ID
 * productNumber	是	string	产品编号
 * productClientId	是	Long	客户ID
 * productName	是	string	产品名称
 * productModel	是	string	型号
 * productArticleNumber	是	string	品号
 * productState	是	Integer	产品状态（1/发布 2/未发布)
 * productType	是	Integer	产品类型（1/成品 2/半成品）
 * productVersion	是	string	产品版本
 * productRemark	是	string	备注描述
 */

var updateProduct = function updateProduct(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/product/updateProduct', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 新增产品
 * 参数名	必选	类型	说明
 * productNumber	是	string	产品编号
 * productClientId	是	Long	客户ID
 * productName	是	string	产品名称
 * productModel	是	string	型号
 * productArticleNumber	是	string	品号
 * productState	是	Integer	产品状态（1/发布 2/未发布)
 * productType	是	Integer	产品类型（1/成品 2/半成品）
 * productVersion	是	string	产品版本
 * productRemark	是	string	备注描述
 */

var addProduct = function addProduct(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/product/addProduct', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 产品及工序列表接口
 * 参数名	必选	类型	说明
 * pageIndex	是	Integer	页码
 * password	是	Integer	页面
 * routingState	是	Integer	0/未录入 1/已录入(发布） 2/未发布
 * productNumber	否	String	编号
 * productName	否	String	名称
 * productArticleNumber	否	String	品号
 * productModel	否	String	型号
 * productType	否	Integer	产品类型 1/成品 2/半成品
 * productClientId	否	Long	客户ID
 */

var productRoutingList = function productRoutingList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/product/productRoutingList', { params: data });
};

/**
 * 取消发布工艺路线
 * 参数名	必选	类型	说明
 * productId	是	Long	产品ID
 */

var cancelRouting = function cancelRouting(productId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/product/cancelRouting', 'productId=' + productId);
};

/**
 * 发布工艺路线
 * 参数名	必选	类型	说明
 * productId	是	Long	产品ID
 */

var releaseRouting = function releaseRouting(productId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/product/releaseRouting', 'productId=' + productId);
};

/**
 * 查看工艺路线
 * 参数名	必选	类型	说明
 * productId	是	Long	产品ID
 */

var getRouting = function getRouting(productId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/product/getRouting', { params: { productId: productId } });
};

/**
 * 工艺详情
 * 参数名	必选	类型	说明
 * procedureId	是	Long	工艺ID
 */

var getProcedure = function getProcedure(procedureId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/product/getProcedure?procedureId=' + procedureId);
};

/**
 * 半成品列表
 * 参数名	必选	类型	说明
 * pageIndex	是	Integer	页码
 * password	是	Integer	页面
 * productNumber	否	String	编号
 * productName	否	String	名称
 * productModel	否	String	型号
 */

var semiFinishedProductList = function semiFinishedProductList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/product/semiFinishedProductList', { params: data });
};

/**
 * 获取产品流程
 * 参数名	必选	类型	说明
 * productId	是	Long	产品ID
 */

var getProductProcedure = function getProductProcedure(productId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/product/getProductProcedure', { params: { productId: productId } });
};

/**
 * 设置工艺路线
 */

var writeRoutings = function writeRoutings(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/product/writeRoutings', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 工序列表
 * 参数名	必选	类型	说明
 * pageIndex	是	Integer	页码
 * pageSize	是	Integer	页面
 * productId	是	Long	产品ID
 */

var procedureList = function procedureList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/product/procedureList', { params: data });
};

/**
 * 工序附件详情
 * 参数名	必选	类型	说明
 * procedureId	是	Long	工序ID
 */

var getProduceDraw = function getProduceDraw(procedureId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/product/getProduceDraw', { params: { procedureId: procedureId } });
};

/**
 * 查看产品图纸
 * 参数名	必选	类型	说明
 * productId	是	Long	产品ID
 */

var getProductDraw = function getProductDraw(productId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/product/getProductDraw', { params: { productId: productId } });
};

//基础数据管理

/**
 * 查询客户信息列表无分页
 */

var findClientListNoPage = function findClientListNoPage(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/client/findClientListNoPage');
};

/**
 * 查询客户信息列表
 * 参数名	必选	类型	说明
 * clientState	是	string	客户状态( 1/使用中 2/冻结 0/删除）
 * clientNumber	否	string	客户编号
 * clientName	否	string	客户名称
 * pageIndex	否	Integer	当前页数
 * pageSize	否	Integer	页大小
 */

var findClientList = function findClientList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/client/findClientList', 'clientState=' + data.clientState + '&clientNumber=' + data.clientNumber + '&clientName=' + data.clientName + '&pageIndex=' + data.pageIndex + '&pageSize=' + data.pageSize);
};

/**
 * 根据主键id查询客户信息
 * 参数名	必选	类型	说明
 * clientId	是	Long	客户主键id
 */

var clientDetail = function clientDetail(clientId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/client/clientDetail', 'clientId=' + clientId);
};

/**
 * 冻结客户
 * 参数名	必选	类型	说明
 * clientId	是	Long	客户主键id
 */

var freezeClient = function freezeClient(clientId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/client/freezeClient', 'clientId=' + clientId);
};

/**
 * 解冻客户
 * 参数名	必选	类型	说明
 * clientId	是	Long	客户主键id
 */

var thawClient = function thawClient(clientId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/client/thawClient', 'clientId=' + clientId);
};

/**
 * 客户人员新增
 * 参数名	必选	类型	说明
 * clientName	是	string	客户名称
 * clientExplain	是	string	补充说明
 * clientNumber	是	string	客户编号
 * clientLocation	是	String	客户地址
 * clientPhone	是	String	客户联系方式
 * clientEmail	是	String	客户邮箱
 * clientReferredName   客户简称
 */

var addClient = function addClient(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/client/addClient', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 客户人员编辑
 * 参数名	必选	类型	说明
 * clientId	是	Long	客户主键id
 * clientNumber	否	string	客户编号
 * clientName	否	string	客户名称
 * clientPhone	否	string	客户联系方式
 * clientEmail	否	string	客户邮箱
 * clientLocation	否	string	客户地址
 * clientExplain	否	string	补充说明
 * clientReferredName 客户简称
 */

var updateClient = function updateClient(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/client/updateClient', 'clientId=' + data.clientId + '&clientNumber=' + data.clientNumber + '&clientName=' + data.clientName + '&clientPhone=' + data.clientPhone + '&clientEmail=' + data.clientEmail + '&clientLocation=' + data.clientLocation + '&clientExplain=' + data.clientExplain + '&clientReferredName=' + data.clientReferredName + '&clientType=' + data.clientType);
};

/**
 * 删除客户
 * 参数名	必选	类型	说明
 * clientId	是	Long	客户主键id
 */

var deleteClient = function deleteClient(clientId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/client/deleteClient', 'clientId=' + clientId);
};
/**
 * 班组列表(无分页)
 */

var findTeamsListNoPage = function findTeamsListNoPage(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/teams/findTeamsListNoPage');
};

/**
 * 班组列表
 * 参数名	必选	类型	说明
 * teamsNumber	是	string	班组编号
 * pageIndex	否	Integer	当前页数
 * pageSize	否	Integer	页大小
 */

var findTeamsList = function findTeamsList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/teams/findTeamsList', 'teamsNumber=' + data.teamsNumber + '&pageIndex=' + data.pageIndex + '&pageSize=' + data.pageSize);
};

/**
 * 新增班组
 * 参数名	必选	类型	说明
 * teamsNumber	是	string	班组编号
 * teamsName	是	string	班组名称
 */

var addTeams = function addTeams(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/teams/addTeams', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 根据班组主键id查找班组信息
 * 参数名	必选	类型	说明
 * teamsId	是	Long	班组id
 */

var teamsDetail = function teamsDetail(teamsId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/teams/teamsDetail', 'teamsId=' + teamsId);
};

/**
 * 编辑班组信息
 * 参数名	必选	类型	说明
 * teamsId	是	Long	班组id
 * teamsName	否	string	班组名称
 * teamsNumber	否	string	班组编号
 */

var updateTeams = function updateTeams(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/teams/updateTeams', 'teamsId=' + data.teamsId + '&teamsName=' + data.teamsName + '&teamsNumber=' + data.teamsNumber);
};

/**
 * 删除班组
 * 参数名	必选	类型	说明
 * teamsId	是	Long	班组id
 */

var deleteTeams = function deleteTeams(teamsId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/teams/deleteTeams', 'teamsId=' + teamsId);
};

/**
 * 材料列表（无分页）
 */

var materialsAll = function materialsAll(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/materials/materialsAll', { params: data });
};

/**
 * 材料列表
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	int	页面量
 * suppliersName	否	string	供应商名称
 * materialsName	否	string	材料名称
 * materialsNumber	否	string	材料编号
 */

var materialsList = function materialsList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/materials/materialsList', { params: data });
};

/**
 * 材料操作记录
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	int	页面量
 * operationClass	否	int	操作类型（1/删除 2/修改价格）
 * materialsName	否	string	材料名称
 * materialsNumber	否	string	材料编号
 */

var materialsOperationRecordList = function materialsOperationRecordList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/materials/materialsOperationRecordList', { params: data });
};

/**
 * 查看材料质检配置
 * @param materialsId   材料id
 */
var materialsCheckInfo = function materialsCheckInfo(materialsId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/materials/materialsCheckInfo', 'materialsId=' + materialsId);
};

/**
 * 材料删除
 * 参数名	必选	类型	说明
 * materialsId	是	long	材料id
 */

var deleteMaterials = function deleteMaterials(materialsId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/materials/deleteMaterials', 'materialsId=' + materialsId);
};

/**
 * 新增材料
 * 参数名	必选	类型	说明
 * materialsNumber	是	string	材料编号
 * materialsName	是	string	材料名称
 * materialsPrice	是	double	材料价格
 * materialsUnit	是	string	材料单位
 * suppliersId	是	long	供应商id
 * materialsModel 材料型号
 * materialsQualityPlanInfoWay	是	int	质检方式((1/全检 2/抽检))
 * materialsQualityPlanInfoProportion	是	double	比例
 * checkPlanIds	是	string	质检方案id组
 * checkPointMsg	是	string	关注点详情信息
 * materialsQualityPlanInfoIfchecknum	是	int	是否检查数量(1/是 2/否)materialsId	是	long	材料id
 * materialsArticleNumber 是	string	材料品号
 */

var addMaterials = function addMaterials(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/materials/addMaterials', 'materialsNumber=' + data.materialsNumber + '&materialsName=' + data.materialsName + '&materialsPrice=' + data.materialsPrice + '&materialsUnit=' + data.materialsUnit + '&suppliersId=' + data.suppliersId + '&materialsModel=' + data.materialsModel + '&materialsQualityPlanInfoWay=' + data.materialsQualityPlanInfoWay + '&materialsQualityPlanInfoProportion=' + data.materialsQualityPlanInfoProportion + '&checkPlanIds=' + data.checkPlanIds + '&checkPointMsg=' + data.checkPointMsg + '&materialsQualityPlanInfoIfchecknum=' + data.materialsQualityPlanInfoIfchecknum + '&materialsArticleNumber=' + data.materialsArticleNumber + '&materialsResId=' + data.materialsResId + '&materialsDoubleUnit=' + data.materialsDoubleUnit);
};

/**
 * 材料编辑
 * 参数名	必选	类型	说明
 * materialsId	是	long	材料id
 * materialsNumber	是	string	材料编号
 * materialsName	是	string	材料名称
 * materialsPrice	是	double	材料价格
 * materialsUnit	是	string	材料单位
 * suppliersId	是	long	供应商id
 *  * materialsModel 材料型号
 * materialsQualityPlanInfoId	是	long	质检配置主信息id
 * materialsQualityPlanInfoWay	是	int	质检方式((1/全检 2/抽检))
 * materialsQualityPlanInfoProportion	是	double	比例
 * checkPlanIds	是	string	质检方案id组
 * checkPointMsg	是	string	关注点详情信息
 * materialsQualityPlanInfoIfchecknum	是	int	是否检查数量(1/是 2/否)materialsId	是	long	材料id
 * materialsArticleNumber 是	string	材料品号
 */

var editMaterials = function editMaterials(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/materials/editMaterials', 'materialsId=' + data.materialsId + '&materialsNumber=' + data.materialsNumber + '&materialsName=' + data.materialsName + '&materialsPrice=' + data.materialsPrice + '&materialsUnit=' + data.materialsUnit + '&suppliersId=' + data.suppliersId + '&materialsModel=' + data.materialsModel + '&materialsQualityPlanInfoId=' + (data.materialsQualityPlanInfoId != null ? data.materialsQualityPlanInfoId : '') + '&materialsQualityPlanInfoWay=' + (data.materialsQualityPlanInfoWay != null ? data.materialsQualityPlanInfoWay : '') + '&materialsQualityPlanInfoProportion=' + data.materialsQualityPlanInfoProportion + '&checkPlanIds=' + data.checkPlanIds + '&checkPointMsg=' + data.checkPointMsg + '&materialsQualityPlanInfoIfchecknum=' + (data.materialsQualityPlanInfoIfchecknum != null ? data.materialsQualityPlanInfoIfchecknum : '') + '&materialsArticleNumber=' + data.materialsArticleNumber);
};

/**
 * 质检方案列表
 * 参数名	必选	类型	说明
 */

var allqualityCheckPlanList = function allqualityCheckPlanList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/materials/qualityCheckPlanList');
};

/**
 * 供应商列表
 * 参数名	必选	类型	说明
 * suppliersName	否	string	供应商名称
 * suppliersNumber	否	string	供应商编号
 * suppliersState	是	int	供应商状态( 1/使用中 2/冻结 0/删除)
 * pageIndex	否	Integer	当前页数
 * pageSize	否	Integer	页大小
 */

var findSuppliersList = function findSuppliersList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/supplier/findSuppliersList', 'suppliersName=' + data.suppliersName + '&suppliersNumber=' + data.suppliersNumber + '&suppliersState=' + data.suppliersState + '&pageIndex=' + data.pageIndex + '&pageSize=' + data.pageSize);
};

/**
 * 供应商详情
 * 参数名	必选	类型	说明
 * suppliersId	是	Long	供应商主键id
 */

var suppliersDetail = function suppliersDetail(suppliersId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/supplier/suppliersDetail', 'suppliersId=' + suppliersId);
};

/**
 * 冻结供应商
 * 参数名	必选	类型	说明
 * suppliersId	是	Long	供应商主键id
 */

var freezeSuppliers = function freezeSuppliers(suppliersId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/supplier/freezeSuppliers', 'suppliersId=' + suppliersId);
};

/**
 * 删除供应商
 * 参数名	必选	类型	说明
 * suppliersId	是	Long	供应商主键id
 */

var deleteSuppliers = function deleteSuppliers(suppliersId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/supplier/deleteSuppliers', 'suppliersId=' + suppliersId);
};

/**
 * 解冻供应商
 * 参数名	必选	类型	说明
 * suppliersId	是	Long	供应商主键id
 */

var thawSuppliers = function thawSuppliers(suppliersId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/supplier/thawSuppliers', 'suppliersId=' + suppliersId);
};

/**
 * 新增供应商
 * 参数名	必选	类型	说明
 * suppliersRemark	是	string	备注
 * suppliersNumber	是	string	供应商编号
 * suppliersLocation	是	string	供应商地址
 * suppliersPhone	是	string	供应商联系方式
 * suppliersContactName	是	string	供应商联系人
 * suppliersName	是	string	供应商名称
 */

var addSuppliers = function addSuppliers(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/supplier/addSuppliers', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 编辑供应商
 * 参数名	必选	类型	说明
 * suppliersId	是	Long	供应商主键id
 * suppliersNumber	否	string	供应商编号
 * suppliersName	否	string	供应商名称
 * suppliersPhone	否	string	供应商联系方式
 * suppliersContactName	否	string	供应商联系人
 * suppliersLocation	否	string	供应商地址
 * suppliersRemark	否	string	备注
 */

var updateSuppliers = function updateSuppliers(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/supplier/updateSuppliers', 'suppliersId=' + data.suppliersId + '&suppliersNumber=' + data.suppliersNumber + '&suppliersName=' + data.suppliersName + '&suppliersPhone=' + data.suppliersPhone + '&suppliersContactName=' + data.suppliersContactName + '&suppliersLocation=' + data.suppliersLocation + '&suppliersRemark=' + data.suppliersRemark);
};

/**
 * 设备列表(无分页)
 */

var findEquipmentListNoPage = function findEquipmentListNoPage(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/Equipment/findEquipmentListNoPage');
};

/**
 * 设备列表
 * 参数名	必选	类型	说明
 * equipmentDepartmentId	否	int	设备使用部门（1研发部 2生产部 3质量部 4 仓库部）
 * equipmentModel	否	string	设备型号
 * equipmentNumber	否	string	设备编号
 * equipmentState	是	int	设备状态(1/启用 2/报废 3/维修中 0/删除标志)
 * pageIndex	否	Integer	当前页数
 * pageSize	否	Integer	页大小
 */

var findEquipmentList = function findEquipmentList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/Equipment/findEquipmentList', 'equipmentDepartmentId=' + data.equipmentDepartmentId + '&equipmentModel=' + data.equipmentModel + '&equipmentNumber=' + data.equipmentNumber + '&equipmentFactoryNumber=' + data.equipmentFactoryNumber + '&equipmentState=' + data.equipmentState + '&equipmentName=' + data.equipmentName + '&pageIndex=' + data.pageIndex + '&pageSize=' + data.pageSize);
};

/**
 * 设备详情
 * 参数名	必选	类型	说明
 * equipmentId	是	Long	设备主键id
 */

var findEquipmentByid = function findEquipmentByid(equipmentId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/Equipment/findEquipmentByid', 'equipmentId=' + equipmentId);
};

/**
 * 报修设备
 * 参数名	必选	类型	说明
 * equipmentId	是	Long	设备主键id
 */

// let maintenanceEquipment = (data) => axios.post(`/erp_back/Equipment/maintenanceEquipment`, {params:data});
var maintenanceEquipment = function maintenanceEquipment(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/Equipment/maintenanceEquipment', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 报修设备上传图片和视频
 * 参数名	必选	类型	说明
 * equipmentId	是	Long	设备主键id
 */
var uploadMaintenanceEquipment = function uploadMaintenanceEquipment(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/Equipment/upload', data, { headers: { 'Content-Type': 'multipart/form-data' } });
};

/**
 * 报修获取图片或者视频列表
 * 参数名	必选	类型	说明
 */
var getMaintenanceEquipmentImageOrVideo = function getMaintenanceEquipmentImageOrVideo(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/Equipment/imageOrVideos', 'equipmentMaintainId=' + data.equipmentMaintainId);
};

/**
 * 处理报修设备
 * 参数名	必选	类型	说明
 * equipmentId	是	Long	设备主键id
 * equipmentMaintainResult	是	int	维修结果（1/成功 2/报废）
 * equipmentMaintainContent	是	string	维修内容
 * equipmentMaintainReason	是	int	故障原因（1 操作失误 2例行保养 3检点不到位 4正常配件更换 5其他)
 */

var processedEquipment = function processedEquipment(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/Equipment/ProcessedEquipment', 'equipmentId=' + data.equipmentId + '&equipmentMaintainResult=' + data.equipmentMaintainResult + '&equipmentMaintainContent=' + data.equipmentMaintainContent + '&equipmentMaintainReason=' + data.equipmentMaintainReason);
};

/**
 * 新增设备
 * 参数名	必选	类型	说明
 * equipmentMaintenanceCycle	是	int	维修周期
 * equipmentDepartmentId	是	int	设备使用部门（1研发部 2生产部 3质量部 4 仓库部）
 * equipmentStationId	是	Long	所在工位id
 * equipmentRemarks	否	string	备注
 * equipmentNumber	是	string	设备编号
 * equipmentManufacturer	是	string	设备制造厂商
 * equipmentFactoryNumber	是	string	出厂编号
 * equipmentInitiateState	是	int	设备启用状态(1/已启用 2/委外维修中 3/维修中)
 * equipmentPurchaseTime	是	Date	设备购置时间
 * equipmentName	是	string	设备名称
 * equipmentModel	是	string	设备型号
 */

var addEquipment = function addEquipment(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/Equipment/addEquipment', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 编辑设备
 * 参数名	必选	类型	说明
 * equipmentId	是	Long	设备主键id
 * equipmentMaintenanceCycle	是	int	维修周期
 * equipmentDepartmentId	是	int	设备使用部门（1研发部 2生产部 3质量部 4 仓库部）
 * equipmentStationId	是	Long	所在工位id
 * equipmentRemarks	否	string	备注
 * equipmentNumber	是	string	设备编号
 * equipmentManufacturer	是	string	设备制造厂商
 * equipmentFactoryNumber	是	string	出厂编号
 * equipmentInitiateState	是	int	设备启用状态(1/已启用 2/委外维修中 3/维修中)
 * equipmentPurchaseTime	是	Date	设备购置时间
 * equipmentName	是	string	设备名称
 * equipmentModel	是	string	设备型号
 */

var updateEquipment = function updateEquipment(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/Equipment/updateEquipment', 'equipmentId=' + data.equipmentId + '&equipmentMaintenanceCycle=' + data.equipmentMaintenanceCycle + '&equipmentDepartmentId=' + data.equipmentDepartmentId + '&equipmentStationId=' + data.equipmentStationId + '&equipmentRemarks=' + data.equipmentRemarks + '&equipmentNumber=' + data.equipmentNumber + '&equipmentManufacturer=' + data.equipmentManufacturer + '&equipmentFactoryNumber=' + data.equipmentFactoryNumber + '&equipmentInitiateState=' + data.equipmentInitiateState + '&equipmentPurchaseTime=' + data.equipmentPurchaseTime + '&equipmentName=' + data.equipmentName + '&equipmentModel=' + data.equipmentModel);
};

/**
 * 模具工装列表(无分页)
 */

var findMouldToolsListNoPage = function findMouldToolsListNoPage(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/mouldtools/findMouldToolsListNoPage');
};

/**
 * 模具工装列表
 * 参数名	必选	类型	说明
 * mouldToolsType	否	int	模具工装类型(1拉伸-凸模，2拉伸-凹模，3拉伸-切边模，4拉伸-翻边模，5冲压-落料，6冲压-冲孔，7冲压-成型，8冲压-整形)
 * mouldToolsNumber	否	string	模具工装编号
 * mouldToolsName	否	string	模具工装名称
 * mouldToolsTypeId	否	long	模具工装类型名称
 * mouldToolsState 是 int	状态(1/使用中 2/报废 3/维修中)
 * mouldToolsProcedureName 否 string 工序名称
 * pageIndex	否	Integer	当前页数
 * pageSize	否	Integer	页大小
 */

var mouldtoolsList = function mouldtoolsList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/mouldtools/findMouldToolsList', { params: data });
};

/**
 * 模具工装新增
 * 参数名	必选	类型	说明
 * mouldToolsName	是	string	模具名称
 * mouldToolsNumber	是	string	模具工装编号
 * mouldToolsType	是	int	模具工装类型(1拉伸-凸模，2拉伸-凹模，3拉伸-切边模，4拉伸-翻边模，5冲压-落料，6冲压-冲孔，7冲压-成型，8冲压-整形)
 * mouldToolsModel	是	String	模具工装型号
 */

var addMouldTools = function addMouldTools(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/mouldtools/add', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 模具工装详情
 * 参数名	必选	类型	说明
 * mouldToolsId	是	Long	模具工装主键id
 */

// let mouldToolsDetail = (mouldToolsId) => axios.post(`/erp_back/mouldtools/mouldToolsDetail`, `mouldToolsId=${mouldToolsId}`);
var mouldToolsDetail = function mouldToolsDetail(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/mouldtools/mouldToolsDetail', { params: data });
};

/**
 * 模具工装编辑
 * 参数名	必选	类型	说明
 * mouldToolsId	是	Long	模具工装主键id
 * mouldToolsNumber	否	string	模具工装编号
 * mouldToolsName	否	string	模具工装名称
 * mouldToolsModel	否	string	模具工装型号
 * mouldToolsType	否	int	模具工装类型(1拉伸-凸模，2拉伸-凹模，3拉伸-切边模，4拉伸-翻边模，5冲压-落料，6冲压-冲孔，7冲压-成型，8冲压-整形)
 */

// let updateMouldTools = (data) => axios.post(`/erp_back/mouldtools/updateMouldTools`, `mouldToolsId=${data.mouldToolsId}&mouldToolsNumber=${data.mouldToolsNumber}&mouldToolsName=${data.mouldToolsName}&mouldToolsModel=${data.mouldToolsModel}&mouldToolsType=${data.mouldToolsType}`);
var updateMouldTools = function updateMouldTools(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/mouldtools/update', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 删除模具工装
 * 参数名	必选	类型	说明
 * mouldToolsId	是	Long	模具工装主键id
 */

var deleteMouldTools = function deleteMouldTools(mouldToolsId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/mouldtools/deleteMouldTools', 'mouldToolsId=' + mouldToolsId);
};

/**
 * 模具工装类型列表
 * 参数名	必选	类型	说明
 */

var mouldTypeList = function mouldTypeList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/mouldType/list', '');
};

/**
 * 新建模具工装类型
 * 参数名	必选	类型	说明
 * mouldTypeName	是	String	模具工装类型name
 * mouldTypePid	否	Long	父类型id
 */

var addMouldType = function addMouldType(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/mouldType/add', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 上传模具图纸
 * @param file
 */
var uploadDrawing = function uploadDrawing(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/mouldtools/uploadDrawing', data, { headers: { 'Content-Type': 'multipart/form-data' } });
};

/**
 * 模具图纸历史列表
 */

var drawingHistoryList = function drawingHistoryList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/mouldtools/drawingHistoryList', { params: data });
};

/**
 * 装拆模任务列表
 */

var mouldtoolsUseList = function mouldtoolsUseList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/mouldtoolsUse/list', { params: data });
};

/**
* 装拆模任务列表
*/

var mouldtoolsUseDetail = function mouldtoolsUseDetail(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/mouldtoolsUse/useDetail', { params: data });
};

/**
  * 新建装拆模任务
  * 参数名	必选	类型	说明
  */

var createMouldtoolsUse = function createMouldtoolsUse(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/mouldtoolsUse/add', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
  * 编辑装拆模任务
  * 参数名	必选	类型	说明
  */

var updateMouldtoolsUse = function updateMouldtoolsUse(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/mouldtoolsUse/update', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 删除装拆模任务
 * 参数名	必选	类型	说明
 */

var delelteMouldtoolsUse = function delelteMouldtoolsUse(equipmentId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/mouldtoolsUse/delete', 'mouldToolsUseId=' + mouldToolsUseId);
};

/**
* 根据工序id查询模具工装
* 参数名	必选	类型	说明
*/
var findMouldToolsByProcedureId = function findMouldToolsByProcedureId(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/mouldtools/findMouldToolsByProcedureId', { params: data });
};
// let findMouldToolsByProcedureId = () => axios.get(`/erp_back/mouldType/list`, '');

/**
 * 通知拆模
 * 参数名	必选	类型	说明
 */
var mouldToolsNofityUnload = function mouldToolsNofityUnload(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/mouldtoolsUse/nofityUnload', 'mouldToolsUseId=' + data.mouldToolsUseId);
};

/**
 * 工位列表
 * 参数名	必选	类型	说明
 * areaId	否	Long	区域id
 * stationNumber	否	string	工位号
 * pageIndex	否	Integer	当前页数
 * pageSize	否	Integer	页大小
 */

var findStation = function findStation(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/station/findStation', 'areaId=' + data.areaId + '&stationNumber=' + data.stationNumber + '&pageIndex=' + data.pageIndex + '&pageSize=' + data.pageSize);
};

/**
 * 生产物管理列表
 * 参数名	必选	类型	说明
 * areaId	否	Long	区域id
 * stationNumber	否	string	工位号
 * pageIndex	否	Integer	当前页数
 * pageSize	否	Integer	页大小
 */

var creationList = function creationList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/creation/creationList', 'areaId=' + data.areaId + '&stationNumber=' + data.stationNumber + '&pageIndex=' + data.pageIndex + '&pageSize=' + data.pageSize);
};

/**
 * 工位列表(无分页)
 */

var findStationNoPage = function findStationNoPage(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/station/findStationNoPage');
};

/**
 * 工位打印二维码
 * stationId	是	long	工位id
 */

var getStationQrCode = function getStationQrCode(stationId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/station/getStationQrCode?stationId=' + stationId);
};

/**
 * 新增工位
 * 参数名	必选	类型	说明
 * stationLocation	是	string	工位位置描述
 * areaId	是	Long	区域id
 * stationNumber	是	string	工位号
 */

var addStation = function addStation(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/station/addStation', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 编辑工位
 * 参数名	必选	类型	说明
 * stationId	是	Long	工位主键id
 * areaId	否	Long	区域ID
 * stationNumber	否	string	工位号
 * stationLocation	否	工位位置描述
 */

var updateStation = function updateStation(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/station/updateStation', 'stationId=' + data.stationId + '&areaId=' + data.areaId + '&stationNumber=' + data.stationNumber + '&stationLocation=' + data.stationLocation);
};

/**
 * 删除工位
 * 参数名	必选	类型	说明
 * stationId	是	Long	工位主键id
 */

var deleteStation = function deleteStation(stationId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/station/deleteStation', 'stationId=' + stationId);
};

/**
 * 工位详情
 * 参数名	必选	类型	说明
 * stationId	是	Long	工位主键id
 */

var findStationById = function findStationById(stationId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/station/findStationById', 'stationId=' + stationId);
};

/**
 * 通知模板列表
 * 参数名	必选	类型	说明
 * roleId	否	Long	角色主键id
 * messageTemplateState	否	int	模板状态(1/使用 2/冻结 0/删除)
 * pageIndex	否	Integer	当前页数
 * pageSize	否	Integer	页大小
 */

var findMessageTemplates = function findMessageTemplates(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/messagetemplate/findMessageTemplates', 'roleId=' + data.roleId + '&messageTemplateState=' + data.messageTemplateState + '&pageIndex=' + data.pageIndex + '&pageSize=' + data.pageSize);
};

/**
 * 设置角色
 * 参数名	必选	类型	说明
 * roleId	否	Long	角色主键id， 是一个Long类型的数组
 * messageTemplateId	是	Long	通知模板主键id
 */

var setRole = function setRole(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/messagetemplate/setRole', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 查找关联角色id
 * 参数名	必选	类型	说明
 * messageTemplateId	是	Long	通知模板主键id
 */

var findMessageTemplatesById = function findMessageTemplatesById(messageTemplateId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/messagetemplate/findMessageTemplatesById', 'messageTemplateId=' + messageTemplateId);
};

/**
 * 冻结通知模板
 * 参数名	必选	类型	说明
 * messageTemplateId	是	Long	通知模板主键id
 */

var freezeMessageTemplate = function freezeMessageTemplate(messageTemplateId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/messagetemplate/freezeMessageTemplate', 'messageTemplateId=' + messageTemplateId);
};

/**
 * 解冻通知模板
 * 参数名	必选	类型	说明
 * messageTemplateId	是	Long	通知模板主键id
 */

var thaweMessageTemplate = function thaweMessageTemplate(messageTemplateId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/messagetemplate/thaweMessageTemplate', 'messageTemplateId=' + messageTemplateId);
};

/**
 * 通知记录
 * 参数名	必选	类型	说明
 * messageType	是	string	用户名
 * roleName	是	string	角色名
 * adminName	否	string	昵称
 * pageIndex	否	Integer	当前页数
 * pageSize	否	Integer	页大小
 */

var findMessage = function findMessage(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/messagetemplate/findMessage', 'messageType=' + data.messageType + '&roleName=' + data.roleName + '&adminName=' + data.adminName + '&pageIndex=' + data.pageIndex + '&pageSize=' + data.pageSize);
};

//检验工作数据管理

//生产任务管理
/**
 * 生产需求单列表接口
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	int	页面量
 * state	是	int	状态（0/未处理 1/已处理）
 * type	否	int	订单类型 (1/国内 2/国外）
 * number	否	string	订单编号
 */

var getOrdersList = function getOrdersList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/requirements/getOrdersList', { params: data });
};

/**
 * 生产移交记录列表
 * 参数名	必选	类型	说明
 * @param pageIndex				页码
 * @param pageSize				每页显示条数
 * @param sendAdminName				移交负责人
 * @param getAdminName				接收人
 * @param sendProcedureName			移交工序
 * @param getProcedureName			接受工序
 * @param productionTaskNum			生产任务号
 * @param createTime				申请时间
 * @param checkTime					确认时间
 */

var creationAdminList = function creationAdminList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/creationAdmin/creationAdminList', { params: data });
};

/**
 * 员工工资统计
 * 参数名	必选	类型	说明
 * @param pageIndex				页码
 * @param pageSize				每页显示条数
 * @param teamsId				班组
 * @param name				接收人
 * @param startTime		
 * @param endTime			
 */
var getSalaryList = function getSalaryList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/salary/list', { params: data });
};

/**
 * 生产需求单修改记录列表接口
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	int	页面量
 * ordersId	是	long	订单id
 */

var logList = function logList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/requirements/logList', { params: data });
};

/**
 * 生产需求单修改记录详情
 * 参数名	必选	类型	说明
 * productionTaskId	是	long	需求单id
 */

var logInfo = function logInfo(productionTaskId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/requirements/logInfo?productionTaskId=' + productionTaskId);
};

/**
 * 未处理订单详情接口
 * 参数名	必选	类型	说明
 * ordersId	是	long	订单id
 */

var productionOrderInfo = function productionOrderInfo(ordersId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/requirements/orderInfo', 'ordersId=' + ordersId);
};

/**
 * 需求单信息接口
 * 参数名	必选	类型	说明
 * ordersId	是	long	订单id
 */

var requirementsInfo = function requirementsInfo(ordersId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/requirements/requirementsInfo', 'ordersId=' + ordersId);
};

/**
 * 点击生成需求单接口
 * 参数名	必选	类型	说明
 * ordersId	是	long	订单id
 */

var firstGenerate = function firstGenerate(ordersId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/requirements/firstGenerate', 'ordersId=' + ordersId);
};

/**
 * 半成品列表
 * 参数名	必选	类型	说明
 */

var halfProductList = function halfProductList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/requirements/halfProductList');
};

/**
 * 生产需求单设置产品生产数量接口
 * 参数名	必选	类型	说明
 * ordersId	是	long	订单id
 * halfNumJson	是	string	半成品生产计划条目数据
 * finishNumJson	是	string	产品生产计划条目数据
 * newHalfProductsJson	是	string	新的半成品备货条目数据
 * endTime	是	date	计划截止时间
 */
var secondGenerate = function secondGenerate(ordersId, halfNumJson, finishNumJson, newHalfProductsJson, endTime) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/requirements/secondGenerate', 'ordersId=' + ordersId + '&halfNumJson=' + halfNumJson + '&finishNumJson=' + finishNumJson + '&newHalfProductsJson=' + newHalfProductsJson + '&endTime=' + endTime);
};

/**
 * 取消需求单接口
 * 参数名	必选	类型	说明
 * ordersId	是	long	订单id
 */

var rejectGenerate = function rejectGenerate(ordersId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/requirements/rejectGenerate', 'ordersId=' + ordersId);
};

/**
 * 发布需求单，组装条目的时间接口
 * 参数名	必选	类型	说明
 * ordersId	是	long	订单id
 * procurementNumJson	是	string	采购计划条目数据
 * procurementTimesJson	是	string	采购条目时间
 * productionTimesJson	是	string	生产计划时间
 */
var publishGenerate = function publishGenerate(ordersId, procurementNumJson, procurementTimesJson, productionTimesJson) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/requirements/publishGenerate', 'ordersId=' + ordersId + '&procurementNumJson=' + procurementNumJson + '&procurementTimesJson=' + procurementTimesJson + '&productionTimesJson=' + productionTimesJson);
};

/**
 * 订单-需求单列表接口
 * 参数名	必选	类型	说明
 */

var productionTaskList = function productionTaskList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/orderschedule/productionTaskList');
};

/**
 * 订单-需求单列表接口
 * 参数名	必选	类型	说明
 */

var getOrdersByprogress = function getOrdersByprogress() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/progress/getOrders');
};

/**
 * 订单排期更新时间接口
 * 参数名	必选	类型	说明
 * productionTaskId	是	long	需求单id
 * procurementTimesJson	是	string	采购计划条目时间
 * productionTimesJson	是	string	生产计划时间
 */
var changeTimes = function changeTimes(productionTaskId, productionTaskDeadline, procurementTimesJson, productionTimesJson) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/orderschedule/changeTimes', 'productionTaskId=' + productionTaskId + '&productionTaskDeadline=' + productionTaskDeadline + '&procurementTimesJson=' + procurementTimesJson + '&productionTimesJson=' + productionTimesJson);
};

/**
 * 需求单-生产计划-工序安排详细表接口
 * 参数名	必选	类型	说明
 */

var productionTaskListRelease = function productionTaskListRelease() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/productionTaskAllocation/productionTaskList');
};

/**
 * 同班组人员列表接口
 * 参数名	必选	类型	说明
 * adminName	否	string	职员名称
 */

var productionTaskAdminList = function productionTaskAdminList(adminName) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/productionTaskAllocation/adminList?adminName=' + adminName);
};

/**
 * 员工工序任务详情接口
 * 参数名	必选	类型	说明
 * productionAdminId	是	long	工序任务id
 */

var findAdminProcessInfo = function findAdminProcessInfo(productionAdminId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/productionTaskAllocation/findAdminProcessInfo', 'productionAdminId=' + productionAdminId);
};

/**
 * 更新已分配的员工工序任务时间安排接口
 * 参数名	必选	类型	说明
 * productionAdminId	是	long	人员工序任务id
 * startTime	是	date	开始时间
 * endTime	否	date	结束时间
 */

var updateAdminProcessTime = function updateAdminProcessTime(productionAdminId, startTime, endTime) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/productionTaskAllocation/updateAdminProcessTime', 'productionAdminId=' + productionAdminId + '&startTime=' + startTime + '&endTime=' + endTime);
};

/**
 * 转移工序任务接口
 * 参数名	必选	类型	说明
 * productionAdminId	是	long	员工工序任务
 * newAdminId	是	long	新的更改人员id
 * startTime	否	date	任务开始时间
 * endTime	否	date	任务结束时间
 */

var changeAdminProcess = function changeAdminProcess(productionAdminId, startTime, endTime, newAdminId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/productionTaskAllocation/changeAdminProcess', 'productionAdminId=' + productionAdminId + '&startTime=' + startTime + '&endTime=' + endTime + '&newAdminId=' + newAdminId);
};

/**
 * 获取产品工序任务排期中上一步工序开始时间接口
 * 参数名	必选	类型	说明
 * id	是	long	本次工序分配id
 * type	是	int	获取类型(1/从订单任务列表往时间排序表拉（id传工序分配任务id） 2/其他拖拽情况（id传员工工序任务id）)
 */

var getLastWorkstageStartTime = function getLastWorkstageStartTime(id, type) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/productionTaskAllocation/getLastWorkstageStartTime', 'id=' + id + '&type=' + type);
};

/**
 * 工序任务分配人员接口
 * 参数名	必选	类型	说明
 * productionWorkstageId	是	long	工序安排任务id
 * adminId	是	long	人员id
 * number	是	string	分配数量
 * startTime	是	date	任务开始时间
 * endTime	是	date	任务结束时间
 * timeConsuming	是	string	预计工时
 */

var allocationProcessToAdmin = function allocationProcessToAdmin(productionWorkstageId, adminId, number, startTime, endTime, timeConsuming) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/productionTaskAllocation/allocationProcessToAdmin', 'productionWorkstageId=' + productionWorkstageId + '&adminId=' + adminId + '&number=' + number + '&startTime=' + startTime + '&endTime=' + endTime + '&timeConsuming=' + timeConsuming);
};

/**
 * 员工工序任务平移接口
 * 参数名	必选	类型	说明
 * translationJson	是	string	工序任务时间段拼接串
 */

var processMissionTranslation = function processMissionTranslation(translationJson) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/productionTaskAllocation/processMissionTranslation', 'translationJson=' + translationJson);
};

/**
 * 变更员工工序任务数量,时间接口
 * 参数名	必选	类型	说明
 * productionWorkstageId	是	long	生产计划工序分配任务id
 * productionAdminId	是	long	人员工序任务id
 * number	否	string	更改数量
 * startTime	否	date	开始时间
 * endTime	否	date	结束时间
 */

var recallAdminProcess = function recallAdminProcess(productionAdminId, number, startTime, endTime) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/productionTaskAllocation/recallAdminProcess', 'productionAdminId=' + productionAdminId + '&number=' + number + '&startTime=' + startTime + '&endTime=' + endTime);
};

/**
 * 获取工序任务安排预计工时接口
 * 参数名	必选	类型	说明
 * number	是	string	分配数量
 * procedureId	是	long	工序id
 */

var countReferenceTime = function countReferenceTime(number, procedureId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/productionTaskAllocation/countReferenceTime', 'number=' + number + '&procedureId=' + procedureId);
};

//订单管理


/**
 *  订单列表
 * @param pageIndex 页码
 * @param pageSize  页面量
 * @param ordersType  订单类型
 * @param createStartTime   时间选择区段
 * @param createEndTime   时间选择区段
 * @param clientName    客户名称
 * @param ordersNum   订单编号
 * @param orderState    订单状态
 */
var findByCondition = function findByCondition(pageIndex, pageSize, ordersType, createStartTime, createEndTime, clientName, ordersNum, orderState) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/orders/findByCondition?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&ordersType=' + ordersType + '&createStartTime=' + createStartTime + '&createEndTime=' + createEndTime + '&clientName=' + clientName + '&ordersNum=' + ordersNum + '&orderState=' + orderState);
};

/**
 *  订单修改记录列表
 * @param pageIndex 页码
 * @param pageSize  页面量
 * @param time  时间
 * @param adminName   修改人员
 * @param ordersNumber   订单编号
 */
var ordersLogList = function ordersLogList(pageIndex, pageSize, time, adminName, ordersNumber) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/orders/ordersLogList?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&time=' + time + '&adminName=' + adminName + '&ordersNumber=' + ordersNumber);
};

/**
 * 订单修改日志详情
 * @param ordersLogId   历史订单id
 */
var ordersLogDetail = function ordersLogDetail(ordersLogId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/orders/ordersLogDetail', { params: { ordersLogId: ordersLogId } });
};

/**
 * 删除订单
 * @param oId 订单id
 */
var deleteOrders = function deleteOrders(oId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/orders/deleteOrders', 'oId=' + oId);
};

/**
 * 跟进订单信息
 * @param ordersId    订单id
 */
var followOrders = function followOrders(ordersId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/orders/followOrders', 'ordersId=' + ordersId);
};

/**
 * 订单确认生产完成
 * @param orderId 订单id
 */
var makeSureProduct = function makeSureProduct(orderId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/orders/makeSureProduct', 'orderId=' + orderId);
};

/**
 * 坏账接口
 * @param orderId 订单id
 */
var badDebt = function badDebt(ordersId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/orders/badDebt', 'ordersId=' + ordersId);
};

/**
 * 确认签收接口
 * @param orderId 订单id
 */
var ordersConfirmReceipt = function ordersConfirmReceipt(orderId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/orders/ordersConfirmReceipt', 'ordersId=' + orderId);
};

/**
 * 订单详情
 * @param ordersId
 */
var ordersDetail = function ordersDetail(ordersId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/orders/ordersDetail', { params: { ordersId: ordersId } });
};

/**
 *  订单审核列表
 * @param pageIndex 页码
 * @param pageSize  页面量
 * @param ordersType  订单类型
 * @param createStartTime   时间选择区段
 * @param createEndTime   时间选择区段
 * @param clientName    客户名称
 * @param ordersNum   订单编号
 * @param orderCheckState    订单审核状态1待审核 2已审核 3 已取消
 */
var ordersCheckList = function ordersCheckList(pageIndex, pageSize, ordersType, createStartTime, createEndTime, clientName, ordersNum, orderCheckState) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/ordersCheck/findByCheckOrder?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&ordersType=' + ordersType + '&createStartTime=' + createStartTime + '&createEndTime=' + createEndTime + '&clientName=' + clientName + '&ordersNum=' + ordersNum + '&orderCheckState=' + orderCheckState);
};

/**
 *  取消订单接口
 * @param ordersId   订单id
 */
var deleteCheckOrders = function deleteCheckOrders(ordersId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/ordersCheck/deleteCheckOrders', 'ordersId=' + ordersId);
};

/**
 *  订单审核通过
 * @param ordersId   订单id
 */
var passCheck = function passCheck(ordersId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/ordersCheck/passOrders', 'ordersId=' + ordersId);
};

/**
 *  订单审核详情
 * @param ordersId   订单id
 */
var ordersCheckDetail = function ordersCheckDetail(ordersId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/ordersCheck/ordersCheckDetail', { params: { ordersId: ordersId } });
};

/**
 *  录入接口
 */
var addOrders = function addOrders(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/orders/addOrders', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 *  编辑接口
 */
var editOrders = function editOrders(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/orders/editOrders', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 *  拆分接口
 */
var splitOrders = function splitOrders(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/orders/splitOrders', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 *  客户列表
 */
var getSalesmanByPermission = function getSalesmanByPermission(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/admin/getSalesmanByPermission');
};

/**
 *  可订购产品列表
 */
var canBuyProductList = function canBuyProductList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/orders/canBuyProductList');
};

/**
 *  可订购产品列表
 *  clientId	是	long	客户id
 */
var historyProduct = function historyProduct(clientId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/orders/historyProduct', 'clientId=' + clientId);
};

/**
 *  获取汇率
 *  rateType 1人名币2美元3欧元
 */
var getRate = function getRate(rateType) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/rate/getRate', { params: { rateType: rateType } });
};

//仓库管理
/**
 * 采购入库列表接口
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	int	每页条数
 * qualityState	否	int	质检状态 （1未质检2质检中3已完成)
 * planState	否	int	采购状态(1采购中2已完成3已入库)
 * startFinishTime	否	date	截止起始时间
 * endFinishTime	否	date	截止结束时间
 * materialName	否	string	材料名称
 * materialsNumber	否	string	材料编号
 * productionTaskNum	否	string	生产需求单号
 * purchaseState	否	int	生产需求采购状态（1未完成2完成 ）
 */

var purchaseImportList = function purchaseImportList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/procurementPlan/list', { params: data });
};

var getStocktakesNum = function getStocktakesNum() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/stocktakes/getStocktakesNum');
};

/**
 * 采购详情接口
 * 参数名	必选	类型	说明
 * productiveTaskId	是	long	生产任务号
 */

var purchaseImportDetail = function purchaseImportDetail(productiveTaskId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/procurementPlan/detail?productiveTaskId=' + productiveTaskId);
};

/**
 * 通知质检员接口
 * 参数名	必选	类型	说明
 * procurementPlanId	是	long	采购计划id
 */

var notifyCheck = function notifyCheck(procurementPlanId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/procurementPlan/notifyCheck?procurementPlanId=' + procurementPlanId);
};

/**
 * 生产入库通知质检员接口
 * 参数名	必选	类型	说明
 * productionPlanId	是	long	生产入库id
 */

var notifyCheckProduct = function notifyCheckProduct(productionPlanId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/procurementPlan/notifyCheckProduct?productionPlanId=' + productionPlanId);
};
/**
 * 采购计划查看库存或存储历史记录接口
 * 参数名	必选	类型	说明
 * procurementPlanId	是	long	采购计划id
 */

var planDetail = function planDetail(procurementPlanId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/procurementPlan/planDetail?procurementPlanId=' + procurementPlanId);
};

/**
 * 获取所有区域的接口
 */

var allAreaList = function allAreaList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/area/allAreaList');
};

/**
 * 获取所有区域的接口
 */

var allGongWeiAreaList = function allGongWeiAreaList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/area/allGongWeiAreaList');
};

/**
 * 获取所有区域的接口
 */

var allHuojiaAreaList = function allHuojiaAreaList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/area/allHuojiaAreaList');
};

/**
 * 获取所有区域的接口
 * areaId
 */

var getByAreaId = function getByAreaId(areaId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/storageRack/getByAreaId?areaId=' + areaId);
};

/**
 * 获取盘库所需货架接口
 * areaId
 */

var getStorageRackByStock = function getStorageRackByStock(areaId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/storageRack/getStorageRackByStock?areaId=' + areaId);
};

/**
 * 采购入库入库接口
 * procurementPlanId	是	long	采购条目id
 * storageRackId	是	long	货架id
 * enterNum	是	double	入库量
 */

var warehousingEnter = function warehousingEnter(procurementPlanId, storageRackId, enterNum) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/procurementPlan/enter?procurementPlanId=' + procurementPlanId + '&storageRackId=' + storageRackId + '&enterNum=' + enterNum);
};

/**
 * 货架列表接口
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	int	每页显示条数
 * areaName	否	string	区域名
 * storageRackType	否	int	货架类型(1/大 2/中 3/小)
 * storageRackNumber	否	string	货架编号
 */

var goodsShelvesList = function goodsShelvesList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/storageRack/list', { params: data });
};

/**
 * 货架删除接口
 * 参数名	必选	类型	说明
 * storageRackId	是	long	货架id
 */

var storageRackDelete = function storageRackDelete(storageRackId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/storageRack/delete?storageRackId=' + storageRackId);
};

/**
 * 货架详情接口
 * 参数名	必选	类型	说明
 * storageRackId	是	long	货架id
 */

var storageRackDetail = function storageRackDetail(storageRackId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/storageRack/detail?storageRackId=' + storageRackId);
};

/**
 * 打印货架二维码货架接口
 * 参数名	必选	类型	说明
 * storageRackId	是	long	货架id
 */

var getStorageRackQrCode = function getStorageRackQrCode(storageRackId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/storageRack/getQrCode?storageRackId=' + storageRackId);
};

/**
 * 货架新增接口
 * 参数名	必选	类型	说明
 * storageRackAreaId	是	long	区域id
 * storageRackNumber	是	string	货架号
 * storageRackType	是	int	货架类型(1/大 2/中 3/小)
 */

var storageRackAdd = function storageRackAdd(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/storageRack/add', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 货架更新接口
 * 参数名	必选	类型	说明
 * storageRackId	是	long	货架主键
 * storageRackAreaId	是	long	区域id
 * storageRackNumber	是	string	货架号
 * storageRackType	是	int	货架类型(1/大 2/中 3/小)
 */

var storageRackUpdate = function storageRackUpdate(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/storageRack/update', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 得到区最大货架号
 * 参数名	必选	类型	说明
 * areaId
 */

var getMaxAreaNum = function getMaxAreaNum(areaId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/storageRack/getMaxAreaNum?areaId=' + areaId);
};

/**
 * 区域列表接口
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	int	页面量
 * keyWord	否	string	关键字
 * type	否	int	区域类型（”货架管理”, 0), (“工位管理”, 1）
 */

var areaList = function areaList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/area/areaList', { params: data });
};

/**
 * 区域删除接口
 * 参数名	必选	类型	说明
 * areaId	是	long	区域id
 */

var deleteArea = function deleteArea(areaId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/area/deleteArea', 'areaId=' + areaId);
};

/**
 * 区域打印二维码
 * @param areaId
 */
var printingQRode = function printingQRode(areaId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/area/printingQRode', 'areaId=' + areaId);
};

/**
 * 区域新增接口
 * 参数名	必选	类型	说明
 * areaName	是	string	区域名称
 * areaLocation	是	string	区域位置描述
 * areaType	是	int	区域类型
 */

var addArea = function addArea(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/area/addArea', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 区域编辑接口
 * 参数名	必选	类型	说明
 * areaId	是	long	区域id
 * areaName	是	string	区域名称
 * areaLocation	是	string	区域位置描述
 * areaType	是	int	区域类型
 */

var editArea = function editArea(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/area/editArea', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 区域详情接口
 * 参数名	必选	类型	说明
 * areaId	是	long	区域id
 */

var areaInfo = function areaInfo(areaId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/area/areaInfo', 'areaId=' + areaId);
};

/**
 * 盘库任务列表接口
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	int	页面量
 * state	是	int	任务状态（1盘库中 2审核中 3已完成 4已驳回 0/删除标志）
 * startTime	否	date	任务开始时间
 * endTime	否	date	任务截止时间
 * number	否	string	任务编号
 */

var stocktakesList = function stocktakesList(pageIndex, pageSize, state, startTime, endTime, number) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/stocktakes/stocktakesList?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&state=' + state + '&startTime=' + startTime + '&endTime=' + endTime + '&number=' + number);
};

/**
 * 删除盘库任务
 * @param stocktakesId    盘库任务id
 * @returns {*|void}
 */
var deleteStocktake = function deleteStocktake(stocktakesId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/stocktakes/deleteStocktake', 'stocktakesId=' + stocktakesId);
};

/**
 * 盘库任务新增接口
 * 参数名	必选	类型	说明
 * ids	是	string	货架id组
 * stocktakesNumber	是	string	任务编号
 * stocktakesAdminId	是	long	负责人id
 * stocktakesEndTime	是	date	截止日期
 */

var addStocktakes = function addStocktakes(stocktakesNumber, stocktakesAdminId, stocktakesEndTime, ids) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/stocktakes/addStocktakes', 'stocktakesNumber=' + stocktakesNumber + '&stocktakesAdminId=' + stocktakesAdminId + '&stocktakesEndTime=' + stocktakesEndTime + '&ids=' + ids);
};

/**
 * 盘库任务详情接口
 * 参数名	必选	类型	说明
 * stocktakesId	是	long	任务主键id
 */

var stocktakesInfo = function stocktakesInfo(stocktakesId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/stocktakes/stocktakesInfo', 'stocktakesId=' + stocktakesId);
};

/**
 * 盘库任务提交审核接口
 * 参数名	必选	类型	说明
 * stocktakesId	是	long	任务主键id
 */

var submitApproval = function submitApproval(stocktakesId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/stocktakes/submitApproval', 'stocktakesId=' + stocktakesId);
};

/**
 * 采购完成接口
 * 参数名	必选	类型	说明
 * productiveTaskId	是	long	生产任务id
 */

var procurementPlanBuyOver = function procurementPlanBuyOver(productiveTaskId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/procurementPlan/buyOver?productiveTaskId=' + productiveTaskId);
};

/**
 * 生产入库管理列表接口
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	int	每页条数
 * productionType	否	string	类型 1/产品 2/半成品生产）
 * startFinishTime	否	string	计划起始时间
 * endFinishTime	否	date	计划结束时间
 * productNumber	否	string	产品编号
 * productionTaskNum	否	string	生产需求单号
 * productionTaskState	否	int	生产需求生产状态（1未完成2完成 ）
 */

var productionInventoryList = function productionInventoryList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/productionPlan/list', { params: data });
};

/**
 * 生产入库详情接口
 * 参数名	必选	类型	说明
 * productionTaskId	是	long	生产任务id
 */

var productionInventoryDetail = function productionInventoryDetail(productionTaskId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/productionPlan/detail?productionTaskId=' + productionTaskId);
};

/**
 * 生产计划查看库存或存储历史记录接口
 * 参数名	必选	类型	说明
 * productionPlanId	是	long	生产计划id
 */

var productionInventoryPlanDetail = function productionInventoryPlanDetail(productionPlanId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/productionPlan/planDetail?productionPlanId=' + productionPlanId);
};

/**
 * 生产计划入库操作接口
 * 参数名	必选	类型	说明
 * productionPlanId	是	long	生产计划id
 * storageRackId	是	long	货架id
 * enterNum	是	double	入库量
 */

var productionInventoryPlanEnter = function productionInventoryPlanEnter(productionPlanId, storageRackId, enterNum) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/productionPlan/enter?productionPlanId=' + productionPlanId + '&storageRackId=' + storageRackId + '&enterNum=' + enterNum);
};

/**
 * 生产计划确认入库操作接口
 * 参数名	必选	类型	说明
 * productionTaskId	是	long	生产任务id
 */

var productionInventoryPlanGetEnter = function productionInventoryPlanGetEnter(productionTaskId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/productionPlan/getEnter?productionTaskId=' + productionTaskId);
};

/**
 * 发货出库列表接口
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	int	每页条数
 * productionType	否	int	1品 2/半成品生产）
 * productionOutState	否	int	货状态 (1 待备货 2 备货中 3备货完成)
 * startDeliveryTime	否	date	交货起始时间
 * endDeliveryTime	否	string	交货结束时间
 * ordersNumber	否	string	订单号
 * ordersReceivingState	否	int	-1 已发货 2 未发货
 */

var deliveryOutList = function deliveryOutList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/productionPlan/outList', { params: data });
};

/**
 * 发货出库详情接口
 * 参数名	必选	类型	说明
 * productionTaskId	是	long	生产任务id
 */

var deliveryOutListDetail = function deliveryOutListDetail(productionTaskId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/productionPlan/outDetail?productionTaskId=' + productionTaskId);
};

/**
 * 发货出库出库接口
 * 参数名	必选	类型	说明
 * productionPlanId	是	long	生产计划id
 * storageRackId	是	long	货架id
 * outNum	是	double	出库量
 */

var deliveryOutListOut = function deliveryOutListOut(productionPlanId, storageRackId, outNum) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/productionPlan/out?productionPlanId=' + productionPlanId + '&storageRackId=' + storageRackId + '&outNum=' + outNum);
};

/**
 * 出库查看库存或存储历史记录接口
 * 参数名	必选	类型	说明
 * productionPlanId	是	long	生产计划id
 */

var deliveryoutPlanDetail = function deliveryoutPlanDetail(productionPlanId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/productionPlan/outPlanDetail?productionPlanId=' + productionPlanId);
};

/**
 * 确认发货接口
 * 参数名	必选	类型	说明
 * ordersId	是	long	订单id
 */

var deliveryoutSendProduct = function deliveryoutSendProduct(ordersId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/productionPlan/sendProduct?ordersId=' + ordersId);
};

/**
 * 生产领料列表接口
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	int	每页显示条数
 * adminName	否	int	领料人名称
 * goodsType	否	int	物料类型(-1 全部 1 原料 2半成品)
 * thingsName	否	string	物料名
 * thingsNumber	否	string	物料编号
 * taskNum	否	string	生产任务号
 * state	是	int	领料状态 (1待领取(未确认) 2已领取 3.未配好)
 */

var productionRequisitionList = function productionRequisitionList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/productionMaterials/list', { params: data });
};

/**
 * 生产领料领料详情接口
 * 参数名	必选	类型	说明
 * productionMaterialsId	是	long	员工生产领料关联主键
 */

var productionRequisitionDetail = function productionRequisitionDetail(productionMaterialsId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/productionMaterials/detail?productionMaterialsId=' + productionMaterialsId);
};

/**
 * 领料出库接口
 * 参数名	必选	类型	说明
 * productionMaterialsId	是	long	生产领料管理主键
 * storageList	是	list	货架出库量关联列表
 * storageRackId	是	long	货架id
 * outQuality	是	double	出库量
 */

var productionRequisitionOutWarehouse = function productionRequisitionOutWarehouse(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/productionMaterials/outWarehouse', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 材料列表接口
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	string	每页显示条数
 * areaId	否	long	区域id
 * storageRackId	否	long	货架id
 * number	是	string	编号
 * name	否	string	名
 * model	否	string	型号
 * type	是	string	物料类型 1原料 2产品 3 模具工装
 */

var materialstoolsList = function materialstoolsList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/storageRackCargo/thingsList', { params: data });
};

/**
 * 库存设置警戒值接口
 * 参数名	必选	类型	说明
 * goodsId	是	long	物品id
 * goodsClasses	是	string	物品类型1原料 2 成品半成品 3 模具
 * warningValue	是	double	警戒值
 */

var setWarning = function setWarning(goodsId, goodsClasses, warningValue) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/storageRackCargo/setWarning?goodsId=' + goodsId + '&goodsClasses=' + goodsClasses + '&warningValue=' + warningValue);
};

/**
 * 物料详情接口
 * 参数名	必选	类型	说明
 * goodsClasses	是	string	物料类型 1原料 2成品半成品 3 模具
 * goodsId	是	string	物料id
 */

var materialsListDetail = function materialsListDetail(goodsId, goodsClasses) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/storageRackCargo/detail?goodsId=' + goodsId + '&goodsClasses=' + goodsClasses);
};

/**
 * 盘库任务管理员工接口
 * 参数名	必选	类型	说明
 */

var getStocktakeAdminByPermission = function getStocktakeAdminByPermission() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/admin/getStocktakeAdminByPermission');
};

/**
 * 质检方案员工接口
 * 参数名	必选	类型	说明
 */

var getQualityAdminByPermission = function getQualityAdminByPermission() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/admin/getQualityAdminByPermission');
};

//财务管理
/**
 * 到款审核列表管理
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	int	每页显示条数
 * ordersType	否	int	订单类型(-1 全部 1/国内 2/国外 3/子订单)
 * ordersNum	是	string	密码
 * paymentState	是	int	收款支付状态(0 未付款1 已付款 )
 */

var paymentList = function paymentList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/ordersPaymentPlan/paymentList', { params: data });
};

/**
 * 收款计划详情接口
 * 参数名	必选	类型	说明
 * ordersPaymentPlanId	是	long	收款计划id
 */

var ordersPayDetail = function ordersPayDetail(ordersPaymentPlanId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/ordersPaymentPlan/detail?ordersPaymentPlanId=' + ordersPaymentPlanId);
};

/**
 * 开票确认接口
 * 参数名	必选	类型	说明
 * ordersPaymentPlanId	是	long	收款计划id
 * startTime	是	date	开票时间
 */

var startTicket = function startTicket(ordersPaymentPlanId, startTime) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/ordersPaymentPlan/startTicket?ordersPaymentPlanId=' + ordersPaymentPlanId + '&startTime=' + startTime);
};

/**
 * 确认收款接口
 * 参数名	必选	类型	说明
 * ordersPaymentPlanId	是	long	收款计划id
 * getTime	是	date	付款时间
 */

var getMoney = function getMoney(ordersPaymentPlanId, getTime) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/ordersPaymentPlan/getMoney?ordersPaymentPlanId=' + ordersPaymentPlanId + '&getTime=' + getTime);
};

/**
 * 付款审核管理列表接口
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	int	页面量
 * suppliersId	否	long	供应商id
 * productionTaskNum	否	string	需求单编号
 * payState	是	int	付款状态（1/未付款 2/已付款）
 */

var paymentCheckList = function paymentCheckList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/paymentCheck/paymentCheckList', { params: data });
};

/**
 * 供应商下拉列表接口
 */

var getSuppliersList = function getSuppliersList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/paymentCheck/getSuppliersList');
};

/**
 * 付款确认接口
 * 参数名	必选	类型	说明
 * procurementPlanId	是	long	采购计划id
 */

var makeSurePay = function makeSurePay(procurementPlanId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/paymentCheck/makeSurePay', 'procurementPlanId=' + procurementPlanId);
};

/**
 * 盘库审核列表接口
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	int	每页显示条数
 * stocktakesNum	否	string	任务号
 * stocktakesState	是	int	任务是否审核 2 未审核 3 已审核
 */

var libraryCheckList = function libraryCheckList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/stocktakes/checkList', { params: data });
};

/**
 * 盘库任务详情接口
 * 参数名	必选	类型	说明
 * stocktakesId	是	long	盘库任务id
 */

var librarycheckDetail = function librarycheckDetail(stocktakesId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/stocktakes/checkDetail?stocktakesId=' + stocktakesId);
};

/**
 * 通过或者驳回接口
 * 参数名	必选	类型	说明
 * stocktakesId	是	long	盘库任务id
 * state	是	int	审核结果 3 通过 4 驳回
 */

var librarycheckUpdate = function librarycheckUpdate(stocktakesId, state) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/stocktakes/update?stocktakesId=' + stocktakesId + '&state=' + state);
};

/**
 * 原材料价格审核列表接口
 * 参数名	必选	类型	说明
 * pageIndex	否	int	页码
 * pageSize	否	int	每页显示条数
 * materialsState	是	int	原材料申请状态(1/未审核 2/已审核)
 * materialsNumber	否	string	材料编号
 */

var listMaterialsPriceApply = function listMaterialsPriceApply(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/materials/listMaterialsPriceApply', { params: data });
};

/**
 * 原材料价格审核列表接口
 * 参数名	必选	类型	说明
 * materialsPriceApplyId	是	long	审核条目id
 */

var listMaterialsPriceDetail = function listMaterialsPriceDetail(materialsPriceApplyId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/materials/detail', 'materialsPriceApplyId=' + materialsPriceApplyId);
};

/**
 * 通过价格审核接口
 * 参数名	必选	类型	说明
 * materialsPriceApplyId	是	long	审核条目id
 */

var listMaterialsPriceAccept = function listMaterialsPriceAccept(materialsPriceApplyId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/materials/accept?materialsPriceApplyId=' + materialsPriceApplyId);
};

/**
 * 驳回价格审核接口
 * 参数名	必选	类型	说明
 * materialsPriceApplyId	是	long	审核条目id
 */

var listMaterialsPriceReject = function listMaterialsPriceReject(materialsPriceApplyId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/materials/reject?materialsPriceApplyId=' + materialsPriceApplyId);
};

//采购管理

//系统管理
/**
 *员工列表接口
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	int	每页显示条数
 * adminName	否	string	员工昵称
 * roleName	是	string	角色名
 * adminState	是	int	员工状态(1/使用 2/冻结 0/删除)
 * teamsId	否	long	班组id
 */

var adminList = function adminList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/admin/adminList', { params: data });
};

/**
 *所有角色接口
 */

var getRoleList = function getRoleList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/role/getRoleList');
};

/**
 *获取所有的班组接口
 */

var allTeamList = function allTeamList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/teams/allTeamList');
};

/**
 *员工删除接口
 * 参数名	必选	类型	说明
 * adminId	是	long	员工id
 */

var deleteAdmin = function deleteAdmin(adminId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/admin/deleteAdmin?adminId=' + adminId);
};

/**
 * 员工冻结接口
 * 参数名	必选	类型	说明
 * adminId	是	long	员工id
 */

var freezeAdmin = function freezeAdmin(adminId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/admin/freezeAdmin?adminId=' + adminId);
};

/**
 * 用户恢复接口
 * 参数名	必选	类型	说明
 * adminId	是	long	员工id
 */

var normalAdmin = function normalAdmin(adminId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/admin/normalAdmin?adminId=' + adminId);
};

/**
 * 员工新增接口
 * 参数名	必选	类型	说明
 * adminAccount	是	string	账号
 * password	是	string	密码
 * adminName	是	string	昵称
 * adminPhone	是	string	联系方式
 * adminIsQualityCheck	是	int	是否为质检员1质检员 0 非质检员
 * roleIdList	是	list	角色列表
 * teamsId	是	long	班组id
 */

var addAdmin = function addAdmin(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/admin/addAdmin', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 员工更新接口
 * 参数名	必选	类型	说明
 * adminId	是	long	员工主键
 * adminAccount	是	string	账号
 * password	是	string	密码
 * adminName	是	string	昵称
 * adminPhone	是	string	联系方式
 * adminIsQualityCheck	是	int	是否为质检员1质检员 0 非质检员
 * roleIdList	是	list	角色列表
 * teamsId	是	long	班组id
 */

var updateAdmin = function updateAdmin(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/admin/updateAdmin', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 员工详情接口
 * 参数名	必选	类型	说明
 * adminId	是	long	员工主键
 */

var detailAdmin = function detailAdmin(adminId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/admin/detailAdmin?adminId=' + adminId);
};

/**
 * 角色列表接口
 * 参数名	必选	类型	说明
 * pageIndex	是	int	页码
 * pageSize	是	int	每页显示条数
 * roleName	否	string	角色名称
 * roleState	是	int	角色（1、使用中；0、冻结）
 */

var listRole = function listRole(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/role/listRole', { params: data });
};

/**
 * 角色删除接口
 * 参数名	必选	类型	说明
 * roleId	是	long	角色id
 */

var deleteRole = function deleteRole(roleId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/role/deleteRole?roleId=' + roleId);
};

/**
 * 角色解冻冻结接口
 * 参数名	必选	类型	说明
 * roleId	是	long	角色id
 */

var changeRole = function changeRole(roleId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/role/changeRole?roleId=' + roleId);
};

/**
 * 角色新增接口
 * 参数名	必选	类型	说明
 * roleName	是	string	角色名称
 * roleDescription	是	string	角色描述
 * tpermissions	是	list	权限列表
 * rolePermissionList	是	list	列表
 */

var addRole = function addRole(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/role/addRole', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 角色详情接口
 * 参数名	必选	类型	说明
 * roleId	是	long	角色id
 */

var getRole = function getRole(roleId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/role/getRole?roleId=' + roleId);
};

/**
 * 角色获取权限树
 */

var getPermissions = function getPermissions() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/permission/getPermissions');
};

/**
 * 角色更新接口
 * 参数名	必选	类型	说明
 * roleName	是	string	角色名称
 * roleId	是	long	角色id
 * roleDescription	是	string	角色描述
 * tpermissions	是	list	权限列表
 * rolePermissionList	是	list	列表
 */

var updateRole = function updateRole(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/role/updateRole', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 登录接口
 * 参数名	必选	类型	说明
 * adminAccount	是	string	账号
 * password	是	string	密码
 */
var login = function login(adminAccount, password) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/admin/login', 'adminAccount=' + adminAccount + '&password=' + password);
};

/**
 * 校验是否接口
 */
var logout = function logout() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/admin/logout');
};

/**
 * 校验是否接口
 */
var checkLogin = function checkLogin() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/admin/checkLogin');
};

//质检管理
/**
 * 质检员列表接口(无分页)
 * 参数名	必选	类型	说明
 * qualityCheckPlanNumber 质检方案名搜索
 */

var searchQualityCheckPlanList = function searchQualityCheckPlanList(qualityCheckPlanNumber) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/qualityCheckPlan/searchQualityCheckPlanList', { params: { qualityCheckPlanNumber: qualityCheckPlanNumber } });
};

/**
 * 质检员列表接口
 * 参数名	必选	类型	说明
 * pageIndex	是	Integer	页码
 * pageSize	是	string	页面大小
 */

var qualityAdminList = function qualityAdminList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/qualityCheckPlan/qualityAdminList', { params: data });
};

/**
 * 删除质检员接口
 * 参数名	必选	类型	说明
 * adminId	是	Long	管理员ID
 */

var deleteAdminQuality = function deleteAdminQuality(adminId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/qualityCheckPlan/deleteAdminQuality', 'adminId=' + adminId);
};

/**
 * 质检类别列表接口
 */

var qualityCheckTypeList = function qualityCheckTypeList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/qualityCheckPlan/qualityCheckTypeList');
};

/**
 * 检验工序列表接口
 */

var procedureCategoryList = function procedureCategoryList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/procedureCategory/procedureCategoryList');
};

/**
 * 质检员权限详情
 * 参数名	必选	类型	说明
 * adminId	是	Long	管理员ID
 */

var getAdminQuality = function getAdminQuality(adminId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/qualityCheckPlan/getAdminQuality?adminId=' + adminId);
};

/**
 * 配置质检员权限接口
 * 参数名	必选	类型	说明
 * adminId	是	Long	管理员ID
 * qualityTypeList	是	list	密码
 * procedureCategoryList	否	list	昵称
 */

var updateAdminQuality = function updateAdminQuality(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/qualityCheckPlan/updateAdminQuality', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 质检任务列表(待检验)接口
 * 参数名	必选	类型	说明
 * pageIndex	是	string	页码
 * pageSize	是	string	页面
 * qualityCheckTypeId	否	Long	质检类型
 * startTime	否	date	开始时间
 * endTime	否	date	结束时间
 * cargoType	否	integer	0/全部 1/产品 2/原料
 * cargoNumber	否	String	产品/原料编号
 * qualityTaskNum	否	String	质检任务编号
 */

var qualityTaskList = function qualityTaskList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/qualityTask/qualityTaskList', { params: data });
};

/**
 * 质检任务列表(已检验)接口
 * 参数名	必选	类型	说明
 * pageIndex	是	string	页码
 * pageSize	是	string	页面
 * qualityCheckTypeId	否	Long	质检类型
 * startTime	否	date	开始时间
 * endTime	否	date	结束时间
 * cargoType	否	integer	0/全部 1/产品 2/原料
 * cargoNumber	否	String	产品/原料编号
 * qualityTaskNum	否	String	质检任务编号
 */

var qualityTaskListFinished = function qualityTaskListFinished(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/qualityTask/qualityTaskListFinished', { params: data });
};

/**
 * 质检任务详情接口
 * 参数名	必选	类型	说明
 * qualityTaskId	是	Long	质检任务ID
 */

var getQualityTask = function getQualityTask(qualityTaskId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/qualityTask/getQualityTask?qualityTaskId=' + qualityTaskId);
};

/**
 * 质检详情接口
 * 参数名	必选	类型	说明
 * qualityTaskRecordId	是	Long	质检任务ID
 */

var getQualityTaskRecord = function getQualityTaskRecord(qualityTaskRecordId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/qualityTask/getQualityTaskRecord?qualityTaskRecordId=' + qualityTaskRecordId);
};

/**
 * 把不合格的记录加入到工序不良记录中
 * 参数名	必选	类型	说明
 * qualityTaskRecordId	是	Long	质检记录ID
 */

var addToTcBadnessRecord = function addToTcBadnessRecord(qualityTaskRecordId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/qualityTask/addToTcBadnessRecord?qualityTaskRecordId=' + qualityTaskRecordId);
};

/**
 * 质检方案列表口
 * 参数名	必选	类型	说明
 * pageIndex	是	string	页码
 * pageSize	是	string	页面大小
 * qualityCheckPlanState	否	string	1/使用 2/冻结
 * qualityCheckPlanNumber	否	string	编号
 * startTime	否	string	开始时间
 * endTime	否	string	结束时间
 * adminName	否	string	制定人
 */

var qualityCheckPlanList = function qualityCheckPlanList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/qualityCheckPlan/qualityCheckPlanList', { params: data });
};

/**
 * 上线质检方案接口
 * 参数名	必选	类型	说明
 * qualityCheckPlanId	是	Long	质检方案ID
 */

var onlineQualityCheckPlan = function onlineQualityCheckPlan(qualityCheckPlanId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/qualityCheckPlan/onlineQualityCheckPlan', 'qualityCheckPlanId=' + qualityCheckPlanId);
};

/**
 * 下线质检方案接口
 * 参数名	必选	类型	说明
 * qualityCheckPlanId	是	Long	质检方案ID
 */

var offlineQualityCheckPlan = function offlineQualityCheckPlan(qualityCheckPlanId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/qualityCheckPlan/offlineQualityCheckPlan', 'qualityCheckPlanId=' + qualityCheckPlanId);
};

/**
 * 新增质检方案接口
 * 参数名	必选	类型	说明
 * qualityCheckPlanNumber	是	string	质检方案编号
 * qualityCheckPlanAdminId	是	string	制定人ID
 * pointNames	是	list	质检点列表
 */

var addQualityCheckPlan = function addQualityCheckPlan(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/qualityCheckPlan/addQualityCheckPlan', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 质检方案详情
 * 参数名	必选	类型	说明
 * 参数名	必选	类型	说明
 * qualityCheckPlanId	是	Long	用户名
 */

var getQualityCheckPlan = function getQualityCheckPlan(qualityCheckPlanId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/qualityCheckPlan/getQualityCheckPlan?qualityCheckPlanId=' + qualityCheckPlanId);
};

/**
 * 更新质检方案接口
 * 参数名	必选	类型	说明
 * qualityCheckPlanId
 * qualityCheckPlanNumber	是	string	质检方案编号
 * qualityCheckPlanAdminId	是	string	制定人ID
 * pointNames	是	list	质检点列表
 */

var updateQualityCheckPlan = function updateQualityCheckPlan(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/qualityCheckPlan/updateQualityCheckPlan', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 判断能否更新质检方案
 * 参数名	必选	类型	说明
 * qualityCheckPlanId	是	Long	质检方案ID
 */

var checkUpdateQualityCheckPlan = function checkUpdateQualityCheckPlan(qualityCheckPlanId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/qualityCheckPlan/checkUpdateQualityCheckPlan?qualityCheckPlanId=' + qualityCheckPlanId);
};

/**
 * 工序类别管理-列表
 * @param pageIndex 页码
 * @param pageSize 页面大小
 * @param pacState 类别状态(1/启用 2/下线 0/删除)
 * @returns {AxiosPromise}
 */
var listProcedureCategory = function listProcedureCategory(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/procedureCategory/listProcedureCategory', { params: data });
};

/**
 * 工序类别管理-删除
 * @param pcId 工序类别id
 * @returns {AxiosPromise}
 */
var deleteProcedureCategory = function deleteProcedureCategory(pcId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/procedureCategory/deleteProcedureCategory', 'pcId=' + pcId);
};

/**
 * 工序类别管理-上/下线状态切换
 * @param pcId 工序类别id
 * @returns {AxiosPromise}
 */
var toggleProcedureCategory = function toggleProcedureCategory(pcId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/procedureCategory/toggleProcedureCategory', 'pcId=' + pcId);
};

/**
 * 工序类别管理-新增
 * @param pcNum 工序类别编号
 * @param pcName 工序类别名称
 * @returns {AxiosPromise}
 */
var addProcedureCategory = function addProcedureCategory(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/procedureCategory/addProcedureCategory', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 工序类别管理-编辑
 * @param pcId 工序类别id
 * @param pcNum 工序类别编号
 * @param pcName 工序类别名称
 * @returns {AxiosPromise}
 */
var editProcedureCategory = function editProcedureCategory(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/procedureCategory/editProcedureCategory', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 获取详情
 * @param procedureCategoryId 工序ID
 * @returns {AxiosPromise}
 */
var getProcedureCategory = function getProcedureCategory(procedureCategoryId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/procedureCategory/getProcedureCategory?procedureCategoryId=' + procedureCategoryId);
};

/**
 * 采购需求单列
 * @param pageIndex 页码
 * @param pageSize 每页条数
 * @param planState 采购状态(1采购中2已完成3已入库)
 * @param materialsNumber 材料编号
 * @param productionTaskNum 生产需求单号
 * @param purchaseState 生产需求采购状态（1未完成2完成 ）
 * @returns {AxiosPromise}
 */
var procurementPlanList = function procurementPlanList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/procurementPlan/list', { params: data });
};

/**
 * 采购需求单详情
 * @param productiveTaskId 生产任务号
 * @returns {AxiosPromise}
 */
var procurementPlanDetail = function procurementPlanDetail(productiveTaskId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/procurementPlan/detail', { params: { productiveTaskId: productiveTaskId } });
};

/**
 * 申请价格变更接口
 * @param materialsId 材料id
 * @param materialsNewPrice 材料新价格
 * @param remark 备注
 * @returns {AxiosPromise}
 */
var changePrice = function changePrice(materialsId, materialsNewPrice, remark) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/materials/changePrice', 'materialsId=' + materialsId + '&materialsNewPrice=' + materialsNewPrice + '&remark=' + remark);
};

/**
 * 需求单信息接口
 * 参数名	必选	类型	说明
 * taskId	是	long	生产任务id
 */

var requirementsInfoByTaskId = function requirementsInfoByTaskId(taskId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/requirements/requirementsInfoByTaskId', 'taskId=' + taskId);
};

/**
 *
 *            页面量
 * @param createStartTime
 *            创建时间选择区段开始
 * @param createEndTime
 *            创建时间选择区段截止
 * @param teamsName
 *            班组名称
 * @param adminName
 *            负责人
 * @param procedureNumber
 *            工序编号
 * @param productNumber
 *            产品编号
 * @param orderNumber
 *            订单编号
 * @param missionState                                                                   ?stocktakesId=` + stocktakesId + '&state=' + state
 *            工序任务状态(1/进行中 2/已完成)
 */
var countMissionsData = function countMissionsData(createStartTime, createEndTime, teamsName, adminName, procedureNumber, productNumber, orderNumber, missionState) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/productionMissionCount/countMissionsData?pageIndex=' + '&createStartTime=' + createStartTime + '&createEndTime=' + createEndTime + '&teamsName=' + teamsName + '&adminName=' + adminName + '&procedureNumber=' + procedureNumber + '&productNumber=' + productNumber + '&orderNumber=' + orderNumber + '&missionState=' + missionState);
};

/**
 *
 * @param pageIndex
 *            页码
 * @param pageSize
 *            页面量
 * @param createStartTime
 *            创建时间选择区段开始
 * @param createEndTime
 *            创建时间选择区段截止
 * @param teamsName
 *            班组名称
 * @param adminName
 *            负责人
 * @param procedureNumber
 *            工序编号
 * @param productNumber
 *            产品编号
 * @param orderNumber
 *            订单编号
 * @param missionState                                                                   ?stocktakesId=` + stocktakesId + '&state=' + state
 *            工序任务状态(1/进行中 2/已完成)
 */
var processMissionList = function processMissionList(pageIndex, pageSize, createStartTime, createEndTime, teamsName, adminName, procedureNumber, productNumber, orderNumber, missionState) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/productionMissionCount/processMissionList?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&createStartTime=' + createStartTime + '&createEndTime=' + createEndTime + '&teamsName=' + teamsName + '&adminName=' + adminName + '&procedureNumber=' + procedureNumber + '&productNumber=' + productNumber + '&orderNumber=' + orderNumber + '&missionState=' + missionState);
};

/**
 *
 * @param productionAdminId  工序任务id
 */
var processTaskInfo = function processTaskInfo(productionAdminId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/productionMissionCount/processTaskInfo', 'productionAdminId=' + productionAdminId);
};
/**
 * 材料详情接口
 * 参数名	必选	类型	说明
 * materialsId	是	long	材料id
 */
var materialsInfo = function materialsInfo(materialsId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/materials/materialsInfo', 'materialsId=' + materialsId);
};

/**
 * 判断产品是否在生产中
 * @param productId
 * @returns
 */
var checkProduct = function checkProduct(productId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/product/checkInProduction', { params: { productId: productId } });
};

/**
 * 上传合同文件接口
 * @param file
 */
var receiveFile = function receiveFile(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/orders/receiveFile', data, { headers: { 'Content-Type': 'multipart/form-data' } });
};

/**
 * 下载合同文件接口
 * 参数名	必选	类型	说明
 * ordersContractsFileUrl	否	string	文件路径（录入订单时候传递）
 * ordersContractsName	否	string	文件名（录入订单时候传递）
 * ordersContractsId	否	long	文件id（其余情况传递）
 */
var downloadResource = function downloadResource(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/orders/downloadResource', { params: data });
};

/**
 * 删除订单文件接口
 * @param ordersContractsId   订单文件关联id
 * @returns {*|void}
 */
var deleteOrdersContracts = function deleteOrdersContracts(ordersContractsId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/orders/deleteOrdersContract', 'ordersContractsId=' + ordersContractsId);
};

/**
 * 订单文件上传
 * @param data
 * @returns {*|void}
 */
var putOrdersContact = function putOrdersContact(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/orders/putOrdersContact', data);
};

/**
 * 根据产品查找半成品列表
 * 参数名	必选	类型	说明
 * productId		是	long	产品id
 */
var productHalfList = function productHalfList(productId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/requirements/productHalfList', { params: { productId: productId } });
};

/**
 * 所有供应商
 */
var findSuppliersListNoPage = function findSuppliersListNoPage(productId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/supplier/findSuppliersListNoPage');
};

/**
 * 首页消息
 */
var getHomeMessage = function getHomeMessage(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/messagetemplate/findMessageTemplatesByAdmin', { params: data });
};

/**
* 首页入口接口
*/
var getIndexCount = function getIndexCount(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/admin/indexCount', { params: data });
};

/**
* 产品类型
*/
var getResListByType = function getResListByType(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/res/getResListByType', { params: data });
};

/**
* 不良记录列表
*/
var getTcBadRecord = function getTcBadRecord(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/tcBadRecord/findList', { params: data });
};

/**
* 上传不良记录图片或视频
* @param file
*/
var uploadBadRecord = function uploadBadRecord(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/upload2/badRecord', data, { headers: { 'Content-Type': 'multipart/form-data' } });
};
// let uploadBadRecord = (data) => axios.post(`/upload2/badRecord`, data)

var addTcBadRecord = function addTcBadRecord(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/tcBadRecord/add', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

var deleteTcBadRecord = function deleteTcBadRecord(tcBadRecordId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/tcBadRecord/delete', 'tcBadRecordId=' + tcBadRecordId);
};

var showTcBadRecord = function showTcBadRecord(tcBadRecordId, type) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/tcBadRecord/hide?tcBadRecordId=' + tcBadRecordId + '&hide=' + type, 'tcBadRecordId=' + tcBadRecordId + '&hide=' + type, { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' } });
};

/**
* 工序用时统计
*/
var getProceduresStatsList = function getProceduresStatsList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/stats/procedure/list', { params: data });
};
var getProceduresStatsDeatil = function getProceduresStatsDeatil(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/erp_back/stats/procedure/get', { params: data });
};
var addProceduresStatsList = function addProceduresStatsList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/stats/procedure/add', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};
var updateProceduresStatsList = function updateProceduresStatsList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/erp_back/stats/procedure/update', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};
var uploadProceduresStatsVideo = function uploadProceduresStatsVideo(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('http://192.168.1.118:8088/upload/video', data, { headers: { 'Content-Type': 'multipart/form-data' } });
};



/***/ }),

/***/ "irzW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'items',
  props: ['model', 'itemHeight', 'edit', 'editProcedure', 'directlyProcess'],
  data: function data() {
    return {
      totalNum: 0,
      isShow: true
    };
  },
  mounted: function mounted() {
    this.total(this.model);
  },

  computed: {},
  methods: {
    total: function total(item) {
      var _this = this;

      if (item.children && item.children.length > 0) {
        item.children.forEach(function (i) {
          _this.total(i);
        });
      } else {
        if (item.procedureType === 'process') {
          this.totalNum++;
        }
      }
    },
    changeDragStart: function changeDragStart(el) {
      this.$store.state.startHash = el.target.getAttribute('data-hash');
      if (el.target.parentElement.previousSibling) {
        this.$store.state.activePreHash = el.target.parentElement.previousSibling.firstChild.getAttribute('data-hash');
      }
      if (el.target.parentElement.nextSibling) {
        this.$store.state.activeNextHash = el.target.parentElement.nextSibling.firstChild.getAttribute('data-hash');
      }
    },
    changeDragEnd: function changeDragEnd(el) {
      this.$store.state.startHash = -1;
      this.$store.state.activeHash = -1;
      this.$store.state.activePreHash = -1;
      this.$store.state.activeNextHash = -1;
    },
    select: function select(model) {
      if (this.editProcedure) return;
      this.$store.state.selectHash = model.hash;
    },
    select2: function select2(model) {
      this.$store.state.selectHash = model.hash;
    },
    del: function del(hash) {
      var _this2 = this;

      this.$confirm('确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.$store.state.deleteHash = hash;
      });
    }
  },
  components: {},
  filters: {},
  watch: {
    model: {
      handler: function handler(val, oldval) {
        this.totalNum = 0;
        this.total(this.model);
      },
      deep: true //对象内部的属性监听，也叫深度监听
    }
  }
});

/***/ }),

/***/ "j0zN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-header flex-box"},[_c('div',{staticClass:"flex-box g-header-left"},[_c('i',{staticClass:"iconfont",class:_vm.icon}),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title || _vm.$route.name))])]),_vm._v(" "),_vm._t("rightBtn")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jEQS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7497756_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__("+J9x");
function injectStyle (ssrContext) {
  __webpack_require__("yCQp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f7497756"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7497756_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ny8D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-login",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login.apply(null, arguments)}}},[_c('div',{staticClass:"login-container flex-box"},[_c('div',{staticClass:"img-box"}),_vm._v(" "),_c('div',{staticClass:"form-box flex-box"},[_vm._m(0),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"demo-ruleForm login-box",attrs:{"model":_vm.form,"rules":_vm.rules,"label-position":"left","label-width":"0px"}},[_c('el-form-item',{attrs:{"prop":"adminAccount"}},[_c('el-input',{attrs:{"type":"text","auto-complete":"off","placeholder":"请输入您的账号","prefix-icon":"iconfont icon-iconfontwodea"},model:{value:(_vm.form.adminAccount),callback:function ($$v) {_vm.$set(_vm.form, "adminAccount", $$v)},expression:"form.adminAccount"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"password"}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off","placeholder":"请输入您的密码","prefix-icon":"iconfont icon-mima"},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"width":"100%"}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary","loading":_vm.logining},nativeOn:{"click":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[_vm._v("登录")])],1)],1)],1)]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"title flex-box"},[_c('img',{attrs:{"src":__webpack_require__("dLd/")}}),_vm._v("普力升工艺管理系统")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',[_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("浙ICP备 2022012921号-1")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pYs9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qIPy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qRls":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_craftLine_vue__ = __webpack_require__("7yzj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_726fedb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_craftLine_vue__ = __webpack_require__("THLI");
function injectStyle (ssrContext) {
  __webpack_require__("Do2q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_craftLine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_726fedb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_craftLine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qZvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticClass:"aside-cont navbar g-elmenu",staticStyle:{"width":"202px","font-size":"12px"},attrs:{"default-active":_vm.$route.path,"active-text-color":"#fff","text-color":"#fff","router":"","unique-opened":true,"collapse":_vm.isCollapse}},[_vm._l((_vm.$router.options.routes),function(item,index){return (!item.hidden&&_vm.$checkPermissions(item.permission))?[(!item.leaf)?_c('el-submenu',{attrs:{"index":index+''}},[_c('template',{slot:"title"},[_c('i',{class:'iconfont '+ item.icon+' '+((_vm.netaddress===item.children[0].path&&_vm.isCollapse)?'actived':'')}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_vm._l((item.children),function(child){return (!child.hidden&&_vm.$checkPermissions(child.permission))?_c('el-menu-item',{key:child.path,attrs:{"index":child.path},nativeOn:{"click":function($event){return _vm.shows(child.path)}}},[_vm._v("\n        "+_vm._s(child.name)+"\n      ")]):_vm._e()})],2):_vm._e(),_vm._v(" "),(item.leaf&&item.children.length>0)?_c('el-menu-item',{class:_vm.netaddress==item.children[0].path ? 'is-active':'',attrs:{"index":item.children[0].path},nativeOn:{"click":function($event){return _vm.shows(item.children[0].path)}}},[_c('span',[_vm._v(_vm._s(item.name))])]):_vm._e()]:_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tH33":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_craft_vue__ = __webpack_require__("uGBY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52701716_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_craft_vue__ = __webpack_require__("VuGh");
function injectStyle (ssrContext) {
  __webpack_require__("4bLx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_craft_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52701716_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_craft_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uGBY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flow_vue__ = __webpack_require__("NWCo");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{
        procedureType: 'flow',
        procedureName: '主流程',
        children: []
      }, {
        procedureType: 'semi',
        procedureName: '边方块',
        children: [{
          procedureType: 'process',
          procedureName: '工序',
          children: []
        }]
      }, {
        procedureType: 'process',
        procedureName: '工序',
        children: [],
        checkState: false
      }],
      itemHeight: 54,
      hasSelect: false,
      craftLineCopy: [],
      allHalfList: []
    };
  },

  props: {
    craftLine: {
      type: Array
    },
    addBefore: {
      type: Function
    },
    notEdit: {
      type: Boolean
    },
    editProcedure: {
      type: Boolean
    }
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.craftLineCopy = this.craftLine;
    this.$store.state.selectHash = this.craftLineCopy[0].hash;
  },

  components: {
    items: __WEBPACK_IMPORTED_MODULE_3__flow_vue__["a" /* default */]
  },
  methods: {
    adds: function adds(type) {
      this.addBefore(type, this.addresult);
    },
    addresult: function addresult(type) {
      var _this = this;

      this.recursion(this.craftLineCopy, this.$store.state.selectHash, function (arrs, j) {
        if (arrs[j].procedureType == 'flow') {
          var types = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, { hash: Date.now(), children: [] }, type);
          arrs[j].children.push(types);
        }
        _this.craftLineCopy = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.craftLineCopy));
      });
    },
    handleDragOver: function handleDragOver(el) {
      el.preventDefault(); //重要
      el.dataTransfer.dropEffect = 'move';
      if (el.target && el.target.className && el.target.className.indexOf('fixed') > -1) {
        return;
      }
      var activeHash = el.target.getAttribute('data-hash');
      if (activeHash != null) {
        this.$store.state.activeHash = activeHash;
        var center = el.target.getBoundingClientRect().y + el.target.getBoundingClientRect().height / 2;
        if (el.pageY > center) {
          this.$store.state.activeDirection = 'bottom';
        } else {
          this.$store.state.activeDirection = 'top';
        }
      }
    },
    handleDrag: function handleDrag() {
      var _this2 = this;

      if (this.$store.state.activeHash == -1 || this.$store.state.startHash == -1 || this.$store.state.startHash == this.$store.state.activeHash) {
        return;
      }
      if (this.$store.state.activeHash == this.$store.state.activePreHash && this.$store.state.activeDirection === 'bottom') {
        return;
      }
      if (this.$store.state.activeHash == this.$store.state.activeNextHash && this.$store.state.activeDirection === 'top') {
        return;
      }
      this.getPreStep(this.craftLineCopy, this.$store.state.startHash);
      this.recursion(this.craftLineCopy, this.$store.state.startHash, function (arrs, j) {
        arrs[j].procedureHash = '默认下步工序';
      });
      this.remove(this.craftLineCopy, this.$store.state.startHash);
      this.add(this.craftLineCopy, this.$store.state.activeHash);
      this.recursion(this.craftLineCopy, this.$store.state.selectHash, function (arrs, j) {
        if (arrs[j].procedureType == 'process') {
          _this2.$emit('get-list', arrs);
        }
      });
    },
    remove: function remove(arr, hash) {
      var _this3 = this;

      this.recursion(arr, hash, function (arrs, j) {
        _this3.$store.state.moveItem = arrs[j];
        arrs.splice(j, 1);
      });
    },
    add: function add(arr, hash) {
      var _this4 = this;

      this.recursion(arr, hash, function (arrs, j) {
        if (_this4.$store.state.activeDirection === 'top') {
          arrs.splice(j, 0, _this4.$store.state.moveItem);
        } else {
          arrs.splice(j + 1, 0, _this4.$store.state.moveItem);
        }
      });
    },
    recursion: function recursion(arrs, h, fn) {
      for (var j = 0; j < arrs.length; j++) {
        if (Number(arrs[j].hash) === Number(h)) {
          fn(arrs, j);
          return false;
        } else {
          if (arrs[j].children && arrs[j].children.length > 0) {
            this.recursion(arrs[j].children, h, fn);
          }
        }
      }
    },
    getAllHalf: function getAllHalf(arrs) {
      for (var j = 0; j < arrs.length; j++) {
        if (arrs[j].procedureType === 'semi') {
          this.allHalfList.push(arrs[j]);
        } else {
          if (arrs[j].children && arrs[j].children.length > 0) {
            this.getAllHalf(arrs[j].children);
          }
        }
      }
    },
    getPreStep: function getPreStep(arrs, hash) {
      for (var j = 0; j < arrs.length; j++) {
        if (arrs[j].procedureHash && Number(arrs[j].procedureHash) === Number(hash)) {
          arrs[j].procedureHash = '默认下步工序';
        } else {
          if (arrs[j].children && arrs[j].children.length > 0) {
            this.getPreStep(arrs[j].children, hash);
          }
        }
      }
    }
  },
  watch: {
    '$store.state.deleteHash': {
      handler: function handler(val) {
        var _this5 = this;

        this.hasSelect = false;
        this.recursion(this.craftLineCopy, val, function (arrs, j) {
          arrs.splice(j, 1);
          _this5.allHalfList = [];
          _this5.getAllHalf(_this5.craftLineCopy);
          _this5.$emit('get-half', _this5.allHalfList);
          _this5.recursion(_this5.craftLineCopy, _this5.$store.state.selectHash, function (arrs, j) {
            if (arrs[j].procedureType == 'process') {
              _this5.$emit('get-list', arrs);
            }
          });
        });
        this.recursion(this.craftLineCopy, this.$store.state.selectHash, function (arrs, j) {
          _this5.hasSelect = true;
        });
        if (!this.hasSelect) {
          this.$store.state.selectHash = this.craftLineCopy[0].hash;
        }
      }
    },
    '$store.state.selectHash': function $storeStateSelectHash(val) {
      var _this6 = this;

      this.recursion(this.craftLineCopy, val, function (arrs, j) {
        if (arrs[j].procedureType == 'process') {
          _this6.$emit('get-list', arrs);
        }
      });
    },
    'craftLineCopy': function craftLineCopy(val) {
      this.$emit('line', val);
      this.allHalfList = [];
      this.getAllHalf(this.craftLineCopy);
      this.$emit('get-half', this.allHalfList);
    }
  }
});

/***/ }),

/***/ "uaSg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export backUrl */
/* unused harmony export ssoUrl */
/* unused harmony export mainUrl */
/* unused harmony export clickUrl */
/* unused harmony export downloadUrl */
/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgCode： 图片验证码地址
 * clickUrl: 菜单点击地址
 *
 */
var backUrl = void 0;
var mainUrl = void 0;
var ssoUrl = void 0;
var clickUrl = void 0;
var downloadUrl = void 0;

if (false) {
  backUrl = 'http://test-pk-ht.hzqisheng.cn/';
  //ssoUrl = 'http://47.97.104.158:12080'//正式网
  mainUrl = 'http://192.168.0.138/';
  ssoUrl = 'http://47.98.61.135:12080/'; //测式网
  clickUrl = 'http://localhost:';
  downloadUrl = 'http://192.168.0.188:8088/park_cms/';
} else {
  backUrl = '/';
  mainUrl = 'http://test-user-center.zhihuipk.com/'; //测式网
  ssoUrl = 'http://47.98.61.135:12080/'; //测式网
  // mainUrl = 'http://main.zhihuipk.com/'//正式网
  // ssoUrl = 'http://47.97.104.158:12080/'//正式网
  clickUrl = '';
  downloadUrl = 'http://test-pk-ht.hzqisheng.cn/'; // todo 测式网
}



/***/ }),

/***/ "w/eq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"container"},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSwitch),expression:"isSwitch"}],staticClass:"aside-cont"},[_c('div',{staticClass:"logo"},[_c('div',{staticClass:"f-imgtopbox2"},[_c('transition',[_c('p',{staticClass:"title"})])],1)]),_vm._v(" "),_c('v-left-nav-bar')],1)]),_vm._v(" "),_c('el-container',[_c('el-header',{staticClass:"header flex-box"},[_c('div',{staticClass:"g-top-breadcrumb",staticStyle:{"flex":"1"}},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.$route.matched),function(item){return _c('el-breadcrumb-item',{key:item.path},[_vm._v("\n              "+_vm._s(item.name)+"\n            ")])}),1)],1),_vm._v(" "),_c('ul',{staticClass:"header-right flex-box"},[_c('li',[_c('i',{staticClass:"iconfont icon-denglu"}),_vm._v(" "),_c('el-dropdown',{attrs:{"trigger":"click"}},[_c('span',{staticClass:"el-dropdown-link"},[_vm._v("\n                "+_vm._s(_vm.adminName || '管理员')),_c('i',{staticClass:"el-icon-arrow-down el-icon--right",staticStyle:{"margin-top":"-6px"}})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('div',[_c('el-dropdown-item',{attrs:{"command":1}},[_c('b',{on:{"click":_vm.logOut}},[_vm._v("退出")])])],1)])],1)],1)])]),_vm._v(" "),_c('el-main',{staticClass:"main"},[_c('router-view')],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[(!_vm.isSwitch)?_c('div',{staticClass:"icon_switch",staticStyle:{"left":"0"},on:{"click":function($event){_vm.isSwitch=!_vm.isSwitch}}},[_c('i',{class:_vm.isSwitch?'el-icon-caret-left':'el-icon-caret-right'})]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wG2C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_left_navbar_vue__ = __webpack_require__("RSuO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f83996f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_left_navbar_vue__ = __webpack_require__("qZvQ");
function injectStyle (ssrContext) {
  __webpack_require__("qIPy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f83996f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_left_navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f83996f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_left_navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wqBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},

  props: {
    icon: {
      type: String,
      default: 'icon-fenpei'
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {},
  methods: {},
  components: {},
  watch: {}
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "yCQp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yclV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return saveState; });
/* unused harmony export setSession */
/* unused harmony export getSession */
/* unused harmony export setStore */
/* unused harmony export getStore */
/* unused harmony export removeStore */
/* unused harmony export getQueryString */
/* unused harmony export islength */
/* unused harmony export rule */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return phoneRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return phoneRule2; });
/* unused harmony export phoneRule3 */
/* unused harmony export chinese */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return number; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return number0; });
/* unused harmony export number1 */
/* unused harmony export pointNumber */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return pointNumber2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return price; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return price3; });
/* unused harmony export areaRule */
/* unused harmony export email */
/* unused harmony export bankCode */
/* unused harmony export http */
/* unused harmony export numberCode */
/* unused harmony export noChinese */
/* unused harmony export contractCode */
/* unused harmony export overscroll */
/* unused harmony export unique */
/* unused harmony export showBack */
/* unused harmony export toast */
/* unused harmony export currency */
/* unused harmony export isEmoji */
/* unused harmony export imgFile */
/* unused harmony export selectImgFile */
/* unused harmony export empty */
/* unused harmony export date */
/* unused harmony export getFilters */
/* unused harmony export selectOtherFile */
/* unused harmony export throttle */
/* unused harmony export del */
/* unused harmony export getCascaderObj */
/* unused harmony export deepClone */
/* unused harmony export getType */
/* unused harmony export deepCopy */
/* unused harmony export getState */
/* unused harmony export getChartType */
/* unused harmony export removeFile */
/* unused harmony export ridFirstAndEnd */
/* unused harmony export arrConcat */
/* unused harmony export resizeMe */
/* unused harmony export resizeMe2 */
/* unused harmony export resetForm */
/* unused harmony export getFormData */
/* unused harmony export toDatetime */
/* unused harmony export toDate */
/* unused harmony export toDateTime */
/* unused harmony export checkForm */
/* unused harmony export strParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEndtime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSpanArr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return updatePeople; });
/* unused harmony export getEndtimes */
/* unused harmony export getMorning */
/* unused harmony export getAfternoon */
/* unused harmony export checkTime */
/* unused harmony export getTimeSecond */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__story___ = __webpack_require__("Zsfk");




var _this2 = this,
    _arguments = arguments;



/**
 * 保存列表页的搜索条件及当前页
 */
var saveState = function saveState(path, filters) {
  var pars = {};
  pars.filters = filters;
  __WEBPACK_IMPORTED_MODULE_3__story___["a" /* default */].dispatch('saveListPagePars', { path: path, pars: pars });
};

/**
 * 存储localSession
 */
var setSession = function setSession(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(content);
  }
  window.sessionStorage.setItem(name, content);
};

/**
 * 获取localSession
 */
var getSession = function getSession(name) {
  if (!name) return;
  return window.sessionStorage.getItem(name);
};
/**
 * 存储localStorage
 */
var setStore = function setStore(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
var getStore = function getStore(name) {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
var removeStore = function removeStore(name) {
  if (!name) return;
  window.localStorage.removeItem(name);
};
/**
 * 获取地址栏参数
 */
var getQueryString = function getQueryString(name) {
  var pam = window.location.href.split('?')[1] || '';
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = pam.match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
};

/**
 * 补0
 */
var islength = function islength(num) {
  if (Number(num) < 10) {
    return '0' + num;
  } else {
    return num;
  }
};

/**
 * 表单校验
 */
var rule = {
  alert: function alert(mess) {
    __WEBPACK_IMPORTED_MODULE_3__story___["a" /* default */].state.alertMessage = mess;
    __WEBPACK_IMPORTED_MODULE_3__story___["a" /* default */].state.showAlert = true;
  },
  empty: function empty(str, mess) {
    //不能为空
    if (str == '') {
      this.alert(mess);
      return false;
    } else {
      return true;
    }
  },
  phone: function phone(str) {
    //手机号校验
    var myReg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
    if (!myReg.test(str)) {
      this.alert('手机号码有误');
      return false;
    } else {
      return true;
    }
  }
};

var phoneRule = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/; //11位的电话号码
var phoneRule2 = /(^(\d{3,4}-)?\d{7,8})$|((^(\d{3,4})?\d{7,8})$)|(^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$)/; //8位固话+11位的电话号码
var phoneRule3 = /(^([0-9]+(-?)[0-9]+)+)$/; //不限位数，只限制数字加-的电话号码 110等电话也可以输入
var chinese = /^[\u4E00-\u9FA5]+$/;
var number = /(^[1-9]([0-9]+)$)|(^[1-9]?$)/;
var number0 = /(^[1-9]([0-9]+)$)|(^(0){1}$)|(^[1-9]?$)/;
var number1 = /(^[1-9]([0-9]+)$)|(^[0-9]?$)/;
var pointNumber = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^[0-9]\.[0-9]([0-9])?$)/; //可小数非零数字
var pointNumber2 = /(^[1-9]([0-9]+)?(\.[0-9]{1,5})?$)|(^[0-9]\.[0-9]([0-9]{1,5})?$)/; //可小数非零数字
var price = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/; // 2位小数点
var price3 = /(^[1-9]([0-9]+)?(\.[0-9]{1,3})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9]{1,2})?$)/; // 3位小数点
var areaRule = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^[0-9]\.[0-9]([0-9])?$)/;
// export const email = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
var email = /^((([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})[; ,])*(([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})))$/;
var bankCode = /^([1-9]{1})(\d{14}|\d{18})$/;
var http = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:\/~\+#][^\u4E00-\u9FA5]*[\w\-\@?^=%&\/~\+#][^\u4E00-\u9FA5])?/;
// export const http = /[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/;
var numberCode = /^(\w)+$/;
var noChinese = /[^\u4E00-\u9FA5]+$/g;
var contractCode = /^[\w\-_]+$/;
var overscroll = function overscroll(els) {
  for (var i = 0; i < els.length; ++i) {
    var el = els[i];
    el.addEventListener('touchstart', function () {
      var top = this.scrollTop,
          totalScroll = this.scrollHeight,
          currentScroll = top + this.offsetHeight;
      if (top === 0) {
        this.scrollTop = 1;
      } else if (currentScroll === totalScroll) {
        this.scrollTop = top - 1;
      }
    });
    el.addEventListener('touchmove', function (evt) {
      if (this.offsetHeight < this.scrollHeight) evt._isScroller = true;
    });
  }
}; //禁止body的滚动事件
document.body.addEventListener('touchmove', function (evt) {
  if (!evt._isScroller) {
    evt.preventDefault();
  }
}); //给class为.scroll的元素加上自定义的滚动事件
//overscroll(document.querySelectorAll('.scroll'));


//删除数组指定的某个元素
Array.prototype.remove = function (val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};

//数组去重
var unique = function unique(arr) {
  return arr.filter(function (element, index, self) {
    return self.indexOf(element) === index;
  });
};

Date.prototype.format = function (format) {
  var o = {
    "M+": this.getMonth() + 1, //month
    "d+": this.getDate(), //day
    "h+": this.getHours(), //hour
    "m+": this.getMinutes(), //minute
    "s+": this.getSeconds(), //second
    "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
    "S": this.getMilliseconds() //millisecond
  };
  var week = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  if (/(w+)/.test(format)) {
    format = format.replace(RegExp.$1, week[this.getDay()]);
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
};

Date.prototype.add = function (part, value) {
  value *= 1;
  if (isNaN(value)) {
    value = 0;
  }
  switch (part) {
    case "y":
      this.setFullYear(this.getFullYear() + value);
      break;
    case "m":
      this.setMonth(this.getMonth() + value);
      break;
    case "d":
      this.setDate(this.getDate() + value);
      break;
    case "h":
      this.setHours(this.getHours() + value);
      break;
    case "n":
      this.setMinutes(this.getMinutes() + value);
      break;
    case "s":
      this.setSeconds(this.getSeconds() + value);
      break;
    default:

  }
  return this;
};

//alert(new Date().add("m", -1).format('yyyy-MM-dd hh:mm:ss'));

/**
 * 显示返回顶部按钮，开始、结束、运动 三个过程中调用函数判断是否达到目标点
 */
var showBack = function showBack(el, callback) {
  var requestFram = void 0;
  var oldScrollTop = void 0;

  document.addEventListener('scroll', function () {
    showBackFun();
  }, false);
  document.addEventListener('touchstart', function () {
    showBackFun();
  }, { passive: true });

  document.addEventListener('touchmove', function () {
    showBackFun();
  }, { passive: true });

  document.addEventListener('touchend', function () {
    oldScrollTop = el.getPosition().top;
    moveEnd();
  }, { passive: true });

  var moveEnd = function moveEnd() {
    requestFram = requestAnimationFrame(function () {
      if (el.getPosition().top != oldScrollTop) {
        oldScrollTop = el.getPosition().top;
        moveEnd();
      } else {
        cancelAnimationFrame(requestFram);
      }
      showBackFun();
    });
  };

  //判断是否达到目标点
  var showBackFun = function showBackFun() {
    if (el.getPosition().top > 500) {
      callback(true);
    } else {
      callback(false);
    }
  };
};

var toast = function toast() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;

  var toast = document.createElement('div');
  toast.className = 'common-toast common-toast-show';
  toast.innerHTML = msg;
  document.body.appendChild(toast);
  toast.style.display = 'block';
  toast.style.margin = '-' + toast.offsetHeight / 2 + 'px 0 0 -' + toast.offsetWidth / 2 + 'px';
  var timer = setTimeout(function () {
    toast.className = 'common-toast common-toast-hide';
    clearTimeout(timer);
    var timer2 = setTimeout(function () {
      document.body.removeChild(toast);
      clearTimeout(timer2);
    }, 200);
  }, time);
};

var digitsRE = /(\d{3})(?=\d)/g;

function currency(value, currency, decimals) {
  value = parseFloat(value);
  if (!isFinite(value) || !value && value !== 0) return '';
  currency = currency != null ? currency : '$';
  decimals = decimals != null ? decimals : 2;
  var stringified = Math.abs(value).toFixed(decimals);
  var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  var i = _int.length % 3;
  var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
  var _float = decimals ? stringified.slice(-1 - decimals) : '';
  var sign = value < 0 ? '-' : '';
  return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
}

/**
 * 检查是否为Emoji
 */
var isEmoji = function isEmoji(name) {
  if (escape(name).toLocaleLowerCase().match(/(\%\ue[0-9a-f]{3})|(\%\ud[0-9a-f]{3})/)) {
    return true;
  } else {
    return false;
  }
};

var resizeMe = function resizeMe(img, maxW, maxH, nocheck) {

  var browser = {
    versions: function () {
      var u = navigator.userAgent;
      return {
        trident: u.indexOf('Trident') > -1, //IE内核
        presto: u.indexOf('Presto') > -1, //opera内核
        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, //是否iPad
        webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
        weixin: u.toLowerCase().match(/MicroMessenger/i) == 'micromessenger', //是否微信
        qq: u.match(/\sQQ/i) == " qq" //是否QQ
      };
    }()
  };

  var canvas = document.createElement('canvas');
  var width = img.width;
  var height = img.height;
  var max_width = maxW || 640;
  var max_height = maxH || 640;
  var max_size = 300; //k
  if (width > max_width) {
    height *= max_width / width;
    height = Math.round(height);
    width = max_width;
  }
  if (height > max_height) {
    width *= max_height / height;
    width = Math.round(width);
    height = max_height;
  }
  //将图片放入canvas，并重置canvas大小
  if (browser.versions.ios || browser.versions.webApp) {
    var mpImg = new MegaPixImage(img);
    canvas.width = width;
    canvas.height = height;
    mpImg.render(canvas, { width: width, height: height });
  } else {
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, width, height);
  }
  var res,
      quality = .7,
      resSize,
      ratio = 1;

  res = canvas.toDataURL("image/jpeg", quality); // 截取canvas对应的jpg图片，并且画质为70%（默认就是70%，可以改变）

  // Android 2.x、Android 4.1.2、4.3 的 toDataURL 不支持jpeg格式；
  if (res.substr(0, "data:image/png".length) == "data:image/png" || res.substr(0, 6) == "data:,") {
    var encoder = new JPEGEncoder();
    res = encoder.encode(canvas.getContext("2d").getImageData(0, 0, width, height), quality * 100, true);
  }
  resSize = Math.ceil(res.length / 1024); //k

  if (resSize > max_size && !nocheck) {
    ratio = Math.ceil(Math.sqrt(max_size / resSize) * 100) / 100;
    if (ratio >= .9) {
      ratio -= .1;
    }

    res = resizeMe(img, max_width * ratio, max_height * ratio, true);
  }
  return res;
};

var resizeMe2 = function resizeMe2(img) {
  var canvas = document.createElement('canvas');
  var ress = resizeMe(img);
  var imgs = new Image();
  imgs.src = ress;

  var prom = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    imgs.onload = function () {
      var height = imgs.height;
      var width = imgs.width;
      var widthheight = height >= width ? width : height;
      canvas.width = widthheight;
      canvas.height = widthheight;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(imgs, (width - widthheight) / 2, (height - widthheight) / 2, widthheight, widthheight, 0, 0, widthheight, widthheight);
      var res = canvas.toDataURL("image/jpeg", 1); // 截取canvas对应的jpg图片，并且画质为70%（默认就是70%，可以改变）
      // Android 2.x、Android 4.1.2、4.3 的 toDataURL 不支持jpeg格式；
      if (res.substr(0, "data:image/png".length) == "data:image/png" || res.substr(0, 6) == "data:,") {
        var encoder = new JPEGEncoder();
        res = encoder.encode(canvas.getContext("2d").getImageData(0, 0, widthheight, widthheight), 100, true);
      }
      resolve(res);
    };
  });

  return prom;
};

/**将选中的图片转化成base64
 * @param files
 */
var imgFile = function imgFile(files) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (res, err) {
    var image = new Image();
    var _this = _this2;
    var leng = files.length;
    for (var i = 0; i < leng; i++) {
      var reader = new FileReader();
      reader.readAsDataURL(files[i]);
      reader.onload = function (e) {
        var image = new Image();
        image.src = this.result;
        image.onload = function () {
          var resized = resizeMe(image);
          if (!resized) {
            err('图片加载出错，请选择其他图片！');
            return;
          } else {
            res(resized);
          }
        };
      };
    }
  });
};

/**
 * 选择图片
 */
var selectImgFile = function selectImgFile(e, message, type) {
  var files = e.target.files || e.dataTransfer.files;
  console.log(files);
  type = type || ['image/png', 'image/jpeg', 'image/gif', 'application/pdf'];
  // list = list || 0;
  var ok = [];
  if (type instanceof Array) {
    type.forEach(function (item) {
      ok.push(files[0].type === item ? 1 : 0);
    });
  } else {
    ok.push(files[0].type === type ? 1 : 0);
  }
  if (!files.length) return;
  if (ok.indexOf(0) === -1) {
    message({
      type: 'error',
      message: '图片类型选择错误！'
    });
    return;
  }
  if (files[0].size >= 20 * 1024 * 1024) {
    message({
      type: 'error',
      message: '选择图片最大为20M'
    });
    return;
  }
  if (typeof FileReader === 'undefined') {
    //globel.toast('不支持图片上传');
    return false;
  }
  return imgFile(files);
};

var empty = function empty(val) {
  switch (val) {
    case null:
    case undefined:
    case '':
      return '-';
    default:
      return val;
  }
};
var date = function date(val) {
  switch (val) {
    case null:
    case undefined:
    case '':
      return '-';
    default:
      return new Date(val).format('yyyy-MM-dd hh:mm:ss');
  }
};

var getFilters = function getFilters(arr, val) {
  arr = arr || [];
  var message = '';
  arr.forEach(function (item) {
    if (item.value === val) {
      message = item.label;
      return;
    }
  });
  return message;
};
/**
 * 选择文件
 */
var selectOtherFile = function selectOtherFile(e, message, type) {
  var files = e.target.files || e.dataTransfer.files;
  var ok = [];
  if (type) {
    if (type instanceof Array) {
      type.forEach(function (item) {
        ok.push(files[0].type === item ? 1 : 0);
      });
    } else {
      ok.push(files[0].type === type ? 1 : 0);
    }
  } else {
    ok.push(0);
  }
  console.log(files);
  if (!files.length) return;
  if (ok.indexOf(0) === -1) {
    message({
      type: 'error',
      message: '文件类型选择错误！'
    });
    return;
  }
  if (files[0].size >= 20 * 1024 * 1024) {
    message({
      type: 'error',
      message: '选择文件最大为20M'
    });
    return;
  }
  if (typeof FileReader === 'undefined') {
    //globel.toast('不支持图片上传');
    return false;
  }
  return files;
};
var throttle = function throttle(func, delay) {
  //函数节流
  var timer = null;
  var startTime = Date.now();
  return function () {
    var curTime = Date.now();
    var remaining = delay - (curTime - startTime);
    var context = _this2;
    var args = _arguments;
    clearTimeout(timer);
    if (remaining <= 0) {
      func.apply(context, args);
      startTime = Date.now();
    } else {
      timer = setTimeout(func, remaining);
    }
  };
};
var del = function del(arr, index, type) {
  arr.splice(index, 1);
  if (type) {
    var file = document.getElementById(type);
    file.value = ''; //虽然file的value不能设为有字符的值，但是可以设置为空值
  }
};
/**
 *获取级联选择器的选项
 * @param val
 * @param opt
 * @param config
 * @returns {*}
 */
var getCascaderObj = function getCascaderObj(val, opt, config) {
  var value = config || 'value';
  return val.map(function (value, index, array) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(opt), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var itm = _step.value;

        if (itm[value] == val) {
          opt = itm.children;
          return itm;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return null;
  });
};
/**
 *获取选择器的选项
 * @param val
 * @param opt
 * @returns {string}
 */
var deepClone = function deepClone(val, opt) {
  var arr = '',
      item;
  if (val.constructor == Array) {
    val.map(function (value, index, array) {
      item = opt.filter(function (item) {
        return item.value === value;
      })[0];
      return item ? arr = item : '';
    });
  } else {
    item = opt.filter(function (item) {
      return item.value === val;
    })[0];
    return item ? arr = item : '';
  }
  return arr;
};
var getType = function getType(obj) {
  //tostring会返回对应不同的标签的构造函数
  var toString = Object.prototype.toString;
  var map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  };
  if (obj instanceof Element) {
    return 'element';
  }
  return map[toString.call(obj)];
};
var deepCopy = function deepCopy(o) {
  if (o instanceof Array) {
    var n = [];
    for (var i = 0; i < o.length; ++i) {
      n[i] = deepCopy(o[i]);
    }
    return n;
  } else if (o instanceof Function) {
    var n = new Function("return " + o.toString())();
    return n;
  } else if (o instanceof Object) {
    var n = {};
    for (var i in o) {
      n[i] = deepCopy(o[i]);
    }
    return n;
  } else {
    return o;
  }
};
var getState = function getState(val) {
  switch (val) {
    case 0:
      return '待招商';
    case 1:
      return '已招商';
    case 2:
      return '已锁定';

  }
};

var getChartType = function getChartType(val) {
  switch (val) {
    case 0:
      return '商务';
    case 1:
      return '办公';
    case 2:
      return '工位';
  }
};

/**
 *重置文件选择
 * @param id
 */
var removeFile = function removeFile(id) {
  var fileObj = document.getElementById(id);
  if (fileObj) {
    fileObj.value = '';
  }
};

var ridFirstAndEnd = function ridFirstAndEnd(arr) {
  var str = '';
  arr.forEach(function (item, index) {
    if (index == 0) {
      str += item;
    } else {
      str += ',' + item;
    }
  });
  return str;
};
/**
 * 拼接两个数组
 * @param arr1
 * @param arr2
 * @returns {*}
 */
var arrConcat = function arrConcat(arr1, arr2) {
  if (!arr2 || getType(arr2) != 'array') {
    return [3];
  }
  if (!arr1 || getType(arr1) != 'array') {
    arr2.push(3);
    return arr2;
  }
  arr1.forEach(function (item) {
    arr2.push(item);
  });
  return arr2;
};



/**
 * elementUI 表单重置方法
 * @param obj
 * @param type
 */
var resetForm = function resetForm(obj, type) {
  if (obj) {
    if (type == 2) {
      obj.map(function (item, index) {
        item.resetFields();
      });
    } else {
      obj.resetFields();
    }
  }
};

/**
 * 获取表单数据
 * @param o
 * @param j
 * @returns {FormData}
 */
var getFormData = function getFormData(o, j) {
  var formData = new FormData();

  var _loop = function _loop(i) {
    if (o[i] !== null && o[i] !== undefined) {
      if (getType(o[i]) === 'array') {
        // formData.append(i, o[i]);
        o[i].forEach(function (item) {
          formData.append(i, item);
        });
      } else {
        formData.append(i, o[i]);
      }
    } else {
      formData.append(i, '');
    }
  };

  for (var i in o) {
    _loop(i);
  }
  return formData;
};

var toDatetime = function toDatetime(time) {
  return time ? new Date(time).format('yyyy-MM-dd 00:00:00') : '';
};
var toDate = function toDate(time) {
  return time ? new Date(time).format('yyyy-MM-dd') : '';
};

var toDateTime = function toDateTime(time) {
  return time ? new Date(time).format('yyyy-MM-dd hh:mm:ss') : '';
};

/**
 * elementUI 验证表单方法
 * @param obj
 * @param type
 * @returns {*}
 */
var checkForm = function checkForm(obj, type) {
  var ok = void 0;
  if (obj) {
    if (type === 2) {
      ok = [];
      obj.map(function (item, index) {
        item.validate(function (valid) {
          if (valid) {
            ok.push(1);
          } else {
            ok.push(2);
          }
        });
      });
    } else {
      obj.validate(function (valid) {
        if (valid) {
          ok = 1;
        } else {
          ok = 2;
        }
      });
    }
  } else {
    ok = 3;
  }
  return ok;
};

/**
 *用JSON.parse()转译字符串的判断
 * @param str
 * @returns {*}
 */
var strParse = function strParse(str) {
  switch (str) {
    case undefined:
    case 'undefined':
      return undefined;
    case null:
    case 'null':
      return null;
    case '':
      return '';
    default:
      try {
        return str ? JSON.parse(str) : '';
      } catch (err) {
        return '';
      }
  }
};

/**
 * 获得时间间隔
 */
var getTime = function getTime(stTime, edTime) {
  /* console.log(new Date(stTime), 1)*/
  var stTimeMillisecond = new Date(stTime).getTime();
  var edTimeMillisecond = new Date(edTime).getTime();
  //对不规则的开始时间进行整理
  /* if (getTimeSecond(stTime,2) <= stTimeMillisecond && getTimeSecond(stTime,3) >= stTimeMillisecond) {
     stTime = getTimeSecond(stTime,3);
   }
   if (getTimeSecond(stTime,1) >= stTimeMillisecond) {
     stTime = getTimeSecond(stTime,1);
   }
   if (getTimeSecond(stTime,4) <= stTimeMillisecond) {
     stTime = getTimeSecond(stTime,5);
   }
   console.log(new Date(stTime), 2)
   //对不规则的结束时间进行整理
   if (getTimeSecond(edTime,2) <= edTimeMillisecond && getTimeSecond(edTime,3) >= edTimeMillisecond) {
     edTime = getTimeSecond(edTime,2);
   }
   if (getTimeSecond(edTime,1) >= edTimeMillisecond) {
     edTime = getTimeSecond(edTime,9);
   }
   if (getTimeSecond(edTime,4) <= edTimeMillisecond) {
     edTime = getTimeSecond(edTime,4);
   }
  */

  var startTime = new Date(stTime);
  var endTime = new Date(edTime);
  var oneDayTime = 8 * 60 * 60 * 1000;
  var dayEnd = 16 * 3600000 + 30 * 60000;
  var reduceTime = 0; //应减去的时间
  if (startTime.getHours() >= 8) {
    //开始时间大于8点
    if (startTime.getHours() < 12) {
      reduceTime += (startTime.getHours() - 8) * 3600000 + startTime.getMinutes() * 60000;
    } else if (startTime.getHours() === 12 && startTime.getMinutes() < 30) {
      //开始时间在12:00 - 12:30
      reduceTime += 4 * 3600000;
    } else if (startTime.getHours() === 16 && startTime.getMinutes() >= 30 || startTime.getHours() > 16) {
      reduceTime += 8 * 3600000;
    } else {
      reduceTime += 4 * 3600000 + startTime.getHours() * 3600000 + startTime.getMinutes() * 60000 - 12 * 3600000 - 30 * 60000;
    }
  }
  if (endTime.getHours() * 3600000 + endTime.getMinutes() * 60000 - dayEnd < 0) {
    reduceTime += dayEnd - endTime.getHours() * 3600000 - endTime.getMinutes() * 60000;
    if (endTime.getHours() === 12 && endTime.getMinutes() < 30) {
      //结束时间在12:00 - 12:30
      reduceTime -= 12 * 3600000 + 30 * 60000 - endTime.getHours() * 3600000 - endTime.getMinutes() * 60000;
    } else if (endTime.getHours() < 12) {
      reduceTime -= 30 * 60000;
      if (endTime.getHours() < 8) {
        reduceTime -= 8 * 3600000;
      }
    }
  }
  var allDay = (new Date(endTime.getFullYear() + '-' + (endTime.getMonth() + 1) + '-' + endTime.getDate() + ' 24:00:00') - new Date(startTime.getFullYear() + '-' + (startTime.getMonth() + 1) + '-' + startTime.getDate() + ' 00:00:00')) / (24 * 3600000); //相差总天数
  return oneDayTime * allDay - reduceTime;
};

/**
 * 获得结束时间
 * yyp
 */
var getEndtime = function getEndtime(startTime, time) {
  var start = new Date(startTime);
  var day = Math.floor(time / (8 * 3600)); //经过多少天
  var remainingTime = time % (8 * 3600); //减去天数后剩余多少秒
  var endTime = start.setDate(start.getDate() + day); //开始时间加上经过多少天
  if (new Date(endTime).getHours() < 8) {
    //小于八点
    endTime = new Date(endTime).setHours(8, 0, 0, 0);
  } else if (new Date(endTime).getHours() === 16 && new Date(endTime).getMinutes() >= 30 || new Date(endTime).getHours() > 16) {
    //大于16:30
    endTime = new Date(endTime).add('d', 1);
    endTime = new Date(endTime).setHours(8, 0, 0, 0);
  } else if (new Date(endTime).getHours() === 12 && new Date(endTime).getMinutes() <= 30) {
    endTime = new Date(endTime).setHours(12, 30, 0, 0);
    endTime -= 30 * 60000;
  }
  endTime += remainingTime * 1000;
  if (new Date(endTime).getHours() === 12 && new Date(endTime).getMinutes() >= 30 || new Date(endTime).getHours() >= 13) {
    if (start.getHours() <= 12) {
      endTime += 30 * 60000;
    }
  }
  if (new Date(endTime).getHours() === 16 && new Date(endTime).getMinutes() >= 30 || new Date(endTime).getHours() > 16) {
    var hour = new Date(endTime).getHours();
    var minute = new Date(endTime).getMinutes();
    endTime = new Date(endTime).setDate(new Date(endTime).getDate() + 1);
    endTime = new Date(endTime).setHours(8, 0, 0, 0);
    endTime += (hour - 16) * 3600000;
    endTime += (minute - 30) * 60000;
  }
  if (new Date(endTime).getHours() < 8) {
    endTime = new Date(endTime).setDate(new Date(endTime).getDate() - 1);
    endTime = new Date(endTime).setHours(16, 30, 0, 0);
  }
  return new Date(endTime).format('yyyy-MM-dd hh:mm:ss');
};

/**
 * 判断当前元素与上一个元素是否相同
 *
 */
var getSpanArr = function getSpanArr(data, val) {
  var spanArr = [];
  var pos = 0;
  for (var i = 0; i < data.length; i++) {
    if (i === 0) {
      spanArr.push(1);
      pos = 0;
    } else {
      // 判断当前元素与上一个元素是否相同
      if (data[i][val] === data[i - 1][val]) {
        spanArr[pos] += 1;
        spanArr.push(0);
      } else {
        spanArr.push(1);
        pos = i;
      }
    }
  }
  return spanArr;
};

/**
 * 把第startIndex位置的放到endIndex位置
 *
 */
var updatePeople = function updatePeople(arr, start, end, position) {
  start = Number(start);
  end = Number(end);
  var a = void 0;
  if (start < end) {
    if (position == 'left') {
      a = end - 1;
    } else {
      a = end + 1;
    }
  } else {
    if (position == 'left') {
      a = end;
    } else {
      a = end + 1;
    }
  }
  var startIndex = start;
  var endIndex = a;
  if (start > end) {
    /*往左*/
    var temp = startIndex;
    startIndex = endIndex;
    endIndex = temp;
    var frontArr = arr.slice(0, startIndex);
    var secondArr = arr.slice(startIndex, endIndex);
    var endArr = arr.slice(endIndex + 1);
    var moveItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(arr[endIndex]));
    var endItem = position == 'left' ? JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(arr[startIndex])) : JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(arr[startIndex - 1]));
    var array = [];
    moveItem.startTime = position == 'left' ? endItem.startTime : endItem.endTime;
    moveItem.endTime = getEndtime(moveItem.startTime, moveItem.duration / 1000);
    array.push(moveItem);
    var allArr = secondArr.concat(endArr);
    allArr.forEach(function (item, index) {
      item.startTime = array[array.length - 1].endTime;
      item.endTime = getEndtime(item.startTime, item.duration / 1000);
      array.push(item);
    });
    var jsonData = {
      newArr: frontArr.concat(array),
      startTime: moveItem.startTime,
      endTime: moveItem.endTime
    };
    return jsonData;
  } else {
    /*往右*/
    /*start,end*/
    var _frontArr = arr.slice(0, start);
    var _secondArr = position == 'left' ? arr.slice(start + 1, end) : arr.slice(start + 1, end + 1);
    var _endArr = position == 'left' ? arr.slice(end) : arr.slice(end + 1);
    var _moveItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(arr[start]));
    var _endItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(arr[end]));
    var _array = [];
    _moveItem.startTime = position == 'left' ? _endItem.startTime : _endItem.endTime;
    _moveItem.endTime = getEndtime(_moveItem.startTime, _moveItem.duration / 1000);
    _array.push(_moveItem);
    _endArr.forEach(function (item, index) {
      item.startTime = _array[_array.length - 1].endTime;
      item.endTime = getEndtime(item.startTime, item.duration / 1000);
      _array.push(item);
    });
    var _jsonData = {
      newArr: _frontArr.concat(_secondArr).concat(_array),
      startTime: _moveItem.startTime,
      endTime: _moveItem.endTime
    };
    return _jsonData;
  }
};

/**
 * 获得结束时间
 */

var getEndtimes = function getEndtimes(startTime, durtion) {
  var stime = startTime;
  if (new Date(startTime).getTime() === getTimeSecond(startTime, 2)) {
    stime = getTimeSecond(startTime, 3);
  }
  if (new Date(startTime).getTime() === getTimeSecond(startTime, 4)) {
    stime = getTimeSecond(startTime, 5);
  }
  var start = new Date(stime).getTime(); /*起始毫秒数*/
  var secondDuration = durtion * 60 * 1000; /*时长的毫秒数*/
  var secondFour = 4 * 60 * 60 * 1000; /*4个小时的毫秒数*/
  var numFour = Math.floor(secondDuration / secondFour); /*有多少的（4个小时的毫秒数）*/
  var secondResidue = secondDuration % secondFour; /*取余数（4个小时的毫秒数） */
  var type = void 0;
  if (start >= getTimeSecond(start, 1) && start <= getTimeSecond(start, 2)) {
    /*上午*/
    type = 1;
  } else {
    /*下午*/
    type = 2;
  }
  if (numFour > 0) {
    /*大于4个小时*/
    var x1 = Math.floor(numFour / 2); //取整数
    var x2 = numFour % 2; //取余数
    var stTime = void 0;
    var a = void 0;
    if (type === 1) {
      /*上午*/
      if (x2 === 1) {
        a = new Date(start).add('d', x1).getTime();
        stTime = getTimeSecond(a, 3) + start - getTimeSecond(start, 1);
        return getAfternoon(stTime, secondResidue);
      } else {
        stTime = new Date(start).add('d', x1).getTime();
        return getMorning(stTime, secondResidue);
      }
    } else {
      /*下午*/
      if (x2 === 1) {
        a = new Date(start).add('d', x1).getTime();
        stTime = getTimeSecond(a, 5) + start - getTimeSecond(start, 3);
        return getMorning(stTime, secondResidue);
      } else {
        stTime = new Date(start).add('d', x1).getTime();
        return getAfternoon(stTime, secondResidue);
      }
    }
  } else {
    if (type === 1) {
      /*上午*/
      return getMorning(start, secondResidue);
    } else {
      /*下午*/
      return getAfternoon(start, secondResidue);
    }
  }
};
var getMorning = function getMorning(start, secondResidue) {
  var time = void 0;
  if (start + secondResidue > getTimeSecond(start, 2)) {
    time = getTimeSecond(start, 3) + (secondResidue - (getTimeSecond(start, 2) - start));
    // console.log(checkTime(time),'上午大于4小时 numFour = 0')
    return checkTime(time);
  } else {
    time = start + secondResidue;
    //console.log(checkTime(time),'上午不足4小时 numFour = 0')
    return checkTime(time);
  }
};
var getAfternoon = function getAfternoon(start, secondResidue) {
  var time = void 0;
  if (start + secondResidue > getTimeSecond(start, 4)) {
    time = getTimeSecond(start, 5) + (secondResidue - (getTimeSecond(start, 4) - start));
    //console.log(checkTime(time),'下午大于4小时 numFour = 0')
    return checkTime(time);
  } else {
    time = start + secondResidue;
    //console.log(checkTime(time),'下午不足4小时 numFour = 0')
    return checkTime(time);
  }
};
var checkTime = function checkTime(time) {
  var a = new Date(time).format('yyyy.MM.dd');
  if (new Date(time).getTime() === getTimeSecond(time, 1)) {
    return new Date(getTimeSecond(new Date(a).add('d', '-1').getTime(), 4)).format('yyyy.MM.dd hh:mm:ss');
  } else if (new Date(time).getTime() === getTimeSecond(time, 3)) {
    return new Date(getTimeSecond(time, 2)).format('yyyy.MM.dd hh:mm:ss');
  } else {
    return new Date(time).format('yyyy.MM.dd hh:mm:ss');
  }
};
var getTimeSecond = function getTimeSecond(time, type) {
  var temp = new Date(time).format('yyyy.MM.dd');
  var nextTemp = new Date(time).add('d', 1).format('yyyy.MM.dd');
  var beforeTemp = new Date(time).add('d', -1).format('yyyy.MM.dd');
  switch (type) {
    case 1:
      return new Date(temp + ' 08:00:00').getTime();
    case 2:
      return new Date(temp + ' 12:00:00').getTime();
    case 3:
      return new Date(temp + ' 12:30:00').getTime();
    case 4:
      return new Date(temp + ' 16:30:00').getTime();
    case 5:
      return new Date(nextTemp + ' 08:00:00').getTime();
    case 6:
      return new Date(nextTemp + ' 12:00:00').getTime();
    case 7:
      return new Date(nextTemp + ' 12:30:00').getTime();
    case 8:
      return new Date(nextTemp + ' 16:30:00').getTime();
    case 9:
      return new Date(beforeTemp + ' 16:30:00').getTime();
  }
};

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.802fd62aafbf66d27972.js